import { Injectable, Inject, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { GlobalDataOpsService, GlobalDomOpsService, AcepSSOService, CommonOperationsService, AcepGlobalModule } from '@acepteam/globalspack';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Subject, fromEvent } from 'rxjs';
import { map, share, first } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { __awaiter } from 'tslib';

//export interface CreditCard {
//    name: any,
//    zip: any,
//    month: any,
//    year: any,
//    cvv: any,
//    type: any,
//    number: any
//}
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@acepteam/globalspack';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/forms';

const _c0 = ["managecreditcards"];
const _c1 = ["manageecp"];
const _c2 = ["nettermsaddress"];
const _c3 = ["shippingaddress"];
const _c4 = ["terms"];
function PaymentComponent_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 106);
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵtext(2, "(Auto Renew - ON)");
    ɵngcc0.ɵɵelementEnd();
} }
function PaymentComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, PaymentComponent_div_6_span_4_Template, 3, 0, "span", 105);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵelementStart(6, "p", 10);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "currency");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const li_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", li_r19.ProductName, "", li_r19.Quantity > 1 ? " (" + li_r19.Quantity + ")" : "", " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", li_r19.ProductAutoRenew);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(8, 4, li_r19.UnitPrice * li_r19.Quantity, "USD", "symbol-narrow", "1.2-2"));
} }
function PaymentComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3, "Group Portal");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "p", 10);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "currency");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(7, 1, ctx_r1.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS, "USD", "symbol-narrow", "1.2-2"));
} }
function PaymentComponent_div_156_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3, " Please contact ");
    ɵngcc0.ɵɵelementStart(4, "a", 107);
    ɵngcc0.ɵɵtext(5, "Member and Customer Care");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " for assistance. ");
    ɵngcc0.ɵɵelementEnd();
} }
function PaymentComponent_a_172_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 108);
    ɵngcc0.ɵɵlistener("click", function PaymentComponent_a_172_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.ApplyPromoCode(); });
    ɵngcc0.ɵɵtext(1, "Apply Code");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("disabled", ctx_r6.od.PromoCode == "" ? true : null);
} }
function PaymentComponent_div_178_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 109);
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r7.pconfig.ACH_DESCRIPTION, ɵngcc0.ɵɵsanitizeHtml);
} }
function PaymentComponent_div_206_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵtext(2, " American College of Emergency Physicians ");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4, " P.O. Box 619911 ");
    ɵngcc0.ɵɵelement(5, "br");
    ɵngcc0.ɵɵtext(6, " Dallas TX 75261-9911 ");
    ɵngcc0.ɵɵelementEnd();
} }
function PaymentComponent_ng_template_207_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "br");
    ɵngcc0.ɵɵtext(1, " American College of Emergency Physicians MISC ACEP ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3, " P.O. Box 222291 ");
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵtext(5, " Dallas TX 75222-2291 ");
} }
function PaymentComponent_i_222_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r13.checkText);
} }
function PaymentComponent_label_273_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 110);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "a", 111);
    ɵngcc0.ɵɵlistener("click", function PaymentComponent_label_273_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.showterms(); });
    ɵngcc0.ɵɵtext(3, "terms & conditions");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("I agree to ", ctx_r17.pconfig.TERMSANDCONDITIONS_CHECKBOXTEXT, " ");
} }
function PaymentComponent_label_274_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 110);
    ɵngcc0.ɵɵtext(1, "I have read the disclaimer and agree to the terms and conditions");
    ɵngcc0.ɵɵelementEnd();
} }
const _c5 = [[["", 8, "payment-autorenewal-details"]], [["", 8, "payment-check-details"]]];
const _c6 = [".payment-autorenewal-details", ".payment-check-details"];
function ManageCreditCardsComponent_div_10_option_95_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 77);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const year_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", year_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(year_r8);
} }
function ManageCreditCardsComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵelementStart(2, "div", 14);
    ɵngcc0.ɵɵelementStart(3, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r10); const el_r2 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectPaymentDetails(el_r2.ProfileId); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "label", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 1);
    ɵngcc0.ɵɵelementStart(6, "span", 17);
    ɵngcc0.ɵɵelement(7, "span");
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "span", 17);
    ɵngcc0.ɵɵelement(10, "span", 18);
    ɵngcc0.ɵɵtext(11, "New Card ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 19);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 20);
    ɵngcc0.ɵɵelementStart(16, "a", 21);
    ɵngcc0.ɵɵlistener("click", function ManageCreditCardsComponent_div_10_Template_a_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r10); const el_r2 = ctx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.editPayType(el_r2.ProfileId); });
    ɵngcc0.ɵɵtext(17, "Edit");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 22);
    ɵngcc0.ɵɵelementStart(19, "a", 21);
    ɵngcc0.ɵɵlistener("click", function ManageCreditCardsComponent_div_10_Template_a_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r10); const el_r2 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.deletePayTypeConfirm(el_r2.ProfileId); });
    ɵngcc0.ɵɵtext(20, "Delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 23);
    ɵngcc0.ɵɵelementStart(22, "div", 24);
    ɵngcc0.ɵɵelementStart(23, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.selectedpaytype.CardHolderType = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "label", 26);
    ɵngcc0.ɵɵtext(25, "Personal Card");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_26_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.selectedpaytype.CardHolderType = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "label", 28);
    ɵngcc0.ɵɵtext(28, "Corporate Card");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 12);
    ɵngcc0.ɵɵelementStart(30, "div", 29);
    ɵngcc0.ɵɵelement(31, "div", 30);
    ɵngcc0.ɵɵelement(32, "div", 31);
    ɵngcc0.ɵɵelement(33, "div", 32);
    ɵngcc0.ɵɵelement(34, "div", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(35, "div", 34);
    ɵngcc0.ɵɵelementStart(36, "div", 35);
    ɵngcc0.ɵɵelementStart(37, "div", 36);
    ɵngcc0.ɵɵelementStart(38, "div", 37);
    ɵngcc0.ɵɵelementStart(39, "label", 38);
    ɵngcc0.ɵɵtext(40, "Card Number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(41, "input", 39);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_41_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.selectedpaytype.CreditCardNumber = $event; })("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_41_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.cardnumberchange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "span", 40);
    ɵngcc0.ɵɵtext(43, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(44, "div", 41);
    ɵngcc0.ɵɵelementStart(45, "div", 36);
    ɵngcc0.ɵɵelementStart(46, "div", 37);
    ɵngcc0.ɵɵelementStart(47, "label", 42);
    ɵngcc0.ɵɵtext(48, "Name on Card");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(49, "input", 43);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_49_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.selectedpaytype.NameOnCard = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(50, "span", 40);
    ɵngcc0.ɵɵtext(51, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(52, "div", 12);
    ɵngcc0.ɵɵelementStart(53, "div", 35);
    ɵngcc0.ɵɵelementStart(54, "div", 36);
    ɵngcc0.ɵɵelementStart(55, "div", 37);
    ɵngcc0.ɵɵelementStart(56, "label", 44);
    ɵngcc0.ɵɵtext(57, "Expiration Month");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(58, "select", 45, 46);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_select_ngModelChange_58_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.MM = $event; })("change", function ManageCreditCardsComponent_div_10_Template_select_change_58_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r5 = ɵngcc0.ɵɵreference(93); const _r4 = ɵngcc0.ɵɵreference(59); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.updatecardexpdate(_r5.value, _r4.value, ""); });
    ɵngcc0.ɵɵelement(60, "option");
    ɵngcc0.ɵɵelementStart(61, "option", 47);
    ɵngcc0.ɵɵtext(62, "01 - Jan");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(63, "option", 48);
    ɵngcc0.ɵɵtext(64, "02 - Feb");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(65, "option", 49);
    ɵngcc0.ɵɵtext(66, "03 - Mar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(67, "option", 50);
    ɵngcc0.ɵɵtext(68, "04 - Apr");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(69, "option", 51);
    ɵngcc0.ɵɵtext(70, "05 - May");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(71, "option", 52);
    ɵngcc0.ɵɵtext(72, "06 - Jun");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(73, "option", 53);
    ɵngcc0.ɵɵtext(74, "07 - Jul");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(75, "option", 54);
    ɵngcc0.ɵɵtext(76, "08 - Aug");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(77, "option", 55);
    ɵngcc0.ɵɵtext(78, "09 - Sep");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(79, "option", 56);
    ɵngcc0.ɵɵtext(80, "10 - Oct");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(81, "option", 57);
    ɵngcc0.ɵɵtext(82, "11 - Nov");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(83, "option", 58);
    ɵngcc0.ɵɵtext(84, "12 - Dec");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(85, "span", 40);
    ɵngcc0.ɵɵtext(86, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(87, "div", 41);
    ɵngcc0.ɵɵelementStart(88, "div", 36);
    ɵngcc0.ɵɵelementStart(89, "div", 37);
    ɵngcc0.ɵɵelementStart(90, "label", 59);
    ɵngcc0.ɵɵtext(91, "Expiration Year");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(92, "select", 60, 61);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_select_ngModelChange_92_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.YYYY = $event; })("change", function ManageCreditCardsComponent_div_10_Template_select_change_92_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r5 = ɵngcc0.ɵɵreference(93); const _r4 = ɵngcc0.ɵɵreference(59); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.updatecardexpdate(_r5.value, _r4.value, ""); });
    ɵngcc0.ɵɵelement(94, "option");
    ɵngcc0.ɵɵtemplate(95, ManageCreditCardsComponent_div_10_option_95_Template, 2, 2, "option", 62);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(96, "span", 40);
    ɵngcc0.ɵɵtext(97, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(98, "div", 12);
    ɵngcc0.ɵɵelementStart(99, "div", 35);
    ɵngcc0.ɵɵelementStart(100, "div", 36);
    ɵngcc0.ɵɵelementStart(101, "div", 37);
    ɵngcc0.ɵɵelementStart(102, "label", 63);
    ɵngcc0.ɵɵtext(103, "Billing Zip Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(104, "input", 64);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_104_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.selectedpaytype.PostalCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(105, "span", 40);
    ɵngcc0.ɵɵtext(106, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(107, "div", 65);
    ɵngcc0.ɵɵelementStart(108, "div", 36);
    ɵngcc0.ɵɵelementStart(109, "div", 37);
    ɵngcc0.ɵɵelementStart(110, "label", 66);
    ɵngcc0.ɵɵtext(111, "CVV/CID");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(112, "input", 67);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageCreditCardsComponent_div_10_Template_input_ngModelChange_112_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.selectedpaytype.CVV = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(113, "span", 40);
    ɵngcc0.ɵɵtext(114, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(115, "div", 68);
    ɵngcc0.ɵɵelementStart(116, "input", 69, 70);
    ɵngcc0.ɵɵlistener("change", function ManageCreditCardsComponent_div_10_Template_input_change_116_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r7 = ɵngcc0.ɵɵreference(117); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.selectedpaytype.SaveCC = _r7.checked; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(118, "label", 71);
    ɵngcc0.ɵɵtext(119, "Save this card for future use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(120, "div", 72);
    ɵngcc0.ɵɵelementStart(121, "div", 73);
    ɵngcc0.ɵɵelementStart(122, "input", 74);
    ɵngcc0.ɵɵlistener("click", function ManageCreditCardsComponent_div_10_Template_input_click_122_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.cancelEditPay(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(123, "div", 75);
    ɵngcc0.ɵɵelementStart(124, "input", 76);
    ɵngcc0.ɵɵlistener("click", function ManageCreditCardsComponent_div_10_Template_input_click_124_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.savePayType(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.savedpaymenttypes.length == 1 && ctx_r0.selectedpaytype.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.isOnShoppingCart);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("value", el_r2.ProfileId);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "Profile-", i_r3, "");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.ProfileId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("for", "Profile-", i_r3, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("sprites image-", ctx_r0.CardType[el_r2.CardType], "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("x", el_r2.CreditCardNumber.length > 4 ? el_r2.CreditCardNumber.substring(0, 4) : el_r2.CreditCardNumber, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId != "" || !ctx_r0.isOnShoppingCart);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Exp: ", el_r2.CCExpirationDate ? ɵngcc0.ɵɵpipeBind2(14, 38, el_r2.CCExpirationDate, "MM/yyyy") : "", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", i_r3 + 1 == ctx_r0.savedpaymenttypes.length ? "ccAddNewCard" : "notnewcard")("hidden", !(ctx_r0.selectedpaytype.ProfileId == el_r2.ProfileId && ctx_r0.editpay));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId != "" || ctx_r0.SHOWCARDHOLDERTYPE != true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("value", ctx_r0.CardHolderType.Personal);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.CardHolderType);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("value", ctx_r0.CardHolderType.Business);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.CardHolderType);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId != "");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.CreditCardNumber);
    ɵngcc0.ɵɵattribute("data-validate", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.NameOnCard);
    ɵngcc0.ɵɵattribute("data-validate", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.MM);
    ɵngcc0.ɵɵadvance(34);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.YYYY);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.yearRange);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.PostalCode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", !(el_r2.ProfileId == ""));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.CVV);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", !(el_r2.ProfileId == "" && ctx_r0.SHOWSAVECC == true && !ctx_r0.allowAddMultipleCards && ctx_r0.isOnShoppingCart));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disableSaveCC)("checked", ctx_r0.selectedpaytype.SaveCC == true);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("hidden", !(el_r2.ProfileId != "" || ctx_r0.allowAddMultipleCards));
} }
function ManageCreditCardsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 78);
    ɵngcc0.ɵɵtext(1, " No Payment Methods Found ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementEnd();
} }
function ManageBillingOptionsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1, " Auto Renewal ");
    ɵngcc0.ɵɵelementEnd();
} }
function ManageBillingOptionsComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1, " Payment Method ");
    ɵngcc0.ɵɵelementEnd();
} }
function ManageBillingOptionsComponent_div_13_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", el_r3.IsOnAutoRenewal ? "Yes" : "No", " ");
} }
function ManageBillingOptionsComponent_div_13_div_9_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const pt_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵattributeInterpolate1("data-image", "assets/resources/images/logos/", ctx_r9.CardType[pt_r10.CardType] + "", ".png");
    ɵngcc0.ɵɵproperty("value", pt_r10.PaymentMethodId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r9.CardType[pt_r10.CardType] + "", "-x", pt_r10.CreditCardNumber, "");
} }
function ManageBillingOptionsComponent_div_13_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "select", 11, 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageBillingOptionsComponent_div_13_div_9_Template_select_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const el_r3 = ɵngcc0.ɵɵnextContext().$implicit; return el_r3.PaymentMethodId = $event; });
    ɵngcc0.ɵɵtemplate(3, ManageBillingOptionsComponent_div_13_div_9_option_3_Template, 2, 4, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("name", "paymentMethodId_", el_r3.BillingOptionId, "");
    ɵngcc0.ɵɵproperty("ngModel", el_r3.PaymentMethodId);
    ɵngcc0.ɵɵattribute("data-boid", el_r3.BillingOptionId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.savedpaymenttypes);
} }
function ManageBillingOptionsComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 4);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, ManageBillingOptionsComponent_div_13_div_8_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(9, ManageBillingOptionsComponent_div_13_div_9_Template, 4, 4, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", el_r3.ProductName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", el_r3.StartDate, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", el_r3.ExpireDate, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.IsCurrentMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.IsCurrentMode && el_r3.BillingOptionId);
} }
function TermsAddressComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 28);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const obj_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", obj_r2.acep_iso2code);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(obj_r2.acep_name);
} }
function TermsAddressComponent_option_42_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 28);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const obj_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", obj_r3.acep_isocode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(obj_r3.acep_name);
} }
function ShippingaddressComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵelement(2, "span", 14);
    ɵngcc0.ɵɵtext(3, "We currently do not ship internationally, non-digital products should be removed. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 15);
    ɵngcc0.ɵɵelementStart(5, "input", 16);
    ɵngcc0.ɵɵlistener("click", function ShippingaddressComponent_div_5_Template_input_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.returnToCart(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function ShippingaddressComponent_option_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const obj_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngValue", obj_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.formatAddress(obj_r6));
} }
function ShippingaddressComponent_div_18_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const obj_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", obj_r9.acep_iso2code);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(obj_r9.acep_name);
} }
function ShippingaddressComponent_div_18_option_50_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const obj_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", obj_r10.acep_isocode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(obj_r10.acep_name);
} }
function ShippingaddressComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelementStart(4, "label", 18);
    ɵngcc0.ɵɵtext(5, "Country");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.address.country = $event; })("change", function ShippingaddressComponent_div_18_Template_select_change_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.onCountrySelect($event.target.value); });
    ɵngcc0.ɵɵelement(7, "option", 20);
    ɵngcc0.ɵɵtemplate(8, ShippingaddressComponent_div_18_option_8_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "span", 10);
    ɵngcc0.ɵɵtext(10, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 2);
    ɵngcc0.ɵɵelementStart(12, "div", 3);
    ɵngcc0.ɵɵelementStart(13, "div", 13);
    ɵngcc0.ɵɵelementStart(14, "label", 22);
    ɵngcc0.ɵɵtext(15, "Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "input", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.address.attention = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "span", 10);
    ɵngcc0.ɵɵtext(18, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 3);
    ɵngcc0.ɵɵelementStart(21, "div", 13);
    ɵngcc0.ɵɵelementStart(22, "label", 24);
    ɵngcc0.ɵɵtext(23, "Address 1");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.address.street1 = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "span", 10);
    ɵngcc0.ɵɵtext(26, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "div", 2);
    ɵngcc0.ɵɵelementStart(28, "div", 3);
    ɵngcc0.ɵɵelementStart(29, "div", 13);
    ɵngcc0.ɵɵelementStart(30, "label", 26);
    ɵngcc0.ɵɵtext(31, "Address 2");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_32_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.address.street2 = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "span", 10);
    ɵngcc0.ɵɵtext(34, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(35, "div", 2);
    ɵngcc0.ɵɵelementStart(36, "div", 3);
    ɵngcc0.ɵɵelementStart(37, "div", 13);
    ɵngcc0.ɵɵelementStart(38, "label", 28);
    ɵngcc0.ɵɵtext(39, "City");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "input", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_40_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.address.city = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(41, "span", 10);
    ɵngcc0.ɵɵtext(42, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "div", 2);
    ɵngcc0.ɵɵelementStart(44, "div", 3);
    ɵngcc0.ɵɵelementStart(45, "div", 4);
    ɵngcc0.ɵɵelementStart(46, "label", 30);
    ɵngcc0.ɵɵtext(47, "State/Province");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(48, "select", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_select_ngModelChange_48_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.address.stateOrProvince = $event; })("change", function ShippingaddressComponent_div_18_Template_select_change_48_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onStateSelect($event.target.value); });
    ɵngcc0.ɵɵelement(49, "option", 20);
    ɵngcc0.ɵɵtemplate(50, ShippingaddressComponent_div_18_option_50_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(51, "span", 10);
    ɵngcc0.ɵɵtext(52, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(53, "div", 2);
    ɵngcc0.ɵɵelementStart(54, "div", 3);
    ɵngcc0.ɵɵelementStart(55, "div", 13);
    ɵngcc0.ɵɵelementStart(56, "label", 32);
    ɵngcc0.ɵɵtext(57, "Zip/Postal Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(58, "input", 33);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_58_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.address.zip = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(59, "span", 10);
    ɵngcc0.ɵɵtext(60, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(61, "div", 2);
    ɵngcc0.ɵɵelementStart(62, "div", 3);
    ɵngcc0.ɵɵelementStart(63, "div", 13);
    ɵngcc0.ɵɵelementStart(64, "label", 34);
    ɵngcc0.ɵɵtext(65, "Phone");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(66, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_66_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.address.phone = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(67, "span", 10);
    ɵngcc0.ɵɵtext(68, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(69, "div", 2);
    ɵngcc0.ɵɵelementStart(70, "div", 3);
    ɵngcc0.ɵɵelementStart(71, "div", 13);
    ɵngcc0.ɵɵelementStart(72, "label", 36);
    ɵngcc0.ɵɵtext(73, "Email");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(74, "input", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_div_18_Template_input_ngModelChange_74_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.address.email = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(75, "span", 10);
    ɵngcc0.ɵɵtext(76, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.country);
    ɵngcc0.ɵɵattribute("data-validate", ctx_r3.validate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.ui_countries);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.attention);
    ɵngcc0.ɵɵattribute("data-validate", ctx_r3.validate);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.street1);
    ɵngcc0.ɵɵattribute("data-validate", ctx_r3.validate);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.street2);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.city);
    ɵngcc0.ɵɵattribute("data-validate", ctx_r3.validate);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("hidden", ctx_r3.ui_stateprovinces && ctx_r3.ui_stateprovinces.length == 0);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.stateOrProvince);
    ɵngcc0.ɵɵattribute("data-validate", ctx_r3.validate && ctx_r3.ui_stateprovinces.length > 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.ui_stateprovinces);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.zip);
    ɵngcc0.ɵɵattribute("data-validate", ctx_r3.validate);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.phone);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.address.email);
} }
function ManageECPComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "input", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageECPComponent_div_10_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r6); const el_r2 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectPaymentDetails(el_r2.ProfileId); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "label", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 1);
    ɵngcc0.ɵɵelementStart(6, "span", 18);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "span", 18);
    ɵngcc0.ɵɵtext(9, " New Account");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "div", 19);
    ɵngcc0.ɵɵelement(11, "div", 20);
    ɵngcc0.ɵɵelementStart(12, "div", 21);
    ɵngcc0.ɵɵelementStart(13, "a", 22);
    ɵngcc0.ɵɵlistener("click", function ManageECPComponent_div_10_Template_a_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r6); const el_r2 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.deletePayTypeConfirm(el_r2.ProfileId); });
    ɵngcc0.ɵɵtext(14, "Delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 23);
    ɵngcc0.ɵɵelementStart(16, "div", 13);
    ɵngcc0.ɵɵelementStart(17, "div", 24);
    ɵngcc0.ɵɵelementStart(18, "div", 25);
    ɵngcc0.ɵɵelementStart(19, "label", 26);
    ɵngcc0.ɵɵtext(20, "Name on Account");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageECPComponent_div_10_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectedpaytype.NameOnCard = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "span", 28);
    ɵngcc0.ɵɵtext(23, "Required");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 13);
    ɵngcc0.ɵɵelementStart(25, "div", 29);
    ɵngcc0.ɵɵelementStart(26, "div", 24);
    ɵngcc0.ɵɵelementStart(27, "div", 25);
    ɵngcc0.ɵɵelementStart(28, "label", 30);
    ɵngcc0.ɵɵtext(29, "Routing Number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "input", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageECPComponent_div_10_Template_input_ngModelChange_30_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectedpaytype.ECPAccountRT = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "span", 28);
    ɵngcc0.ɵɵtext(32, "Please enter a valid Routing Number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "div", 32);
    ɵngcc0.ɵɵelementStart(34, "div", 24);
    ɵngcc0.ɵɵelementStart(35, "div", 25);
    ɵngcc0.ɵɵelementStart(36, "label", 33);
    ɵngcc0.ɵɵtext(37, "Account Number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "input", 34);
    ɵngcc0.ɵɵlistener("ngModelChange", function ManageECPComponent_div_10_Template_input_ngModelChange_38_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.selectedpaytype.ECPAccountDDA = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(39, "span", 28);
    ɵngcc0.ɵɵtext(40, "Please enter a valid Account Number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(41, "div", 35);
    ɵngcc0.ɵɵelementStart(42, "input", 36, 37);
    ɵngcc0.ɵɵlistener("change", function ManageECPComponent_div_10_Template_input_change_42_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r4 = ɵngcc0.ɵɵreference(43); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.selectedpaytype.SaveCC = _r4.checked; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(44, "label", 38);
    ɵngcc0.ɵɵtext(45, "Save this account for future use");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(46, "div", 39);
    ɵngcc0.ɵɵelementStart(47, "div", 40);
    ɵngcc0.ɵɵelementStart(48, "input", 41);
    ɵngcc0.ɵɵlistener("click", function ManageECPComponent_div_10_Template_input_click_48_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.cancelEditPay(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(49, "div", 42);
    ɵngcc0.ɵɵelementStart(50, "input", 43);
    ɵngcc0.ɵɵlistener("click", function ManageECPComponent_div_10_Template_input_click_50_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.savePayType(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const el_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.savedpaymenttypes.length == 1 && ctx_r0.selectedpaytype.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.isOnShoppingCart);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("value", el_r2.ProfileId);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "ProfileECP-", i_r3, "");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.ProfileId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("for", "ProfileECP-", i_r3, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Account x", el_r2.CreditCardNumber.length > 4 ? el_r2.CreditCardNumber.substring(0, 4) : el_r2.CreditCardNumber, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId != "" || !ctx_r0.isOnShoppingCart);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", i_r3 + 1 == ctx_r0.savedpaymenttypes.length ? "ccAddNewCard" : "notnewcard")("hidden", !(ctx_r0.selectedpaytype.ProfileId == el_r2.ProfileId && ctx_r0.editpay));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.NameOnCard);
    ɵngcc0.ɵɵattribute("data-validate", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.ECPAccountRT);
    ɵngcc0.ɵɵattribute("data-validate", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedpaytype.ECPAccountDDA);
    ɵngcc0.ɵɵattribute("data-validate", el_r2.ProfileId == "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", !(el_r2.ProfileId == "" && ctx_r0.SHOWSAVECC == true && !ctx_r0.allowAddMultipleCards && ctx_r0.isOnShoppingCart));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disableSaveCC)("checked", ctx_r0.selectedpaytype.SaveCC == true);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("hidden", !(el_r2.ProfileId != "" || ctx_r0.allowAddMultipleCards));
} }
function ManageECPComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 44);
    ɵngcc0.ɵɵtext(1, " No Payment Methods Found ");
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementEnd();
} }
class PaymentDetails {
    constructor() {
        this.ProfileId = '';
        this.ProfileActionType = ProfileActionType.Update;
        this.Amount = 0;
        this.AutoRenewal = 'false';
        this.SaveCC = 'false';
        this.BusinessName = '';
        this.CCExpirationDate = '';
        this.CheckNumber = '';
        this.CreditCardNumber = '';
        this.PONumber = '';
        this.CVV = '';
        this.CardType = CardType.None.toString(); //Converting to string because databinding is always a string and not number like enum
        this.PaymentType = PaymentType.ECP.toString();
        this.CardHolderType = CardHolderType.Personal.toString();
        this.InstallmentType = InstallmentType.Annual.toString();
        this.NameOnCard = '';
        this.PostalCode = '';
        this.HasValidBillingOption = 'false';
        this.ContactId = '';
        this.OrgCode = OrgCode.ACEP;
        this.UpdateBillingOptions = false;
        this.PaymentMethodId = '';
        this.PayPalToken = '';
        //ECP Fields//
        this.ECPAccountRT = '';
        this.ECPAccountDDA = '';
        this.ECPAccountType = 'C'; // ECPAccountType.ConsumerChecking.toString();;
    }
}
class BillingOption {
    constructor() {
        this.BillingOptionId = '';
        this.PaymentMethodId = '';
        this.ProductName = '';
        this.Status = '';
        this.InstallmentOrRenewalDate = '';
        this.StartDate = '';
        this.ExpireDate = '';
        this.AmountDue = '';
        this.CCLastDigits = '';
        this.PaymentType = CardType.None.toString(); //THIS IS ACTUALLY CARD TYPE IN THE WEBSERVICE
        this.IsOnAutoRenewal = false;
        this.OnInstallments = false;
        this.BillingOptionType = '';
        this.PaymentMethodOrgCode = OrgCode.ACEP;
    }
}
class PaymentUIConfiguration {
    constructor() {
        this.SHOWAMOUNT = false;
        this.SHOWTRIALMEMBERSHIP = false;
        this.TRIALMEMBERSHIPLABEL = "MM/DD/YYYY - MM/DD/YYYY";
        this.PAYMENTMETHOD = "Payment Method";
        this.SHOWPROMOCODE = true;
        this.PRMOCODELABEL = "Promo Code";
        this.LOCKPROMOCODE = false;
        this.SHOWPROMOCODEAPPLIED = true;
        this.SHOWPAYMENTTYPE = false;
        this.ALLOW_CREDITCARDS = false;
        this.ALLOW_CHECKS = false;
        this.ALLOW_PAYPAL = false;
        this.ALLOW_CREDITTERMS = false;
        this.TERMS_ACCOUNT_APPROVED = false;
        this.TERMS_ACCOUNT_HASBILLINGINFO = false;
        //ALLOW_APPLEPAY: boolean = false;
        this.ALLOW_ECP = false;
        this.SHOWCARDHOLDERTYPE = false; //Personal/Business
        this.SHOWSAVEDPAYMENTTYPES = true;
        this.SHOWPAYPAL = false;
        this.SHOWAUTORENEWAL = false;
        this.AUTORENEWALLABEL = "Auto Renewal";
        this.AUTORENEWALINFOLABEL = ""; //this goes above autorenew buttons
        this.LOCKAUTORENEWAL = false;
        this.SHOWSAVECC = true;
        this.SHOWINSTALLMENTS = false;
        this.INSTALLMENTSLABEL = "Installments";
        this.LOCKINSTALLMENTS = false;
        //OBJECT RETURNED BY APPLYPROMOCODE//
        this.AUTOUPDATETAXES = true;
        this.PAYMENTSUMMARY = new PaymentSummary();
        this.CLIENT_GOBACKURL = "";
        this.CLIENT_RECEIPTURL = "";
        this.CLIENT_CONFIRMURL = "";
        this.CHECK_DESCRIPTION = ""; //SHOWS UP WHEN CHECK OPTION IS SELECTED
        this.AUTORENEWAL_DESCRIPTION = ""; // //this goes below the autorenew buttons..SHOWS UP WHEN AUTO AUTORENEWALOPTION IS SELECTED
        this.TERMSANDCONDITIONS_SHOWCHECKBOX = false;
        this.TERMSANDCONDITIONS_CHECKBOXTEXT = "";
        this.TERMSANDCONDITIONS_DESCRIPTION = "";
        this.ACH_DESCRIPTION = '';
        this.VENDOR = "";
    }
}
class PaymentSummary {
    constructor() {
        this.TOTALDISCOUNT = 0;
        this.TOTALTAXES = 0;
        this.TOTALSHIPPING = 0;
        this.TOTALAMOUNTWITHTAXESANDDISCOUNTS = 0;
        this.PROMOCODEMESSAGE = "";
    }
}
class LineItem {
    constructor() {
        this.ExtendedAmount = '';
        this.ProductNumber = '';
        this.ProductName = '';
        this.Quantity = '1';
        this.UnitPrice = '0';
        this.UOM = '';
        this.OverridePrice = false;
        this.PromoCode = '';
        //Membership stuff
        this.IsPrimary = false;
        this.ProductSubType = null;
        this.AccountId = '';
        this.Modifiable = false;
        this.Selected = true;
    }
}
class AccountDetails {
    constructor() {
        this.allowCreditTerms = false;
        this.hasBillingInfo = false;
    }
}
class NetTermsAddress {
    constructor() {
        this.addressid = '';
        this.isprimary = false;
        this.accountname = '';
        this.accountnumber = '';
        this.addresstype = 'Billing';
        this.address1 = '';
        this.address2 = '';
        this.address3 = '';
        this.city = '';
        this.state = '';
        this.zip = '';
        this.country = 'US';
        this.contactname = '';
        this.contactphone = '';
        this.contactemail = '';
    }
}
class ShippingAddress {
    constructor() {
        this.attention = '';
        this.street1 = '';
        this.street2 = '';
        this.city = '';
        this.stateOrProvince = '';
        this.zip = '';
        this.country = 'US';
        this.email = '';
        this.phone = '';
    }
}
class UIDATA {
    constructor() {
        this.StateProvinces = [];
        this.Countries = [];
    }
}
class OrderDetails {
    constructor() {
        this.OrderId = '';
        this.CustomerType = CustType[CustType.Contact];
        this.TotalAmount = 0;
        this.TotalDiscount = 0;
        this.TotalShipping = 0;
        this.AllowShipping = false;
        this.AcepId = '';
        this.AccountNumber = '';
        this.MemberIds = '';
        this.ClientIPAddress = '';
        this.ClientID = '';
        this.Description = '';
        this.GPOrgCode = GPOrgCode.ACEP;
        this.OrderSource = OrderSource.Web;
        this.OrderTypeCode = OrderTypeCode[OrderTypeCode.MembershipIndividual];
        this.OrgCode = OrgCode.ACEP;
        this.PriceListName = '';
        this.PromoCode = '';
        this.PromoCodeMetadata = '';
        this.FutureMemberRate_Override = '';
        this.PaymentInformation = new PaymentDetails();
        this.orderLineItems = new Array();
        this.TransactionId = '';
        this.AccountDetails = new AccountDetails();
        this.ShippingAddress = new ShippingAddress();
        this.ExisitngAddresses = new Array();
        this.CCEmail = '';
    }
}
///ENUMS//
var InstallmentType;
(function (InstallmentType) {
    InstallmentType[InstallmentType["Annual"] = 1] = "Annual";
    InstallmentType[InstallmentType["SemiAnnual"] = 2] = "SemiAnnual";
    InstallmentType[InstallmentType["Quarterly"] = 3] = "Quarterly";
    InstallmentType[InstallmentType["Monthly"] = 4] = "Monthly";
})(InstallmentType || (InstallmentType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["Check"] = 2] = "Check";
    PaymentType[PaymentType["CreditCard"] = 3] = "CreditCard";
    PaymentType[PaymentType["CreditTerms"] = 4] = "CreditTerms";
    PaymentType[PaymentType["PayPal"] = 5] = "PayPal";
    PaymentType[PaymentType["ECP"] = 6] = "ECP";
})(PaymentType || (PaymentType = {}));
var CardHolderType;
(function (CardHolderType) {
    CardHolderType[CardHolderType["Business"] = 1] = "Business";
    CardHolderType[CardHolderType["Personal"] = 2] = "Personal";
})(CardHolderType || (CardHolderType = {}));
var CustType;
(function (CustType) {
    CustType[CustType["Account"] = 1] = "Account";
    CustType[CustType["Contact"] = 2] = "Contact";
})(CustType || (CustType = {}));
var CardType;
(function (CardType) {
    CardType[CardType["Amex"] = 1] = "Amex";
    CardType[CardType["MasterCard"] = 2] = "MasterCard";
    CardType[CardType["Visa"] = 3] = "Visa";
    CardType[CardType["Discover"] = 4] = "Discover";
    CardType[CardType["Check"] = 5] = "Check";
    CardType[CardType["ECP"] = 6] = "ECP";
    CardType[CardType["None"] = -1] = "None";
})(CardType || (CardType = {}));
var ECPAccountType;
(function (ECPAccountType) {
    ECPAccountType[ECPAccountType["ConsumerChecking"] = 1] = "ConsumerChecking";
    ECPAccountType[ECPAccountType["ConsumerSavings"] = 2] = "ConsumerSavings";
    ECPAccountType[ECPAccountType["CommercialChecking"] = 3] = "CommercialChecking";
})(ECPAccountType || (ECPAccountType = {}));
var GPOrgCode;
(function (GPOrgCode) {
    GPOrgCode[GPOrgCode["ACEP"] = 1] = "ACEP";
    GPOrgCode[GPOrgCode["EMRA"] = 2] = "EMRA";
    GPOrgCode[GPOrgCode["EMF"] = 3] = "EMF";
    GPOrgCode[GPOrgCode["NEMPC"] = 4] = "NEMPC";
    GPOrgCode[GPOrgCode["SEMPA"] = 5] = "SEMPA";
    GPOrgCode[GPOrgCode["FACEP"] = 6] = "FACEP";
    GPOrgCode[GPOrgCode["MEMB"] = 7] = "MEMB";
})(GPOrgCode || (GPOrgCode = {}));
var OrderSource;
(function (OrderSource) {
    OrderSource[OrderSource["CRM"] = 1] = "CRM";
    OrderSource[OrderSource["Admin"] = 2] = "Admin";
    OrderSource[OrderSource["Web"] = 3] = "Web";
})(OrderSource || (OrderSource = {}));
var OrderTypeCode;
(function (OrderTypeCode) {
    OrderTypeCode[OrderTypeCode["Chapter"] = 0] = "Chapter";
    OrderTypeCode[OrderTypeCode["Contribution"] = 1] = "Contribution";
    OrderTypeCode[OrderTypeCode["eCME"] = 2] = "eCME";
    OrderTypeCode[OrderTypeCode["MeetingRegistration"] = 3] = "MeetingRegistration";
    OrderTypeCode[OrderTypeCode["MembershipGroup"] = 4] = "MembershipGroup";
    OrderTypeCode[OrderTypeCode["MembershipIndividual"] = 5] = "MembershipIndividual";
    OrderTypeCode[OrderTypeCode["MembershipAddOn"] = 6] = "MembershipAddOn";
    OrderTypeCode[OrderTypeCode["Subscription"] = 7] = "Subscription";
    OrderTypeCode[OrderTypeCode["CMEApproval"] = 8] = "CMEApproval";
    OrderTypeCode[OrderTypeCode["Section"] = 9] = "Section";
    OrderTypeCode[OrderTypeCode["SectionSubscription"] = 10] = "SectionSubscription";
    OrderTypeCode[OrderTypeCode["CUAP"] = 11] = "CUAP";
    OrderTypeCode[OrderTypeCode["FACEP"] = 12] = "FACEP";
    OrderTypeCode[OrderTypeCode["dummy"] = 13] = "dummy";
})(OrderTypeCode || (OrderTypeCode = {}));
var OrgCode;
(function (OrgCode) {
    OrgCode[OrgCode["ACEP"] = 1] = "ACEP";
    OrgCode[OrgCode["EMRA"] = 2] = "EMRA";
    OrgCode[OrgCode["ACEPEMRA"] = 3] = "ACEPEMRA";
    OrgCode[OrgCode["SEMPA"] = 4] = "SEMPA";
    OrgCode[OrgCode["EMF"] = 5] = "EMF";
    OrgCode[OrgCode["NEMPAC"] = 6] = "NEMPAC";
})(OrgCode || (OrgCode = {}));
var ProfileActionType;
(function (ProfileActionType) {
    ProfileActionType[ProfileActionType["Update"] = 1] = "Update";
    ProfileActionType[ProfileActionType["Delete"] = 2] = "Delete";
    ProfileActionType[ProfileActionType["Add"] = 3] = "Add";
})(ProfileActionType || (ProfileActionType = {}));
var ProductType;
(function (ProductType) {
    //[Description("Sales Inventory")]
    ProductType[ProductType["SalesInventory"] = 1] = "SalesInventory";
    //[Description("Miscellaneous Charges")]
    ProductType[ProductType["MiscellaneousCharges"] = 2] = "MiscellaneousCharges";
    ProductType[ProductType["Services"] = 3] = "Services";
    //[Description("Flat Fees")]
    ProductType[ProductType["FlatFees"] = 4] = "FlatFees";
    ProductType[ProductType["Membership"] = 200000] = "Membership";
    ProductType[ProductType["Event"] = 200001] = "Event";
    ProductType[ProductType["CME"] = 200002] = "CME";
})(ProductType || (ProductType = {}));
var ProductSubType;
(function (ProductSubType) {
    //[Description("Chapter Dues")]
    ProductSubType[ProductSubType["ChapterDues"] = 1] = "ChapterDues";
    //[Description("EMF")]
    ProductSubType[ProductSubType["EMF"] = 2] = "EMF";
    //[Description("National Dues")]
    ProductSubType[ProductSubType["NationalDues"] = 3] = "NationalDues";
    ProductSubType[ProductSubType["NEMPAC"] = 4] = "NEMPAC";
    ProductSubType[ProductSubType["PAC"] = 5] = "PAC";
    ProductSubType[ProductSubType["SECT"] = 6] = "SECT";
    ProductSubType[ProductSubType["SPEC"] = 7] = "SPEC";
    ProductSubType[ProductSubType["EventReg"] = 8] = "EventReg";
    ProductSubType[ProductSubType["EventSpecFunc"] = 9] = "EventSpecFunc";
    ProductSubType[ProductSubType["EventLab"] = 10] = "EventLab";
    ProductSubType[ProductSubType["EventResearch"] = 11] = "EventResearch";
    ProductSubType[ProductSubType["EventExhibit"] = 12] = "EventExhibit";
    ProductSubType[ProductSubType["EventBooth"] = 13] = "EventBooth";
    ProductSubType[ProductSubType["EventCME"] = 14] = "EventCME";
    ProductSubType[ProductSubType["Fee"] = 15] = "Fee";
    ProductSubType[ProductSubType["EventTotals"] = 16] = "EventTotals";
    //[Description("ACEP APLS")]
    ProductSubType[ProductSubType["ACEPAPLS"] = 17] = "ACEPAPLS";
    //[Description("ACEP Retro")]
    ProductSubType[ProductSubType["ACEPRetro"] = 18] = "ACEPRetro";
    //[Description("ACEP Series")]
    ProductSubType[ProductSubType["ACEPSeries"] = 19] = "ACEPSeries";
    //[Description("ACEP LiveAct")]
    ProductSubType[ProductSubType["ACEPLiveAct"] = 20] = "ACEPLiveAct";
    //[Description("ACEP EndMat")]
    ProductSubType[ProductSubType["ACEPEndMat"] = 21] = "ACEPEndMat";
    //[Description("AMA ChpLiveAct")]
    ProductSubType[ProductSubType["AMAChpLiveAct"] = 22] = "AMAChpLiveAct";
    //[Description("AMA ChpLiveOcc")]
    ProductSubType[ProductSubType["AMAChpLiveOcc"] = 23] = "AMAChpLiveOcc";
    //[Description("AMA 3rdLiveAct")]
    ProductSubType[ProductSubType["AMA3rdLiveAct"] = 24] = "AMA3rdLiveAct";
    //[Description("AMA 3rdLiveOcc")]
    ProductSubType[ProductSubType["AMA3rdLiveOcc"] = 25] = "AMA3rdLiveOcc";
    //[Description("AMA ChpEndMat")]
    ProductSubType[ProductSubType["AMAChpEndMat"] = 26] = "AMAChpEndMat";
    //[Description("AMA 3rdEndMat")]
    ProductSubType[ProductSubType["AMA3rdEndMat"] = 27] = "AMA3rdEndMat";
    //[Description("AMA RushFee")]
    ProductSubType[ProductSubType["AMARushFee"] = 28] = "AMARushFee";
    ProductSubType[ProductSubType["EventFunc"] = 29] = "EventFunc";
    //[Description("ACEP RushFee")]
    ProductSubType[ProductSubType["ACEPRushFee"] = 30] = "ACEPRushFee";
    //[Description("AMA 10Per")]
    ProductSubType[ProductSubType["AMA10Per"] = 31] = "AMA10Per";
    //[Description("Section Subscription")]
    ProductSubType[ProductSubType["SectionSubscription"] = 32] = "SectionSubscription";
})(ProductSubType || (ProductSubType = {}));

class PaymentService {
    constructor(http, globaldataops, globaldomops, ssosvc, commonsvc, _document) {
        this.http = http;
        this.globaldataops = globaldataops;
        this.globaldomops = globaldomops;
        this.ssosvc = ssosvc;
        this.commonsvc = commonsvc;
        this._document = _document;
        ///PRIVATE PROPERTIES
        this.payloadValid$ = new Subject();
        this.editSavedPaymentTypeInProgress = false;
        this.paymentheaders = this.globaldataops.headers;
        this.paymentWebServicePath = "";
        ///PUBLIC PROPERTIES//
        this.orderdetails = new OrderDetails();
        this.paymentuiconfig = new PaymentUIConfiguration();
        this.orderNumber = "";
        this.termsEmail = "";
        this.termsSubmitted = false;
        this.uidata = new UIDATA();
        //console.log('payment service constrctr');
        this.RefreshOrgCode();
        this.document = _document;
        this.paymentheaders = new HttpHeaders({
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Expose-Headers": "*",
            "Access-Control-Allow-Methods": "PUT, GET, POST",
            "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
            Authorization: this.ssosvc.toolkitauthencoded
        });
        this.ssosvc.GetContext().subscribe(c => {
            //Set the auth headers and the payment web service baspath
            this.paymentheaders.set("Authorization", this.ssosvc.toolkitauthencoded);
            this.RefreshPaymentWebServiceBasePath();
        });
    }
    RefreshOrgCode() {
        let org = this.globaldataops.ORG;
        if (org == "ACEP") {
            this.orderdetails.OrgCode = OrgCode.ACEP;
        }
        else if (org == "EMRA") {
            this.orderdetails.OrgCode = OrgCode.EMRA;
        }
        if (org == "SEMPA") {
            this.orderdetails.OrgCode = OrgCode.SEMPA;
        }
    }
    RefreshPaymentWebServiceBasePath() {
        this.paymentWebServicePath =
            this.globaldataops.WebServicesBasePath + "/AcepOrder/api/2015/orders/";
        if (window.location.href.indexOf('localhost') > -1) {
            this.paymentWebServicePath = 'http://localhost/OrderWS/api/2015/orders/';
        }
    }
    GetExpiryDateYearRange() {
        let currentyear = new Date().getFullYear();
        let years = [];
        for (let i = currentyear; i < currentyear + 10; i++) {
            years.push(i);
        }
        return years;
    }
    GetCardTypeFromName(cardtype) {
        if (cardtype) {
            if (cardtype.toLowerCase() == "visa") {
                return CardType.Visa;
            }
            else if (cardtype.toLowerCase() == "master") {
                return CardType.MasterCard;
            }
            if (cardtype.toLowerCase() == "amex" ||
                cardtype.toLowerCase() == "americanexpress") {
                return CardType.Amex;
            }
            if (cardtype.toLowerCase() == "discover") {
                return CardType.Discover;
            }
        }
        return CardType.None;
    }
    GetCardTypeFromNumber(number) {
        //http://www.richardsramblings.com/regex/credit-card-numbers/
        let cardtype = CardType.None;
        // visa
        var re = new RegExp("^4");
        if (number.match(re) != null)
            cardtype = CardType.Visa;
        // Mastercard
        re = new RegExp("^5[1-5]");
        if (number.match(re) != null)
            cardtype = CardType.MasterCard;
        // AMEX
        re = new RegExp("^3[47]");
        if (number.match(re) != null)
            cardtype = CardType.Amex;
        // Discover
        re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
        if (number.match(re) != null)
            cardtype = CardType.Discover;
        //// Diners
        //re = new RegExp("^36");
        //if (number.match(re) != null)
        //    cardtype =  "Diners";
        //// Diners - Carte Blanche
        //re = new RegExp("^30[0-5]");
        //if (number.match(re) != null)
        //    cardtype =  "Diners - Carte Blanche";
        //// JCB
        //re = new RegExp("^35(2[89]|[3-8][0-9])");
        //if (number.match(re) != null)
        //    cardtype =  "JCB";
        //// Visa Electron
        //re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
        //if (number.match(re) != null)
        //    cardtype =  "Visa Electron";
        $(".ccIcons .sprites").css("opacity", 0.3);
        if (cardtype != CardType.None) {
            //$('.ccIcons img[alt="' + cardtype + '"]').fadeTo("slow", 1.0);
            $(".image-" + CardType[cardtype]).fadeTo("slow", 1.0);
        }
        return cardtype;
        //let ind = 0;
        //switch (cardtype) {
        //    case 'AMEX':
        //        ind = 1;
        //        break;
        //    case 'MasterCard':
        //        ind = 2;
        //        break;
        //    case 'Visa':
        //        ind = 3;
        //        break;
        //    case 'Discover':
        //        ind = 4;
        //        break;
        //    default:
        //}
        //return ind;
    }
    MaskCreditCardNumber(number) {
        let _maskedcc = number;
        if (number && number.length > 4) {
            _maskedcc = number.substring(number.length - 4);
        }
        _maskedcc = "*" + _maskedcc;
        return _maskedcc;
    }
    InitPlugins() {
        this.globaldomops.initPlugins();
        setTimeout(function () {
            let cvv = $("[data-remodal-id=creditcardCVV]").remodal();
            let terms = $("[data-remodal-id=termsModal]").remodal();
            $("[data-remodal-id=deletePaymentMethod]").remodal();
            if (this.paymentuiconfig) {
                let preview = $("[data-remodal-id=paymentpreview]").remodal();
            }
            console.log("payment.service inside settimeout function");
            $(".FlowupLabels").FlowupLabels({
                // Handles the possibility of having input boxes prefilled on page load
                feature_onInitLoad: false,
                // Class when focusing an input
                class_focused: "focused",
                // Class when an input has text entered
                class_populated: "populated"
            });
        }, 100);
    }
    InitPluginsForSavedPaymentTypes() {
        //LABELAUTY
        setTimeout(function () {
            $(".remodal").remodal();
            // $(":radio.nolabelauty, :checkbox.nolabelauty").labelauty();
            $("[data-remodal-id=deletePaymentMethod]").remodal();
        }, 100);
    }
    ResetCreditCardForm() {
        setTimeout(() => {
            $(".ccAddNewCard .populated").removeClass("populated");
            $(".ccAddNewCard .validation-error").removeClass("validation-error");
            $(".ccAddNewCard .focused").removeClass("focused");
        }, 100);
    }
    OpenPaymentPreview() {
        //Check if edit is in progress
        if (this.editSavedPaymentTypeInProgress) {
            this.globaldomops.notify("Please save your credit card details before submitting the payment", "", "warning");
            return;
        }
        let preview = $("[data-remodal-id=paymentpreview]").remodal();
        preview.open();
        ////if (!this.globaldomops.CheckValidations(event)) return false;
        ////this.maskedccnum = this.paymentservice.MaskCreditCardNumber(this.pd.CreditCardNumber);
        //if (this.paymentuiconfig.PAYMENT_AND_SHOPPINGCART_INSAMEPAGE) {
        //    //If shopping cart and payment control in same page then open modal..else toggle the view ( used for membership )
        //}
        //else {
        //    this.paymentuiconfig.PREVIEWMODEON = true;
        //}
        //console.clear();
        console.info("Order Details", this.orderdetails);
    }
    PlaceOrder() {
        this.globaldomops.showwait();
        this.globaldomops.continueToWait = true;
        let od = this.commonsvc.DeepCopyObject(this.orderdetails);
        if (od.orderLineItems.length > 0 &&
            od.orderLineItems[0].Selected != undefined) {
            od.orderLineItems = od.orderLineItems.filter(a => a.Selected);
        }
        //pass observe:response if you want to access response headers
        //https://stackoverflow.com/questions/47389365/httpclient-can%C2%B4t-access-to-response-headers
        // return this.http
        //   .post(
        // this.globaldataops.ninjaapiendpoint + "PlaceOrder",
        //     JSON.stringify(od),
        //     { headers: this.globaldataops.headers, observe: "response" }
        //   )
        //   .pipe(
        //     map((res: HttpResponse<any>) => {
        //       this.orderNumber = res.headers.get("orderNumber");
        //       this.orderdetails.TotalAmount = res.headers.get("totalAmountCharged");
        //       return res;
        //     })
        //   );
        //Do not save Profile if not passing payment info - MB/SM 2/16/2024
        if (+this.paymentuiconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS == 0) {
            od.PaymentInformation.SaveCC = false;
        }
        return this.http
            .post(
        // this.globaldataops.ninjaapiendpoint + "PlaceOrder",
        this.paymentWebServicePath.replace("2015", "2019") + "PlaceOrder", JSON.stringify(od), { headers: this.paymentheaders, observe: "response" })
            .pipe(map((res) => {
            this.orderNumber = res.headers.get("orderNumber");
            this.orderdetails.TotalAmount = res.headers.get("totalAmountCharged");
            return res;
        }));
    }
    ValidateOrder() {
        //this.globaldomops.showwait();
        this.orderdetails.PaymentInformation.CCExpirationDate = "1/1/1900";
        return this.http
            .post(this.paymentWebServicePath.replace("2015", "2019") + "ValidateOrder", JSON.stringify(this.orderdetails), { headers: this.paymentheaders })
            .pipe(map((res) => this.MapValidationOrderDetails(res)));
    }
    RunOrderReceiptWorkflow() {
        let payload = { orderid: this.orderdetails.OrderId, workflowname: 'Email Generic Order Receipt' };
        return this.http
            .post(this.globaldataops.ninjaapiendpoint + "RunOrderWorkflow", JSON.stringify(payload), { headers: this.globaldataops.headers })
            .pipe(map((res) => res));
    }
    GetOrderNumber() {
        let payload = { orderid: this.orderdetails.OrderId };
        return this.http
            .post(this.globaldataops.ninjaapiendpoint + "GetOrderNumberFromOrderId", JSON.stringify(payload), { headers: this.globaldataops.headers })
            .pipe(map((res) => res));
    }
    ApplyPromoCode() {
        //Do not include unselected items into the promo code request
        let od = this.commonsvc.DeepCopyObject(this.orderdetails);
        if (od.orderLineItems.length > 0 &&
            od.orderLineItems[0].Selected != undefined) {
            od.orderLineItems = od.orderLineItems.filter(a => a.Selected);
        }
        return this.http
            .post(this.paymentWebServicePath + "ApplyPromoCode", JSON.stringify(od), {
            headers: this.paymentheaders
        })
            .pipe(map((res) => res));
    }
    GetPaymentMethods() {
        //if (this.savedpaymenttypes) {
        //    return Observable.of([this.savedpaymenttypes]);
        //}
        let endpoint = "GetPaymentMethods?orgcode=" +
            this.orderdetails.OrgCode +
            "&contactid=" +
            this.ssosvc.contactid;
        //let paymenttypes$ = this.http.get(this.ninjaapiendpoint + endpoint, { headers: this.headers }).map((res: HttpResponse<any>) => res).share();
        //return Observable.of([paymenttypes$]);
        return this.http
            .get(this.paymentWebServicePath + endpoint, {
            headers: this.paymentheaders
        })
            .pipe(map((res) => {
            this.MapPaymentDetails(res);
        }), share());
    }
    GetUIDataForShoppingCart() {
        let endpoint = "RunSproc?sp=Acepsp_ShoppingCart_GetPageData";
        return this.http
            .get(this.globaldataops.ninjaapiendpoint + endpoint, {
            headers: this.paymentheaders
        })
            .pipe(map((res) => {
            this.MapUIData(res);
        }), share());
    }
    GetBillingOptions() {
        let endpoint = "GetBillingOptions?orgcode=" +
            this.orderdetails.OrgCode +
            "&contactid=" +
            this.ssosvc.contactid;
        return this.http
            .get(this.paymentWebServicePath + endpoint, {
            headers: this.paymentheaders
        })
            .pipe(map((res) => {
            this.MapBillingOptions(res);
        }), share());
    }
    GetSubscriptions() {
        let endpoint = "/api/dashboardapi/GetSubscriptionDetailsForContact";
        return this.http
            .post("http://localhost/privatews" + endpoint, JSON.stringify({ contactid: this.ssosvc.contactid }))
            .pipe(map((res) => {
            this.MapSubscriptions_BillingOptions(res);
        }), share());
        // return this.http.post(this.globaldataops.WebServicesBasePath + endpoint,JSON.stringify({ 'contactid': this.ssosvc.contactid }), { headers: this.globaldataops.headers }).map((res: HttpResponse<any>) => { this.MapSubscriptions_BillingOptions(res) }).share();
    }
    DeletePaymentMethod(_paydetails) {
        //this.globaldomops.showwait();
        _paydetails.ProfileActionType = ProfileActionType.Delete;
        return this.http.post(this.paymentWebServicePath + "ManagePaymentMethod", JSON.stringify(_paydetails), { headers: this.paymentheaders });
        //.map((res: HttpResponse<any>) => res);
    }
    UpdatePaymentMethod(_paydetails) {
        //this.globaldomops.showwait();
        _paydetails.ProfileActionType =
            _paydetails.ProfileId == ""
                ? ProfileActionType.Add
                : ProfileActionType.Update;
        return this.http.post(this.paymentWebServicePath + "ManagePaymentMethod", JSON.stringify(_paydetails), { headers: this.paymentheaders });
        //.map((res: HttpResponse<any>) => res);
    }
    UpdateBillingOption(_billingoption) {
        //this.globaldomops.showwait();
        return this.http.post(this.paymentWebServicePath + "ManageBillingOption", JSON.stringify(_billingoption), { headers: this.paymentheaders });
        //.map((res: HttpResponse<any>) => res);
    }
    printReceipt() {
        window.open(this.globaldataops.BasePath +
            "/ShoppingCart/PrintReport.aspx?ordernumber=" +
            this.orderNumber);
    }
    selectAllLineitems(od) {
        if (od.orderLineItems) {
            od.orderLineItems.forEach(element => {
                element.selected = true;
            });
        }
        return od;
    }
    //Mapping response of validateorder to orderdetails
    MapValidationOrderDetails(od) {
        // console.info('Order Details', od);
        //Mark all line items as selected
        od = this.selectAllLineitems(od);
        this.orderdetails.PaymentInformation.CCExpirationDate = "";
        //Update payment Methods
        this.MapPaymentDetails(od.existingPaymentMethods);
        //Update Payment Config UI
        //debugger;
        this.MapPaymentConfigUI(od);
        return od;
    }
    MapPaymentDetails(pds) {
        // console.info('Payment Details', pds);
        this.savedpaymenttypes = [];
        for (let p of pds) {
            //{ "profileId":"75729358", "paymentType":0, "checkNumber":null, "amount":0.0, "cardHolderType":0, "businessName":null, "nameOnCard":null, "creditCardNumber":"1881", "ccExpirationDate":"2022-05-01T05:00:00Z", "cvv":null, "postalCode":"33445", "installmentType":0, "autoRenewal":false, "cardType":3, "hasPaymentInfo":true, "saveCC":false }
            let checkifProfileExists = this.savedpaymenttypes.filter(function (s) {
                return s.ProfileId === p.profileId;
            }).length > 0;
            if (!checkifProfileExists) {
                let pd = {
                    ProfileId: p.profileId,
                    ProfileActionType: p.ProfileActionType,
                    Amount: p.amount,
                    AutoRenewal: p.autoRenewal,
                    SaveCC: p.saveCC,
                    BusinessName: p.businessName,
                    CCExpirationDate: moment(p.ccExpirationDate).format("MM/DD/YYYY"),
                    CheckNumber: p.checkNumber,
                    CreditCardNumber: p.creditCardNumber,
                    PONumber: p.poNumber,
                    CVV: p.cvv,
                    CardType: p.cardType,
                    PaymentType: p.paymentType,
                    CardHolderType: p.cardHolderType == 0 ? 2 : 1,
                    InstallmentType: p.installmentType,
                    NameOnCard: p.nameOnCard,
                    PostalCode: p.postalCode,
                    HasValidBillingOption: p.hasValidBillingOption,
                    ContactId: this.ssosvc.contactid,
                    OrgCode: this.orderdetails.OrgCode,
                    UpdateBillingOptions: false,
                    PaymentMethodId: p.paymentMethodId,
                    PayPalToken: p.paymentToken,
                    //ECP
                    ECPAccountRT: p.ecpAccountRT,
                    ECPAccountDDA: p.ecpAccountDDA,
                    ECPAccountType: 'C' // p.ecpAccountType ?? ECPAccountType.CommercialChecking.toString(),
                };
                this.savedpaymenttypes.push(pd);
            }
        }
        if (this.savedpaymenttypes.length > 0) {
            this.orderdetails.PaymentInformation.ProfileId = this.savedpaymenttypes[0].ProfileId;
        }
    }
    MapUIData(jsondata) {
        var _a;
        let data = jsondata;
        this.uidata = {
            Countries: data[0],
            StateProvinces: data[1]
        };
        let achKey = (this.orderdetails.OrderTypeCode == (OrderTypeCode[OrderTypeCode.MembershipGroup])) ? 'ACH Payment Header GP' : 'ACH Payment Header';
        this.paymentuiconfig.ACH_DESCRIPTION = (_a = data[2].filter(a => a.key == achKey)[0]) === null || _a === void 0 ? void 0 : _a.value;
    }
    MapBillingOptions(bos) {
        console.info("Billing Options", bos);
        this.savedbillingoptions = [];
        for (let p of bos) {
            let bo = {
                BillingOptionId: p.billingOptionId,
                PaymentMethodId: p.paymentMethodId,
                ProductName: p.productName,
                Status: p.status,
                InstallmentOrRenewalDate: p.installmentOrRenewalDate,
                StartDate: p.startDate == "" ? "" : moment(p.startDate).format("MM/DD/YYYY"),
                ExpireDate: p.expireDate == "" ? "" : moment(p.expireDate).format("MM/DD/YYYY"),
                AmountDue: p.amountDue,
                CCLastDigits: p.ccLastDigits,
                PaymentType: this.GetCardTypeFromName(p.paymentType),
                IsOnAutoRenewal: p.isOnAutoRenewal,
                OnInstallments: p.onInstallments,
                BillingOptionType: p.billingOptionType,
                PaymentMethodOrgCode: OrgCode[p.paymentMethodOrgCode + ""]
            };
            this.savedbillingoptions.push(bo);
        }
        //    Acep - 1
        //    Emra -2
        //    Sempa - 4
        //    EMf - 5
        //    NEMPAC - 6
        if (this.orderdetails.OrgCode == OrgCode.SEMPA) {
            this.savedbillingoptions = this.savedbillingoptions.filter(b => b.PaymentMethodOrgCode + "" != "ACEP" &&
                b.PaymentMethodOrgCode + "" != "EMRA");
        }
        else {
            this.savedbillingoptions = this.savedbillingoptions.filter(b => b.PaymentMethodOrgCode + "" != "SEMPA");
        }
        //Filter Susbscriptions/Membership  --MOVED TO PAGES
        // let bo_type = this.commonsvc.getQueryString('type');
        // if (bo_type == 'Subscription') {
        //     this.savedbillingoptions = this.savedbillingoptions.filter(b => b.BillingOptionType == 'Subscription');
        // }
        // else if (bo_type == 'Membership') {
        //     this.savedbillingoptions = this.savedbillingoptions.filter(b => b.BillingOptionType == 'Membership');
        // }
    }
    MapSubscriptions_BillingOptions(bos) {
        console.info("Billing Options", bos);
        this.savedbillingoptions = [];
        for (let p of bos.Table) {
            let bo = {
                BillingOptionId: p.billingoptionid,
                PaymentMethodId: p.paymentmethodid,
                ProductName: p.name,
                Status: p.subscriptionstatus,
                InstallmentOrRenewalDate: p.installmentdate,
                StartDate: p.startdate == "" ? "" : moment(p.startdate).format("MM/DD/YYYY"),
                ExpireDate: p.subexpirydate == ""
                    ? ""
                    : moment(p.subexpirydate).format("MM/DD/YYYY"),
                AmountDue: p.amountDue,
                CCLastDigits: p.cclast4digits,
                PaymentType: this.GetCardTypeFromName(p.paymenttype),
                IsOnAutoRenewal: p.isonautorenewal,
                OnInstallments: p.oninstallments,
                BillingOptionType: "Subscription",
                PaymentMethodOrgCode: OrgCode[p.paymentmethodorgcode + ""]
            };
            this.savedbillingoptions.push(bo);
        }
        //    Acep - 1
        //    Emra -2
        //    Sempa - 4
        //    EMf - 5
        //    NEMPAC - 6
        if (this.orderdetails.OrgCode == OrgCode.SEMPA) {
            this.savedbillingoptions = this.savedbillingoptions.filter(b => b.PaymentMethodOrgCode + "" != "ACEP" &&
                b.PaymentMethodOrgCode + "" != "EMRA");
        }
        else {
            this.savedbillingoptions = this.savedbillingoptions.filter(b => b.PaymentMethodOrgCode + "" != "SEMPA");
        }
        //Filter Susbscriptions/Membership  --MOVED TO PAGES
        // let bo_type = this.commonsvc.getQueryString('type');
        // if (bo_type == 'Subscription') {
        //     this.savedbillingoptions = this.savedbillingoptions.filter(b => b.BillingOptionType == 'Subscription');
        // }
        // else if (bo_type == 'Membership') {
        //     this.savedbillingoptions = this.savedbillingoptions.filter(b => b.BillingOptionType == 'Membership');
        // }
    }
    MapPaymentConfigUI(od) {
        let oti = od.orderTypeInfo;
        this.paymentuiconfig.SHOWPROMOCODE = oti.allowPromoCode;
        this.paymentuiconfig.PRMOCODELABEL =
            oti.promoCodeLabel == "" ? "Promo Code" : oti.promoCodeLabel;
        this.paymentuiconfig.SHOWCARDHOLDERTYPE = oti.allowCardHolderType;
        this.paymentuiconfig.SHOWAUTORENEWAL = oti.allowAutoRenewal;
        this.paymentuiconfig.SHOWINSTALLMENTS = oti.allowInstalments;
        this.paymentuiconfig.LOCKAUTORENEWAL = oti.autoRenewalState == 3;
        if (oti.autoRenewalState == 1 || oti.autoRenewalState == 3) {
            this.orderdetails.PaymentInformation.AutoRenewal = 'true';
        }
        this.paymentuiconfig.SHOWPAYMENTTYPE =
            oti.acceptCreditCards && (oti.acceptChecks || oti.allowCreditTerms);
        this.paymentuiconfig.ALLOW_CREDITCARDS = oti.acceptCreditCards;
        this.paymentuiconfig.ALLOW_CHECKS = oti.acceptChecks;
        this.paymentuiconfig.ALLOW_PAYPAL = oti.acceptPaypal; // true;  //Not currently driven through Order Type.needs to show up when no autorenewals or instalmmetns are selected
        this.paymentuiconfig.ALLOW_ECP = oti.acceptECP;
        //if no account number passed through payload ..do not show terms
        this.paymentuiconfig.ALLOW_CREDITTERMS =
            !!oti.allowCreditTerms && this.orderdetails.AccountNumber != "";
        let ad = od.account;
        if (ad) {
            this.paymentuiconfig.TERMS_ACCOUNT_APPROVED = !!ad.allowCreditTerms;
            this.paymentuiconfig.TERMS_ACCOUNT_HASBILLINGINFO = !!ad.hasBillingInfo;
        }
        //debugger;
        //trial membership
        this.ApplyTrialMembershipChanges(this.paymentuiconfig, od);
    }
    ApplyTrialMembershipChanges(config, response) {
        config.SHOWTRIALMEMBERSHIP = response.promoCodeValid && response.isTrialMembership;
        if (config.SHOWTRIALMEMBERSHIP) {
            config.LOCKAUTORENEWAL = config.SHOWTRIALMEMBERSHIP;
            config.TRIALMEMBERSHIPLABEL = response.promoCodeMetadata;
            this.orderdetails.PaymentInformation.AutoRenewal = 'true';
            this.orderdetails.PaymentInformation.InstallmentType = InstallmentType.Monthly; //.toString();
            config.SHOWPAYPAL = false;
            //if trial membership..the total discount is the price that needs to be shown
            if (!!(response.totalDiscount)) {
                config.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS = response.totalDiscount;
            }
        }
    }
    getPayloadValidity() {
        return this.payloadValid$.asObservable();
    }
    GetTotalPriceFromLineItems() {
        let totalamount = 0;
        $.each(this.orderdetails.orderLineItems, function () {
            totalamount +=
                (this.Selected ? (parseFloat(this.UnitPrice) || 0) * parseFloat(this.Quantity) : 0);
            //MB - 3/20/2024..Why were we previously not checking for Selected flag - Found it while working on Graduating Residnets 
        });
        //group portal
        if (this.orderdetails.OrderTypeCode == (OrderTypeCode[OrderTypeCode.MembershipGroup]).toString()) {
            totalamount = this.orderdetails.TotalAmount;
        }
        this.orderdetails.TotalAmount = totalamount;
        return this.orderdetails.TotalAmount;
    }
    UpdateNetTermsBillingAddress(address) {
        this.termsEmail = address.contactemail;
        let endpoint = "/api/accountapi/UpdateAccountAddress";
        // return this.http.post('http://localhost/privatews' + endpoint, JSON.stringify({'address': address}), { headers: this.globaldataops.headers }).map((res: HttpResponse<any>) => {
        //     this.SendNetTermsEmail(res)
        // }).share();
        this.globaldomops.showwait();
        return this.http
            .post(this.globaldataops.WebServicesBasePath + "/privatetoolkit" + endpoint, JSON.stringify({ address: address }), { headers: this.globaldataops.headers })
            .pipe(map((res) => {
            this.SendNetTermsEmail(address);
        }), share());
        // return this.http.post(this.globaldataops.WebServicesBasePath + endpoint,JSON.stringify({ 'contactid': this.ssosvc.contactid }), { headers: this.globaldataops.headers }).map((res: HttpResponse<any>) => { this.MapSubscriptions_BillingOptions(res) }).share();
    }
    SendNetTermsEmail(address) {
        let email_from = "donotreply@acep.org";
        let _vendor = this.paymentuiconfig.VENDOR.toLowerCase();
        let _emailtoprod = "Receivables@acep.org";
        if (['geda', 'paced', 'cuap', 'edap'].indexOf(_vendor) > -1) {
            _emailtoprod = `${_vendor}@acep.org`;
        }
        let email_to = this.globaldataops.isTestEnvironment()
            ? "devops@acep.org"
            : _emailtoprod;
        let email_cc = this.globaldataops.isTestEnvironment()
            ? ""
            : "devops@acep.org";
        // if(window.location.href.indexOf('localhost') > -1)
        // {
        //  email_to = 'mbonthu@acep.org';
        //  email_cc = '';
        // }
        let email_subject = `Terms Approval Request for ${this.paymentuiconfig.VENDOR}`;
        let html = "";
        //html += `<b style='color:red;'>${this.paymentuiconfig.VENDOR} - Confirm Url Error</b><br/>`;
        html += "<table>";
        html += `<tr><td>Account Name:</td><td>${address.accountname}</td><tr>`;
        html += `<tr><td>Account Number:</td><td>${address.accountnumber}</td><tr>`;
        html += `<tr><td>Department Name:</td><td>${address.address1}</td><tr>`;
        html += `<tr><td>Address 1:</td><td>${address.address2}</td><tr>`;
        html += `<tr><td>Address 2:</td><td>${address.address3}</td><tr>`;
        html += `<tr><td>City:</td><td>${address.city}</td><tr>`;
        html += `<tr><td>State/Province:</td><td>${address.state}</td><tr>`;
        html += `<tr><td>Zip/Postal Code:</td><td>${address.zip}</td><tr>`;
        html += `<tr><td>Country:</td><td>${address.country}</td><tr>`;
        html += `<tr><td>Department Contact Name:</td><td>${address.contactname}</td><tr>`;
        html += `<tr><td>Phone:</td><td>${address.contactphone}</td><tr>`;
        html += `<tr><td>Email:</td><td>${address.contactemail}</td><tr>`;
        html += `<tr><td></td><td></td><tr>`;
        html += `<tr><td colspan='2'><hr/></td><tr>`;
        html += `<tr><td>Submitted By:</td><td>${this.ssosvc.context.user.FormalName} ( ${this.ssosvc.acepid} )</td><tr>`;
        html += "</table>";
        html = btoa(html);
        // let errorContent =  `VENDOR: ${this.paymentservice.paymentuiconfig.VENDOR} **** `;
        // errorContent +=  `TRANSACTION ID: ${this.paymentservice.orderdetails.TransactionId} **** `;
        // errorContent +=  `ORDER NUMBER: ${this.paymentservice.orderNumber} **** `;
        // errorContent +=  `CONFIRM URL: ${this.paymentservice.paymentuiconfig.CLIENT_CONFIRMURL} **** `;
        // errorContent +=  `HTTP RESPONSE CODE: ${error.status.toString()} **** `;
        // errorContent +=  `HTTP RESPONSE BODY: ${error._body.toString()} **** `;
        this.globaldataops
            .SendEmail(this.ssosvc.contactid, email_from, email_to, email_cc, email_subject, html)
            .subscribe(() => {
            console.info("Email sent to ACEP Finance about Net Terms Approval");
            this.globaldomops.hidewait();
            this.termsSubmitted = true;
        });
        // this.globaldataops.LogError(this.ssosvc.contactid, errorContent).subscribe(() => { console.info('Error Logged'); this.globaldomops.hidewait(); });
    }
    initiatePayPal(clientId) {
        const paypalScriptElement = this.document.createElement('script');
        paypalScriptElement.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&intent=authorize&disable-funding=credit,card`;
        paypalScriptElement.id = 'paypal-script';
        this.document.head.appendChild(paypalScriptElement);
        return fromEvent(paypalScriptElement, 'load').pipe(first());
    }
    removePayPal() {
        const paypalScriptElement = this.document.getElementById('paypal-script');
        this.document.head.removeChild(paypalScriptElement);
    }
}
PaymentService.ɵfac = function PaymentService_Factory(t) { return new (t || PaymentService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.GlobalDataOpsService), ɵngcc0.ɵɵinject(ɵngcc2.GlobalDomOpsService), ɵngcc0.ɵɵinject(ɵngcc2.AcepSSOService), ɵngcc0.ɵɵinject(ɵngcc2.CommonOperationsService), ɵngcc0.ɵɵinject(DOCUMENT)); };
PaymentService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PaymentService, factory: PaymentService.ɵfac });
PaymentService.ctorParameters = () => [
    { type: HttpClient },
    { type: GlobalDataOpsService },
    { type: GlobalDomOpsService },
    { type: AcepSSOService },
    { type: CommonOperationsService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaymentService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.GlobalDataOpsService }, { type: ɵngcc2.GlobalDomOpsService }, { type: ɵngcc2.AcepSSOService }, { type: ɵngcc2.CommonOperationsService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class PaymentComponent {
    constructor(paymentservice, globaldataops, globaldomops, ssosvc) {
        this.paymentservice = paymentservice;
        this.globaldataops = globaldataops;
        this.globaldomops = globaldomops;
        this.ssosvc = ssosvc;
        this.savedpaymenttypes_cc = [];
        this.savedpaymenttypes_ecp = [];
        this.numberofinstallments = 1;
        this.promocodevalid = false;
        this.summaryValid = true;
        this.checkText = `Please Note: Auto Renewals and Installments are not allowed with Check mode of payment.`;
        this.ccEmailTooltipText = `Enter a secondary email address to send a copy of the receipt for this transaction`;
        this.paymentOptionLabel = "Payment Option";
        this.validateOrderErrorResponse = '';
        this.promocode$ = new Subject();
        //pga: Coding-8830 Subscription for auto renewal change
        this.paymentEvents = new Subject();
        this.InstallmentType = InstallmentType;
        this.PaymentType = PaymentType;
        this.CardType = CardType;
        this.CardHolderType = CardHolderType;
        this.OrderTypeCode = OrderTypeCode;
        //OUTPUT PROPERTIES
        //UPDATE PAYMENT SUMMARY//
        this.updatePaymentSummary = new EventEmitter();
        //ORDER PROCESSED
        this.OrderProcessingCompleted = new EventEmitter();
    }
    get isECommerce() {
        return this.od.OrderTypeCode == 'ECOM';
    }
    get isMembershipIndividual() {
        return this.od.OrderTypeCode == (OrderTypeCode[OrderTypeCode.MembershipIndividual]).toString();
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.paymentservice.removePayPal();
        this.promocode$.unsubscribe();
        //pga: Coding-8830 unsubscribe for auto renewal change
        this.paymentEvents.unsubscribe();
    }
    initPaymentComponent() {
        let thisSvc = this;
        //order details//
        this.od = this.paymentservice.orderdetails;
        //this.od.PaymentInformation = new PaymentDetails();
        //payment details//
        //this.pd = this.od.PaymentInformation;
        this.initTerms();
        this.maskedccnum = this.paymentservice.MaskCreditCardNumber(this.od.PaymentInformation.CreditCardNumber);
        //console.log('payment ngOnInit');
        // if (this.pconfig.AUTOUPDATETAXES && this.od.PromoCode != '') {
        //     this.ApplyPromoCode();
        // }
        // if (this.pconfig.SHOWSAVEDPAYMENTTYPES && this.ssosvc.contactid != '') {
        //      this.globaldomops.continueToWait = true;
        //     this.paymentservice.GetPaymentMethods().subscribe((response) => {
        //         this.savedpaymenttypes = this.paymentservice.savedpaymenttypes;
        //     },
        //         error => {
        //         },
        //         () => {
        //         }
        //     );
        // }
        if (this.ssosvc.contactid != "") {
            // //GET UI DATA
            this.paymentservice.GetUIDataForShoppingCart().subscribe(() => {
                this.termsaddresscomponent.initdata();
                if (!!this.shippingaddresscomponent) {
                    this.shippingaddresscomponent.initdata();
                }
            });
            this.validateOrder();
        }
        //pga: Coding-3734 Set autorenewal to default and change installent label
        if (this.isMembershipIndividual) {
            this.od.PaymentInformation.AutoRenewal = 'true';
            this.pconfig.INSTALLMENTSLABEL = this.paymentOptionLabel;
        }
        //pga: Coding-8830 Subscription for auto renewal set
        this.paymentEvents.next({ autoRenewal: this.od.PaymentInformation.AutoRenewal });
    }
    validateOrder() {
        this.paymentservice.ValidateOrder().subscribe(response => {
            //Update Promo Code Stuff
            if (this.od.PromoCode != "") {
                this.ApplyPromoCodeResponse(response);
            }
            this.ApplyMissingInfoFromValidatePayloadResponse(response);
            //Saved payment Methods
            this.savedpaymenttypes_cc = this.paymentservice.savedpaymenttypes.filter(a => a.CardType != CardType.ECP);
            this.savedpaymenttypes_ecp = this.paymentservice.savedpaymenttypes.filter(a => a.CardType == CardType.ECP);
            this.initShippingAddressComponent(response);
            //payment ui config//
            this.pconfig = this.paymentservice.paymentuiconfig;
            //paypal
            this.initPaypal();
            //Promo code
            this.initPromoCode();
            console.log("payment ngAfterViewInit");
            this.globaldomops.hideWaitIfNoXHRInProgress();
            this.paymentservice.InitPlugins();
            this.paymentservice.payloadValid$.next(true);
        }, error => {
            //VALIDATION FAILED//
            if (error.status != 420) {
                this.validateOrderErrorResponse = "Payment Configuration Invalid";
                this.globaldomops.notify(this.validateOrderErrorResponse, "", "error");
            }
            else {
                this.validateOrderErrorResponse = error.statusText;
            }
            this.paymentservice.payloadValid$.next(false);
        }, () => { });
    }
    initShippingAddressComponent(response) {
        var _a;
        if (!!this.shippingaddresscomponent && ((_a = this.shippingaddresscomponent.addresses) === null || _a === void 0 ? void 0 : _a.length) == 0 && this.isECommerce) {
            let existingAddresses = response.existingAddresses;
            let address = existingAddresses[0]; // response.shippingAddress;
            this.od.ShippingAddress = address;
            this.od.ExisitngAddresses = existingAddresses;
            if (!!address) {
                this.shippingaddresscomponent.address = address;
                this.shippingaddresscomponent.addresses = existingAddresses;
                if (this.isECommerce) {
                    this.summaryValid = address.country == 'US';
                    this.updatePaymentSummary.emit(this.pconfig.PAYMENTSUMMARY);
                }
                this.shippingaddresscomponent.initdata();
            }
        }
    }
    initTerms() {
        if (this.isECommerce) {
            this.loadTermsHtml(`https://acep-assets.s3.amazonaws.com/waivers/acep+store+terms+and+conditions.docx`);
        }
    }
    //Used for Member App etc where validateorder calls are not needed
    initPaymentComponentExternal(response) {
        //order details//
        this.od = this.paymentservice.orderdetails;
        this.maskedccnum = this.paymentservice.MaskCreditCardNumber(this.od.PaymentInformation.CreditCardNumber);
        if (this.od.PromoCode != "") {
            this.ApplyPromoCodeResponse(response);
        }
        this.ApplyMissingInfoFromValidatePayloadResponse(response);
        //Saved payment Methods
        this.savedpaymenttypes_cc = this.paymentservice.savedpaymenttypes.filter(a => a.CardType != CardType.ECP);
        this.savedpaymenttypes_ecp = this.paymentservice.savedpaymenttypes.filter(a => a.CardType == CardType.ECP);
        //payment ui config//
        this.pconfig = this.paymentservice.paymentuiconfig;
        //paypal
        this.initPaypal();
        //Promo code
        this.initPromoCode();
        console.log("payment ngAfterViewInit");
        this.globaldomops.hideWaitIfNoXHRInProgress();
        this.paymentservice.InitPlugins();
        //pga: Coding-3734 Set autorenewal to default and change installent label
        if (this.isMembershipIndividual) {
            this.od.PaymentInformation.AutoRenewal = 'true';
            this.pconfig.INSTALLMENTSLABEL = this.paymentOptionLabel;
        }
        //pga: Coding-8830 Subscription for auto renewal set
        this.paymentEvents.next({ autoRenewal: this.od.PaymentInformation.AutoRenewal });
    }
    initPromoCode() {
        this.promocode$.pipe(
        // debounceTime(1000)
        ).subscribe(() => {
            if (!!this.od.PromoCode) {
                this.ApplyPromoCode();
            }
        });
    }
    ngAfterViewInit() {
        //Only run applypromocode automatically if payment control is on same screen as shopping cart..if not..applypromocode will be run as a service
    }
    onPaymentTypeChange() {
        //console.log(this.od.PaymentInformation.PaymentType);
        this.paymentservice.orderdetails.PaymentInformation.PayPalToken = '';
        this.paymentservice.orderdetails.PaymentInformation.PaymentType = this.od.PaymentInformation.PaymentType;
        if (this.od.PaymentInformation.PaymentType == PaymentType.Check) {
            this.pconfig.LOCKINSTALLMENTS = true;
            this.od.PaymentInformation.AutoRenewal = "false";
            this.od.PaymentInformation.InstallmentType = "" + InstallmentType.Annual;
            if (this.pconfig.SHOWAUTORENEWAL || this.pconfig.SHOWINSTALLMENTS) {
                this.globaldomops.notify(this.checkText, "", "warning");
            }
        }
        else if (this.od.PaymentInformation.PaymentType == PaymentType.PayPal) {
            //PayPal
        }
        else {
            this.pconfig.LOCKINSTALLMENTS = false;
        }
    }
    RefreshPayPalAvailability(formUpdated = false) {
        this.pconfig.SHOWPAYPAL = this.pconfig.ALLOW_PAYPAL && this.od.PaymentInformation.InstallmentType == InstallmentType.Annual && this.od.PaymentInformation.AutoRenewal == 'false';
        // if (!this.paymentservice.paymentuiconfig.ALLOW_PAYPAL && !this.paymentservice.paymentuiconfig.ALLOW_CHECKS && !this.paymentservice.paymentuiconfig.ALLOW_CREDITTERMS) {
        //   this.od.PaymentInformation.PaymentType = PaymentType.CreditCard;
        // }
        if (formUpdated) {
            this.od.PaymentInformation.PaymentType = "3";
        }
    }
    changeAutoRenewal() {
        this.RefreshPayPalAvailability(true);
        //pga: Coding-8830 Subscription for auto renewal change
        this.paymentEvents.next({ autoRenewal: this.od.PaymentInformation.AutoRenewal });
    }
    changeInstallment(fromInstallmentControl = true) {
        if (this.od.PaymentInformation.InstallmentType == InstallmentType.Monthly) {
            this.numberofinstallments = 12;
            //pga: Coding-3739 Set Autorenewal true for Monthly
            if (this.isMembershipIndividual) {
                this.od.PaymentInformation.AutoRenewal = 'true';
            }
        }
        else if (this.od.PaymentInformation.InstallmentType == InstallmentType.Quarterly) {
            this.numberofinstallments = 4;
            //pga: Coding-3739 Set Autorenewal true for Quarterly
            if (this.isMembershipIndividual) {
                this.od.PaymentInformation.AutoRenewal = 'true';
            }
        }
        else if (this.od.PaymentInformation.InstallmentType == InstallmentType.SemiAnnual) {
            this.numberofinstallments = 2;
            //pga: Coding-3739 Set Autorenewal true for SemiAnnual
            if (this.isMembershipIndividual) {
                this.od.PaymentInformation.AutoRenewal = 'true';
            }
        }
        else {
            this.numberofinstallments = 1;
        }
        if (fromInstallmentControl) {
            this.RefreshPayPalAvailability(true);
        }
    }
    ApplyPromoCode() {
        // this.globaldomops.showwait();
        this.paymentservice.ApplyPromoCode().subscribe(response => {
            this.ApplyPromoCodeResponse(response);
        }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            this.globaldomops.notify("Promo Code Could not apply!!", "", "error");
            //  this.globaldomops.hidewait();
        }, () => {
            //   this.globaldomops.hidewait();
        });
    }
    RemovePromoCode() {
        this.od.PromoCode = '';
        this.pconfig.SHOWTRIALMEMBERSHIP = false;
        this.pconfig.LOCKAUTORENEWAL = false;
        this.ApplyPromoCode();
    }
    PlaceOrder() {
        this.od.ShippingAddress = !!(this.shippingaddresscomponent) ? this.shippingaddresscomponent.address : new ShippingAddress();
        this.paymentservice.PlaceOrder().subscribe(response => {
            let orderid = response.body;
            this.paymentservice.orderdetails.OrderId = this.od.OrderId = orderid;
            this.OrderProcessingCompleted.emit(orderid);
        }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            this.OrderProcessingCompleted.emit("");
            //pga: coding-4139 & 3991 Changing the way to read the error message as the information is not receiving in _body object
            let errortext = "Order Processing Failed!!";
            if (!!error._body) {
                errortext = error._body.trim();
            }
            else if (!!error.error.message) {
                errortext = error.error.message.trim();
            }
            else if (!!error.error) {
                errortext = error.error.trim();
            }
            //
            this.globaldomops.notify(errortext, "", "error");
            this.globaldomops.hidewait();
        }, () => {
            this.globaldomops.hideWaitIfNoXHRInProgress();
        });
    }
    SubmitNetTerms() {
        //Save Net Terms Address If Any
        this.paymentservice
            .UpdateNetTermsBillingAddress(this.termsaddresscomponent.address)
            .subscribe(res => { }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            let errortext = error._body != "" && error._body != null && error._body != undefined
                ? error._body.trim()
                : "Order Processing Failed!!";
            this.globaldomops.notify(errortext, "", "error");
            this.globaldomops.hidewait();
        }, () => {
            this.globaldomops.hideWaitIfNoXHRInProgress();
        });
    }
    UpdatePaymentInfoInShoppingCart(selectedpaytype) {
        this.od.PaymentInformation.ProfileId = selectedpaytype.ProfileId;
        this.od.PaymentInformation.ProfileActionType =
            selectedpaytype.ProfileActionType;
        this.od.PaymentInformation.SaveCC = selectedpaytype.SaveCC;
        this.od.PaymentInformation.BusinessName = selectedpaytype.BusinessName;
        this.od.PaymentInformation.CCExpirationDate =
            selectedpaytype.CCExpirationDate;
        this.od.PaymentInformation.CreditCardNumber =
            selectedpaytype.CreditCardNumber;
        this.od.PaymentInformation.CVV = selectedpaytype.CVV;
        this.od.PaymentInformation.CardType = selectedpaytype.CardType;
        this.od.PaymentInformation.CardHolderType = selectedpaytype.CardHolderType;
        this.od.PaymentInformation.NameOnCard = selectedpaytype.NameOnCard;
        this.od.PaymentInformation.PostalCode = selectedpaytype.PostalCode;
        this.od.PaymentInformation.ECPAccountRT = selectedpaytype.ECPAccountRT;
        this.od.PaymentInformation.ECPAccountDDA = selectedpaytype.ECPAccountDDA;
        this.od.PaymentInformation.ECPAccountType = selectedpaytype.ECPAccountType;
        this.paymentservice.orderdetails.PaymentInformation = this.od.PaymentInformation;
        this.maskedccnum = this.paymentservice.MaskCreditCardNumber(this.od.PaymentInformation.CreditCardNumber);
    }
    SynchDataFromChildComponents() {
        this.UpdatePaymentInfoInShoppingCart(this.od.PaymentInformation.PaymentType == PaymentType.CreditCard ? this.managecreditcardscomponent.selectedpaytype : this.manageecp.selectedpaytype);
    }
    ApplyPromoCodeResponse(response) {
        this.pconfig.PAYMENTSUMMARY = {
            TOTALDISCOUNT: response.totalDiscount,
            TOTALSHIPPING: response.totalShipping,
            TOTALTAXES: response.totalTaxes,
            TOTALAMOUNTWITHTAXESANDDISCOUNTS: response.totalAmount,
            PROMOCODEMESSAGE: response.promoMsg
        };
        if (response.totalAmount == 0) {
            this.od.PaymentInformation.AutoRenewal = "false";
            this.pconfig.SHOWAUTORENEWAL = false;
        }
        this.promocodevalid = response.promoCodeValid;
        if (response.promoCodeValid) {
            this.pconfig.SHOWPROMOCODEAPPLIED && this.globaldomops.notify("Promo Code Applied!!");
            // do not update prices on trial membership as return amount is 0 ( however, that is a promotion for current and not future and we sstill need to show the future prices)
            this.changeInstallment(false);
            //trial membership
            //debugger;
            this.paymentservice.ApplyTrialMembershipChanges(this.pconfig, response);
        }
        else {
            if (!!this.od.PromoCode) {
                this.globaldomops.notify(`Invalid ${this.paymentservice.paymentuiconfig.PRMOCODELABEL}: ${this.od.PromoCode}`, "", "error");
            }
            this.pconfig.PAYMENTSUMMARY.PROMOCODEMESSAGE = response.promoMsg + ": " + this.od.PromoCode;
            this.od.PromoCode = "";
        }
        //EMIT THE updatePaymentSummary event so that App Component can update its UI//
        this.updatePaymentSummary.emit(this.pconfig.PAYMENTSUMMARY);
    }
    updateShippingRates(_address) {
        this.od.ShippingAddress = _address;
        this.summaryValid = this.isECommerce && _address.country == 'US';
        this.updatePaymentSummary.emit(this.pconfig.PAYMENTSUMMARY);
        this.validateOrder();
    }
    getAutoRenewalInfoText() {
        let s = '';
        if (!!this.pconfig.AUTORENEWALINFOLABEL) {
            s = this.pconfig.AUTORENEWALINFOLABEL;
        }
        else if (this.pconfig.SHOWTRIALMEMBERSHIP) {
            s = "Easily renew your membership or subscription using your saved payment method.&lt;br&gt;&lt;br&gt;Auto renewal is required for monthly and trial memberships and subscriptions.";
        }
        else if (this.isMembershipIndividual) {
            s = "Members who select monthly, quarterly or semi-annual payment options are enrolled in the auto renewal program.";
        }
        else {
            s = "Your membership or subscription will automatically renew one year from the date of purchase if this box is selected.";
        }
        return s;
    }
    ApplyMissingInfoFromValidatePayloadResponse(response) {
        let lineitems = response.orderLineItems;
        for (let i in lineitems) {
            //unit price
            if (this.od.orderLineItems[i].UnitPrice == "" ||
                this.od.orderLineItems[i].UnitPrice == "0" ||
                this.od.orderLineItems[i].UnitPrice == 0) {
                this.od.orderLineItems[i].UnitPrice = lineitems[i].unitPrice;
            }
            //product name
            if (this.od.orderLineItems[i].ProductName == "") {
                this.od.orderLineItems[i].ProductName = lineitems[i].productName;
            }
        }
        this.paymentservice.orderdetails.orderLineItems = this.od.orderLineItems;
        //if total amount is 0..happens because no promo code and the unit price was not passed in payload
        // if(response.totalAmount == 0)
        // {
        //     this.paymentservice.GetTotalPriceFromLineItems();
        //     this.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS = this.paymentservice.orderdetails.PaymentInformation.Amount = this.paymentservice.orderdetails.TotalAmount;
        // }
        this.od.TotalAmount = this.od.PaymentInformation.Amount = this.paymentservice.GetTotalPriceFromLineItems();
        //group portal
        if (this.od.OrderTypeCode == (OrderTypeCode[OrderTypeCode.MembershipGroup]).toString()) {
            response.totalAmount = this.od.TotalAmount;
        }
        this.pconfig.PAYMENTSUMMARY = {
            TOTALDISCOUNT: response.totalDiscount == null ? 0 : response.totalDiscount,
            TOTALSHIPPING: response.totalShipping == null ? 0 : response.totalShipping,
            TOTALTAXES: response.totalTaxes == null ? 0 : response.totalTaxes,
            TOTALAMOUNTWITHTAXESANDDISCOUNTS: response.totalAmount,
            PROMOCODEMESSAGE: response.promoMsg
        };
        this.od.TotalShipping = this.pconfig.PAYMENTSUMMARY.TOTALSHIPPING;
        this.od.AllowShipping = response.allowShipping;
        //debugger;
        //if trial membership..the total discount is the price that needs to be shown
        //this.paymentservice.ApplyTrialMembershipChanges(this.pconfig, this.od);
        if (this.pconfig.SHOWTRIALMEMBERSHIP) {
            this.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS =
                this.pconfig.PAYMENTSUMMARY.TOTALDISCOUNT;
        }
        this.paymentservice.paymentuiconfig.PAYMENTSUMMARY = this.pconfig.PAYMENTSUMMARY;
        //IF aito renewal si locked and shown from validate promocode response..then it shud be set as true
        if (this.paymentservice.paymentuiconfig.LOCKAUTORENEWAL &&
            this.paymentservice.paymentuiconfig.SHOWAUTORENEWAL) {
            this.od.PaymentInformation.AutoRenewal = this.paymentservice.orderdetails.PaymentInformation.AutoRenewal =
                "true";
        }
        this.updatePaymentSummary.emit(this.pconfig.PAYMENTSUMMARY);
    }
    showterms() {
        let termsModal = $("[data-remodal-id=termsModal]").remodal();
        termsModal.open();
    }
    loadTermsHtml(url) {
        let html = '';
        if (url !== undefined) {
            const source = url;
            const x = 'https://view.officeapps.live.com/op/embed.aspx?src=' + url;
            // 'http://docs.google.com/gview?url=' + url + '&embedded=true';
            html = '<iframe id="termsframeid" style="border: 1px solid gray; min-width: 200px; width:100%; height:350px" src="' + x + '"></iframe>';
            this.terms.nativeElement.innerHTML = html;
        }
        else {
            html = `<div>no document located at ${url}</div>`;
            this.terms.nativeElement.innerHTML = html;
        }
    }
    validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    initPaypal() {
        let thisSvc = this;
        let clientId = this.globaldataops.isTestEnvironment() ? 'AZRW893pZiGYlLPH90wXVSKFaEMHHF4D7VuQy13S0RQz9AaGd93jRUCxPjRE_xh4iAFfXjktkaEzeuxH' :
            'AcPoh-gqcFu3RhtkyWM4Pof6m2TmyyeOxXQnsYH0g4on1tWNrI71GoMB7h6EiNS78q63jwypVdgB0Dj2';
        //var paypalActions;
        var PAYPAL_ACTIONSTATUS;
        this.RefreshPayPalAvailability();
        this.paymentservice.initiatePayPal(clientId).subscribe(() => paypal.Buttons({
            style: {
                layout: 'horizontal',
                color: 'blue',
                shape: 'rect',
                label: 'checkout'
            },
            onInit: function (data, actions) {
                //  actions.disable();
                PAYPAL_ACTIONSTATUS = actions;
            },
            // Called when page displays
            // validate: function (actions) {
            //   console.log("validate called");
            //   actions.disable(); // Allow for validation in onClick()
            //   paypalActions = actions; // Save for later enable()/disable() calls
            // },
            onClick: function (e) {
                console.log('onClick called');
                // Handle validation errors
                if (!thisSvc.globaldomops.CheckValidations(e)) {
                    PAYPAL_ACTIONSTATUS.disable();
                    return false;
                }
                PAYPAL_ACTIONSTATUS.enable();
            },
            onCancel: function (data) {
                // Show a cancel page, or return to cart
                thisSvc.globaldomops.hidewait();
            },
            createOrder: (data, actions) => {
                thisSvc.globaldomops.showwait();
                return actions.order.create({
                    commit: false,
                    application_context: {
                        shipping_preference: 'NO_SHIPPING'
                    },
                    purchase_units: [
                        {
                            description: this.ssosvc.acepid,
                            amount: {
                                currency_code: 'USD',
                                value: parseFloat(thisSvc.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS).toFixed(2) // thisSvc.paymentservice.orderdetails.TotalAmount
                            }
                        }
                    ]
                });
            },
            onApprove: (data, actions) => __awaiter(this, void 0, void 0, function* () {
                actions.order.authorize().then(function (authorization) {
                    // Get the authorization id
                    var authorizationID = authorization.purchase_units[0].payments.authorizations[0].id;
                    // console.log('You have authorized this transaction. Order ID:  ' + data.orderID + ', Authorization ID: ' + authorizationID); //
                    thisSvc.paymentservice.orderdetails.PaymentInformation.PayPalToken = authorizationID; //data.orderID; // authorizationID;
                    thisSvc.PlaceOrder();
                });
                return actions.order.capture().then(function (details) {
                    // thisSvc.paymentservice.orderdetails.PaymentInformation.PayPalToken = details.id; // data.orderID; // authorizationID;
                    // thisSvc.PlaceOrder();
                });
                actions.order.cancel().then(function (details) {
                    thisSvc.globaldomops.hidewait();
                });
            })
        }).render(thisSvc.paymentservice.paypalElement.nativeElement));
    }
}
PaymentComponent.ɵfac = function PaymentComponent_Factory(t) { return new (t || PaymentComponent)(ɵngcc0.ɵɵdirectiveInject(PaymentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AcepSSOService)); };
PaymentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PaymentComponent, selectors: [["payment"]], viewQuery: function PaymentComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
        ɵngcc0.ɵɵviewQuery(_c1, true);
        ɵngcc0.ɵɵviewQuery(_c2, true);
        ɵngcc0.ɵɵviewQuery(_c3, true);
        ɵngcc0.ɵɵviewQuery(_c4, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.managecreditcardscomponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.manageecp = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.termsaddresscomponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.shippingaddresscomponent = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.terms = _t.first);
    } }, inputs: { od: "od", pconfig: "pconfig" }, outputs: { updatePaymentSummary: "updatePaymentSummary", OrderProcessingCompleted: "OrderProcessingCompleted" }, ngContentSelectors: _c6, decls: 290, vars: 174, consts: [[1, "f100", "clear"], [1, "r33", "rightCol"], ["id", "summary-box", 1, "cartSummary_wrap"], [1, "cartSummary_ban"], [1, "cartSummary_box"], ["class", "f100 clear", 4, "ngFor", "ngForOf"], ["class", "f100 clear", 4, "ngIf"], [1, "f100", "clear", 3, "hidden"], [1, "l67"], [1, "r33"], [1, "bold"], [1, "f100", "tax", "clear"], [1, "f100", "tax", "clear", 3, "hidden"], ["id", "installmentCtr", 3, "hidden"], [1, "cartTotal_ban", "clear"], [1, "l67", "leftCol"], ["id", "paymentcontrolcontainer"], [1, "optionbtn", "promoCodebtn", "trialMembCtr"], [1, "trialMbrWrapper"], [1, "wrapperAmount"], [1, "validationwrap"], [1, "validationhead"], [1, "radioBlock", "cartInstallments", "clear"], ["type", "radio", "name", "installments", "id", "Monthly", "required", "required", 3, "value", "ngModel", "disabled", "ngModelChange"], ["for", "Monthly"], [1, "installmentWrapper"], [1, "installmentAmount"], ["type", "radio", "name", "installments", "id", "Quarterly", "required", "required", 3, "value", "ngModel", "disabled", "ngModelChange"], ["for", "Quarterly"], ["type", "radio", "name", "installments", "id", "SemiAnnual", "required", "required", 3, "value", "ngModel", "disabled", "ngModelChange"], ["for", "SemiAnnual"], ["type", "radio", "name", "installments", "id", "NoInstallments", "required", "required", 3, "value", "ngModel", "ngModelChange"], ["for", "NoInstallments"], [1, "l50"], [1, "fl_wrap"], [1, "r50"], [1, "autorenewalWrapper"], [1, "fa", "fa-info-circle"], [1, "tooltiptext", 3, "innerHTML"], ["type", "radio", "name", "AutoRenewal", "id", "AutoRenewal-Yes", "value", "true", 3, "ngModel", "disabled", "ngModelChange"], ["autorenewYes", ""], ["for", "AutoRenewal-Yes"], ["type", "radio", "name", "AutoRenewal", "id", "AutoRenewal-No", "value", "false", 3, "ngModel", "disabled", "ngModelChange"], ["for", "AutoRenewal-No"], [1, "f100", "clear", "autorenewaldetails", 3, "hidden"], [3, "hidden", "updateShippingRates"], ["shippingaddress", ""], [3, "hidden"], ["id", "promoCode", 1, "f100", "clear", 3, "hidden"], [1, "f100", "PromotionCode", "clear"], [1, "fl_label"], ["type", "text", "id", "PromoCode", 3, "ngModel", "disabled", "ngModelChange", "focusout"], ["promo", ""], [1, "promocodemsg", 3, "hidden"], ["class", "optionbtn promoCodebtn", 3, "disabled", "click", 4, "ngIf"], [3, "hidden", "click"], ["id", "paymentcontrol", 1, "f100", "radioWrap", "clear", 3, "hidden"], ["class", "f100 clear payment_ach_header", 3, "innerHTML", 4, "ngIf"], [1, "validationhead", 3, "hidden"], [1, "paymentcontrol-block", "paymentcontrol-cc", "paymentcontrol-ecp", 3, "hidden"], ["type", "radio", "id", "PaymentType-ECP", "name", "PaymentType", "title", "ECP", "required", "required", 3, "value", "ngModel", "change", "ngModelChange"], ["for", "PaymentType-ECP"], ["id", "ccOptions", 1, "f100", "clear", "ccdetails", "paymentcontrol-content", 3, "hidden"], [3, "savedpaymenttypes", "paymentSpecifications"], ["manageecp", ""], [1, "paymentcontrol-block", "paymentcontrol-cc", 3, "hidden"], ["type", "radio", "id", "PaymentType-Card", "name", "PaymentType", "title", "Credit Card", "required", "required", 3, "value", "ngModel", "change", "ngModelChange"], ["for", "PaymentType-Card"], [3, "paymentSpecifications", "savedpaymenttypes"], ["managecreditcards", ""], [1, "paymentcontrol-block", "paymentcontrol-ch", 3, "hidden"], ["type", "radio", "id", "PaymentType-Check", "name", "PaymentType", "title", "Check", "required", "required", 3, "value", "ngModel", "change", "ngModelChange"], ["for", "PaymentType-Check"], [1, "checkdetails", "paymentcontrol-content", 3, "hidden"], [1, "f100", "clear", 3, "innerHTML"], [1, "alert", "alert-info"], [4, "ngIf", "ngIfElse"], ["check_NotMembership", ""], [4, "ngIf"], [1, "paymentcontrol-block", "paymentcontrol-pp", 3, "hidden"], ["type", "radio", "id", "PaymentType-PayPal", "name", "PaymentType", "title", "PayPal", "required", "required", 3, "value", "ngModel", "change", "ngModelChange"], ["for", "PaymentType-PayPal"], [1, "paymentcontrol-block", "paymentcontrol-terms", 3, "hidden"], ["type", "radio", "id", "PaymentType-CreditTerms", "name", "PaymentType", "title", "CreditTerms", "required", "required", 3, "value", "ngModel", "change", "ngModelChange"], ["for", "PaymentType-CreditTerms"], [1, "termsdetails", "paymentcontrol-content", 3, "hidden"], ["type", "text", "id", "ponumber", "maxlength", "50", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["nettermsaddress", ""], ["id", "ccemailCtr", 1, "f100", "clear"], [1, "ccemailWrapper"], [1, "tooltiptext"], ["for", "ccemail", 1, "fl_label"], ["name", "ccemail", "type", "email", "id", "ccemail", "maxlength", "50", "attr.data-validate", "true", "autocomplete", "nope", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["alternateemail", ""], [1, "f100", "clear", "termsCtr", 3, "hidden"], [1, "terms"], ["terms", ""], ["id", "agreeTC", 1, "checkboxWrap"], ["type", "checkbox", "id", "Terms-Yes", "name", "Terms-Yes", "required", "required"], ["for", "Terms-Yes", 4, "ngIf"], ["data-remodal-id", "termsModal", 1, "remodal"], ["data-remodal-action", "confirm", 1, "remodal-confirm"], ["data-remodal-id", "creditcardCVV", 1, "remodal"], [1, "cvvDT"], [1, "cvvMB"], ["class", "autorenewalflag", 4, "ngIf"], [1, "autorenewalflag"], ["target", "_blank", "href", "https://webapps.acep.org/membership/account/#/messageus?org=ACEP&url=https:%2F%2Fwww.acep.org%2Fstore%2F"], [1, "optionbtn", "promoCodebtn", 3, "click"], [1, "f100", "clear", "payment_ach_header", 3, "innerHTML"], ["for", "Terms-Yes"], [3, "click"]], template: function PaymentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c5);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4, " Summary ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, PaymentComponent_div_6_Template, 9, 9, "div", 5);
        ɵngcc0.ɵɵtemplate(7, PaymentComponent_div_7_Template, 8, 6, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "p");
        ɵngcc0.ɵɵtext(11, "Discount");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelementStart(13, "p", 10);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 11);
        ɵngcc0.ɵɵelementStart(17, "div", 8);
        ɵngcc0.ɵɵelementStart(18, "p");
        ɵngcc0.ɵɵtext(19, "Tax");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 9);
        ɵngcc0.ɵɵelementStart(21, "p", 10);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 12);
        ɵngcc0.ɵɵelementStart(25, "div", 8);
        ɵngcc0.ɵɵelementStart(26, "p");
        ɵngcc0.ɵɵtext(27, "Shipping");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 9);
        ɵngcc0.ɵɵelementStart(29, "p", 10);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div");
        ɵngcc0.ɵɵelementStart(33, "div", 8);
        ɵngcc0.ɵɵtext(34, " Order Total ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 9);
        ɵngcc0.ɵɵtext(36);
        ɵngcc0.ɵɵpipe(37, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 13);
        ɵngcc0.ɵɵelementStart(39, "div", 3);
        ɵngcc0.ɵɵtext(40, " Installment ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "div", 4);
        ɵngcc0.ɵɵelementStart(42, "div", 0);
        ɵngcc0.ɵɵelementStart(43, "div", 8);
        ɵngcc0.ɵɵelementStart(44, "p");
        ɵngcc0.ɵɵtext(45, "Installment Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "div", 9);
        ɵngcc0.ɵɵelementStart(47, "p", 10);
        ɵngcc0.ɵɵtext(48);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "div", 0);
        ɵngcc0.ɵɵelementStart(50, "div", 8);
        ɵngcc0.ɵɵelementStart(51, "p");
        ɵngcc0.ɵɵtext(52, "Number of Installments");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "div", 9);
        ɵngcc0.ɵɵelementStart(54, "p", 10);
        ɵngcc0.ɵɵtext(55);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(56, "div", 0);
        ɵngcc0.ɵɵelementStart(57, "div", 8);
        ɵngcc0.ɵɵelementStart(58, "p");
        ɵngcc0.ɵɵtext(59, "Each Installment Amount");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(60, "div", 9);
        ɵngcc0.ɵɵelementStart(61, "p", 10);
        ɵngcc0.ɵɵtext(62);
        ɵngcc0.ɵɵpipe(63, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(64, "div", 14);
        ɵngcc0.ɵɵelementStart(65, "div", 8);
        ɵngcc0.ɵɵtext(66, " Paying Now ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(67, "div", 9);
        ɵngcc0.ɵɵtext(68);
        ɵngcc0.ɵɵpipe(69, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(70, "div", 0);
        ɵngcc0.ɵɵelementStart(71, "div", 8);
        ɵngcc0.ɵɵelementStart(72, "p");
        ɵngcc0.ɵɵtext(73, "Amount to be paid later");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(74, "div", 9);
        ɵngcc0.ɵɵelementStart(75, "p", 10);
        ɵngcc0.ɵɵtext(76);
        ɵngcc0.ɵɵpipe(77, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(78, "div", 15);
        ɵngcc0.ɵɵelementStart(79, "div", 16);
        ɵngcc0.ɵɵelementStart(80, "div", 7);
        ɵngcc0.ɵɵelementStart(81, "h3");
        ɵngcc0.ɵɵtext(82, "Trial Membership");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "div", 17);
        ɵngcc0.ɵɵelementStart(84, "span", 18);
        ɵngcc0.ɵɵtext(85);
        ɵngcc0.ɵɵelement(86, "br");
        ɵngcc0.ɵɵelementStart(87, "span", 19);
        ɵngcc0.ɵɵtext(88, "FREE");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(89, "div", 7);
        ɵngcc0.ɵɵelementStart(90, "h3");
        ɵngcc0.ɵɵtext(91);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(92, "div", 20);
        ɵngcc0.ɵɵelementStart(93, "p", 21);
        ɵngcc0.ɵɵtext(94, "Please select one installment type from the following:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(95, "div", 22);
        ɵngcc0.ɵɵelementStart(96, "input", 23);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_96_listener($event) { return ctx.od.PaymentInformation.InstallmentType = $event; })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_96_listener() { return ctx.changeInstallment(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(97, "label", 24);
        ɵngcc0.ɵɵelementStart(98, "span", 25);
        ɵngcc0.ɵɵtext(99, "Monthly ");
        ɵngcc0.ɵɵelement(100, "br");
        ɵngcc0.ɵɵelementStart(101, "span", 26);
        ɵngcc0.ɵɵtext(102);
        ɵngcc0.ɵɵpipe(103, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(104, "input", 27);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_104_listener($event) { return ctx.od.PaymentInformation.InstallmentType = $event; })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_104_listener() { return ctx.changeInstallment(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(105, "label", 28);
        ɵngcc0.ɵɵelementStart(106, "span", 25);
        ɵngcc0.ɵɵtext(107, "Quarterly ");
        ɵngcc0.ɵɵelement(108, "br");
        ɵngcc0.ɵɵelementStart(109, "span", 26);
        ɵngcc0.ɵɵtext(110);
        ɵngcc0.ɵɵpipe(111, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(112, "input", 29);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_112_listener($event) { return ctx.od.PaymentInformation.InstallmentType = $event; })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_112_listener() { return ctx.changeInstallment(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(113, "label", 30);
        ɵngcc0.ɵɵelementStart(114, "span", 25);
        ɵngcc0.ɵɵtext(115, "Semi-Annual ");
        ɵngcc0.ɵɵelement(116, "br");
        ɵngcc0.ɵɵelementStart(117, "span", 26);
        ɵngcc0.ɵɵtext(118);
        ɵngcc0.ɵɵpipe(119, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(120, "input", 31);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_120_listener($event) { return ctx.od.PaymentInformation.InstallmentType = $event; })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_120_listener() { return ctx.changeInstallment(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(121, "label", 32);
        ɵngcc0.ɵɵelementStart(122, "span", 25);
        ɵngcc0.ɵɵtext(123, "Annual ");
        ɵngcc0.ɵɵelement(124, "br");
        ɵngcc0.ɵɵelementStart(125, "span", 26);
        ɵngcc0.ɵɵtext(126);
        ɵngcc0.ɵɵpipe(127, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(128, "div", 7);
        ɵngcc0.ɵɵelementStart(129, "div", 33);
        ɵngcc0.ɵɵelementStart(130, "div", 34);
        ɵngcc0.ɵɵelementStart(131, "p");
        ɵngcc0.ɵɵelementStart(132, "label");
        ɵngcc0.ɵɵtext(133);
        ɵngcc0.ɵɵpipe(134, "currency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(135, "div", 35);
        ɵngcc0.ɵɵelement(136, "p");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(137, "div", 7);
        ɵngcc0.ɵɵelementStart(138, "div", 36);
        ɵngcc0.ɵɵelementStart(139, "h3");
        ɵngcc0.ɵɵtext(140);
        ɵngcc0.ɵɵelementStart(141, "i", 37);
        ɵngcc0.ɵɵelement(142, "span", 38);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(143, "div");
        ɵngcc0.ɵɵelementStart(144, "input", 39, 40);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_144_listener($event) { return ctx.od.PaymentInformation.AutoRenewal = $event; })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_144_listener() { return ctx.changeAutoRenewal(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(146, "label", 41);
        ɵngcc0.ɵɵtext(147, "Yes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(148, "input", 42);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_148_listener($event) { return ctx.od.PaymentInformation.AutoRenewal = $event; })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_148_listener() { return ctx.changeAutoRenewal(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(149, "label", 43);
        ɵngcc0.ɵɵtext(150, "No");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(151, "div", 44);
        ɵngcc0.ɵɵprojection(152);
        ɵngcc0.ɵɵtext(153);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(154, "app-shippingaddress", 45, 46);
        ɵngcc0.ɵɵlistener("updateShippingRates", function PaymentComponent_Template_app_shippingaddress_updateShippingRates_154_listener($event) { return ctx.updateShippingRates($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(156, PaymentComponent_div_156_Template, 7, 0, "div", 6);
        ɵngcc0.ɵɵelementStart(157, "div", 47);
        ɵngcc0.ɵɵelementStart(158, "div", 48);
        ɵngcc0.ɵɵelementStart(159, "h3");
        ɵngcc0.ɵɵtext(160);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(161, "div", 49);
        ɵngcc0.ɵɵelementStart(162, "div", 8);
        ɵngcc0.ɵɵelementStart(163, "div", 20);
        ɵngcc0.ɵɵelementStart(164, "div", 34);
        ɵngcc0.ɵɵelementStart(165, "label", 50);
        ɵngcc0.ɵɵtext(166);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(167, "input", 51, 52);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_167_listener($event) { return ctx.od.PromoCode = $event; })("focusout", function PaymentComponent_Template_input_focusout_167_listener($event) { return ctx.promocode$.next($event.target.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(169, "span", 53);
        ɵngcc0.ɵɵtext(170);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(171, "div", 9);
        ɵngcc0.ɵɵtemplate(172, PaymentComponent_a_172_Template, 2, 2, "a", 54);
        ɵngcc0.ɵɵelementStart(173, "a", 55);
        ɵngcc0.ɵɵlistener("click", function PaymentComponent_Template_a_click_173_listener() { return ctx.RemovePromoCode(); });
        ɵngcc0.ɵɵtext(174, "Remove Code");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(175, "div", 56);
        ɵngcc0.ɵɵelementStart(176, "h3");
        ɵngcc0.ɵɵtext(177);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(178, PaymentComponent_div_178_Template, 1, 1, "div", 57);
        ɵngcc0.ɵɵelementStart(179, "div", 20);
        ɵngcc0.ɵɵelementStart(180, "p", 58);
        ɵngcc0.ɵɵtext(181, "Choose Payment Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(182, "div", 59);
        ɵngcc0.ɵɵelementStart(183, "input", 60);
        ɵngcc0.ɵɵlistener("change", function PaymentComponent_Template_input_change_183_listener() { return ctx.onPaymentTypeChange(); })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_183_listener($event) { return ctx.od.PaymentInformation.PaymentType = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(184, "label", 61);
        ɵngcc0.ɵɵtext(185, "Bank Account");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(186, "div", 62);
        ɵngcc0.ɵɵelement(187, "manage-ecp", 63, 64);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(189, "div", 65);
        ɵngcc0.ɵɵelementStart(190, "input", 66);
        ɵngcc0.ɵɵlistener("change", function PaymentComponent_Template_input_change_190_listener() { return ctx.onPaymentTypeChange(); })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_190_listener($event) { return ctx.od.PaymentInformation.PaymentType = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(191, "label", 67);
        ɵngcc0.ɵɵtext(192, "Credit Card - Pay now using a credit card");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(193, "div", 62);
        ɵngcc0.ɵɵelement(194, "manage-creditcards", 68, 69);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(196, "div", 70);
        ɵngcc0.ɵɵelementStart(197, "input", 71);
        ɵngcc0.ɵɵlistener("change", function PaymentComponent_Template_input_change_197_listener() { return ctx.onPaymentTypeChange(); })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_197_listener($event) { return ctx.od.PaymentInformation.PaymentType = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(198, "label", 72);
        ɵngcc0.ɵɵtext(199, "Check");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(200, "div", 73);
        ɵngcc0.ɵɵprojection(201, 1);
        ɵngcc0.ɵɵelement(202, "div", 74);
        ɵngcc0.ɵɵelementStart(203, "div", 75);
        ɵngcc0.ɵɵtext(204, " After submitting your application, send a check or money order to: ");
        ɵngcc0.ɵɵelement(205, "br");
        ɵngcc0.ɵɵtemplate(206, PaymentComponent_div_206_Template, 7, 0, "div", 76);
        ɵngcc0.ɵɵtemplate(207, PaymentComponent_ng_template_207_Template, 6, 0, "ng-template", null, 77, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelement(209, "br");
        ɵngcc0.ɵɵelement(210, "br");
        ɵngcc0.ɵɵelementStart(211, "i");
        ɵngcc0.ɵɵtext(212, " Please write the ACEP ID ");
        ɵngcc0.ɵɵelementStart(213, "b", 10);
        ɵngcc0.ɵɵtext(214);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(215, " and ");
        ɵngcc0.ɵɵelementStart(216, "b");
        ɵngcc0.ɵɵtext(217);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(218, " on your check. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(219, "br");
        ɵngcc0.ɵɵelement(220, "hr");
        ɵngcc0.ɵɵelementStart(221, "b");
        ɵngcc0.ɵɵtemplate(222, PaymentComponent_i_222_Template, 2, 1, "i", 78);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(223, "div", 79);
        ɵngcc0.ɵɵelementStart(224, "input", 80);
        ɵngcc0.ɵɵlistener("change", function PaymentComponent_Template_input_change_224_listener() { return ctx.onPaymentTypeChange(); })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_224_listener($event) { return ctx.od.PaymentInformation.PaymentType = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(225, "label", 81);
        ɵngcc0.ɵɵtext(226, "PayPal");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(227, "div", 82);
        ɵngcc0.ɵɵelementStart(228, "input", 83);
        ɵngcc0.ɵɵlistener("change", function PaymentComponent_Template_input_change_228_listener() { return ctx.onPaymentTypeChange(); })("ngModelChange", function PaymentComponent_Template_input_ngModelChange_228_listener($event) { return ctx.od.PaymentInformation.PaymentType = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(229, "label", 84);
        ɵngcc0.ɵɵtext(230, "Purchase Order - Pay later by check or purchase order");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(231, "div", 85);
        ɵngcc0.ɵɵelementStart(232, "div", 7);
        ɵngcc0.ɵɵelementStart(233, "p");
        ɵngcc0.ɵɵtext(234, "Please enter your Purchase Order Details below:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(235, "div", 20);
        ɵngcc0.ɵɵelementStart(236, "div", 34);
        ɵngcc0.ɵɵelementStart(237, "label", 50);
        ɵngcc0.ɵɵtext(238, "PO Number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(239, "input", 86);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_239_listener($event) { return ctx.od.PaymentInformation.PONumber = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(240, "span", 21);
        ɵngcc0.ɵɵtext(241, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(242, "div", 7);
        ɵngcc0.ɵɵelementStart(243, "h4");
        ɵngcc0.ɵɵelementStart(244, "strong");
        ɵngcc0.ɵɵtext(245, "Application for Credit");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(246, "p");
        ɵngcc0.ɵɵtext(247, " Credit terms have not been approved for this account. Please provide the following information to apply for credit. After your application has been approved, you will be notified by email and you will need to return to complete the checkout process. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(248, "app-nettermsaddress", null, 87);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(250, "div", 88);
        ɵngcc0.ɵɵelementStart(251, "div", 89);
        ɵngcc0.ɵɵelementStart(252, "h3");
        ɵngcc0.ɵɵtext(253, "CC Email for Receipt ");
        ɵngcc0.ɵɵelementStart(254, "i", 37);
        ɵngcc0.ɵɵelementStart(255, "span", 90);
        ɵngcc0.ɵɵtext(256);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(257, "div", 20);
        ɵngcc0.ɵɵelementStart(258, "div", 34);
        ɵngcc0.ɵɵelementStart(259, "label", 91);
        ɵngcc0.ɵɵtext(260, "Enter email address");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(261, "input", 92, 93);
        ɵngcc0.ɵɵlistener("ngModelChange", function PaymentComponent_Template_input_ngModelChange_261_listener($event) { return ctx.od.CCEmail = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(263, "span", 21);
        ɵngcc0.ɵɵtext(264, "Please enter a valid email address");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(265, "div", 94);
        ɵngcc0.ɵɵelementStart(266, "h3");
        ɵngcc0.ɵɵtext(267, "Terms & Conditions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(268, "div", 95, 96);
        ɵngcc0.ɵɵelementStart(270, "div", 20);
        ɵngcc0.ɵɵelementStart(271, "div", 97);
        ɵngcc0.ɵɵelement(272, "input", 98);
        ɵngcc0.ɵɵtemplate(273, PaymentComponent_label_273_Template, 4, 1, "label", 99);
        ɵngcc0.ɵɵtemplate(274, PaymentComponent_label_274_Template, 2, 0, "label", 99);
        ɵngcc0.ɵɵelementStart(275, "span", 21);
        ɵngcc0.ɵɵtext(276, "Please agree to our Terms & Conditions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(277, "div", 100);
        ɵngcc0.ɵɵelementStart(278, "h1");
        ɵngcc0.ɵɵtext(279, "Terms & Conditions");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(280, "div", 74);
        ɵngcc0.ɵɵelementStart(281, "a", 101);
        ɵngcc0.ɵɵtext(282, "Okay");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(283, "div", 102);
        ɵngcc0.ɵɵelementStart(284, "h1");
        ɵngcc0.ɵɵtext(285, "Credit Card Verification Codes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(286, "div", 103);
        ɵngcc0.ɵɵelement(287, "div", 104);
        ɵngcc0.ɵɵelementStart(288, "a", 101);
        ɵngcc0.ɵɵtext(289, "Okay");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(145);
        const _r5 = ɵngcc0.ɵɵreference(168);
        const _r11 = ɵngcc0.ɵɵreference(208);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.od.orderLineItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.od.OrderTypeCode == ctx.OrderTypeCode[ctx.OrderTypeCode.MembershipGroup]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.PAYMENTSUMMARY.TOTALDISCOUNT == 0);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1("-", ɵngcc0.ɵɵpipeBind4(15, 114, ctx.pconfig.PAYMENTSUMMARY.TOTALDISCOUNT, "USD", "symbol-narrow", "1.2-2"), "");
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ctx.summaryValid ? ɵngcc0.ɵɵpipeBind4(23, 119, ctx.pconfig.PAYMENTSUMMARY.TOTALTAXES, "USD", "symbol-narrow", "1.2-2") : "-");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.od.AllowShipping);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.summaryValid ? ctx.pconfig.PAYMENTSUMMARY.TOTALSHIPPING > 0 ? ɵngcc0.ɵɵpipeBind4(31, 124, ctx.pconfig.PAYMENTSUMMARY.TOTALSHIPPING, "USD", "symbol-narrow", "1.2-2") : "FREE" : "-");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.od.PaymentInformation.InstallmentType == "1" ? "cartTotal_ban clear" : "clear");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.summaryValid ? ɵngcc0.ɵɵpipeBind4(37, 129, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS, "USD", "symbol-narrow", "1.2-2") : "-", " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.od.PaymentInformation.InstallmentType == "1");
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵtextInterpolate(ctx.InstallmentType[ctx.od.PaymentInformation.InstallmentType]);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ctx.numberofinstallments);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(63, 134, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / ctx.numberofinstallments, "USD", "symbol-narrow", "1.2-2"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind4(69, 139, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / ctx.numberofinstallments, "USD", "symbol-narrow", "1.2-2"), " ");
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(77, 144, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS - ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / ctx.numberofinstallments, "USD", "symbol-narrow", "1.2-2"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.SHOWTRIALMEMBERSHIP != true);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.pconfig.TRIALMEMBERSHIPLABEL, " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.SHOWINSTALLMENTS != true);
        ɵngcc0.ɵɵattribute("disabled", ctx.od.PaymentInformation.PaymentType == ctx.PaymentType.Check);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.pconfig.INSTALLMENTSLABEL, "", ctx.pconfig.SHOWTRIALMEMBERSHIP ? " (after trial period)" : "", "");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.InstallmentType.Monthly);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.InstallmentType)("disabled", ctx.pconfig.LOCKINSTALLMENTS);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(103, 149, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / 12, "USD", "symbol-narrow", "1.2-2"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.InstallmentType.Quarterly);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.InstallmentType)("disabled", ctx.pconfig.LOCKINSTALLMENTS);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(111, 154, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / 4, "USD", "symbol-narrow", "1.2-2"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.InstallmentType.SemiAnnual);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.InstallmentType)("disabled", ctx.pconfig.LOCKINSTALLMENTS);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(119, 159, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / 2, "USD", "symbol-narrow", "1.2-2"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.InstallmentType.Annual);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.InstallmentType);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(127, 164, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS, "USD", "symbol-narrow", "1.2-2"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.od.PaymentInformation.Amount == "" || ctx.pconfig.SHOWAMOUNT != true);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("Amount: ", ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS != "" ? ɵngcc0.ɵɵpipeBind4(134, 169, ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS, "USD", "symbol-narrow", "1.2-2") : "", "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.SHOWAUTORENEWAL != true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.pconfig.AUTORENEWALLABEL == "" ? "Auto Renewal" : ctx.pconfig.AUTORENEWALLABEL, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.getAutoRenewalInfoText(), ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("radioBlock cartRenewal clear ", ctx.pconfig.LOCKAUTORENEWAL ? "setOpacity" : "", "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.AutoRenewal)("disabled", ctx.od.PaymentInformation.PaymentType == ctx.PaymentType.Check || ctx.pconfig.LOCKAUTORENEWAL || ctx.od.PaymentInformation.InstallmentType != ctx.InstallmentType.Annual && ctx.isMembershipIndividual);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.AutoRenewal)("disabled", ctx.pconfig.LOCKAUTORENEWAL || ctx.od.PaymentInformation.InstallmentType != ctx.InstallmentType.Annual && ctx.isMembershipIndividual);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", _r2.checked != true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.pconfig.AUTORENEWAL_DESCRIPTION, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.od.AllowShipping);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.summaryValid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.summaryValid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.SHOWPROMOCODE != true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.pconfig.PRMOCODELABEL);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.pconfig.PRMOCODELABEL);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("fl_input PromotionCode", _r5.value == "" ? "" : ctx.promocodevalid ? "-Success" : "-Error", "");
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PromoCode)("disabled", ctx.pconfig.LOCKPROMOCODE && _r5.value != "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.PAYMENTSUMMARY.PROMOCODEMESSAGE == "" || ctx.promocodevalid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.pconfig.PAYMENTSUMMARY.PROMOCODEMESSAGE);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", _r5.value == "" ? true : ctx.promocodevalid ? false : true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("optionbtn promoCodebtn rpcPromotionCode", _r5.value == "" ? "" : ctx.promocodevalid ? "-Success" : "-Error", "");
        ɵngcc0.ɵɵproperty("hidden", _r5.value == "" ? true : ctx.promocodevalid ? false : true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS == 0 && ctx.od.PaymentInformation.AutoRenewal != "true");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.pconfig.PAYMENTMETHOD);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pconfig.ALLOW_ECP);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.SHOWPAYMENTTYPE != true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.ALLOW_ECP != true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.PaymentType.ECP);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.PaymentType);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.od.PaymentInformation.PaymentType != ctx.PaymentType.ECP);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("savedpaymenttypes", ctx.savedpaymenttypes_ecp)("paymentSpecifications", ctx.paymentEvents.asObservable());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.ALLOW_CREDITCARDS != true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.PaymentType.CreditCard);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.PaymentType);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.od.PaymentInformation.PaymentType != ctx.PaymentType.CreditCard);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("paymentSpecifications", ctx.paymentEvents.asObservable())("savedpaymenttypes", ctx.savedpaymenttypes_cc);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.ALLOW_CHECKS != true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.PaymentType.Check);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.PaymentType);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.od.PaymentInformation.PaymentType != ctx.PaymentType.Check);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.pconfig.CHECK_DESCRIPTION, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.od.OrderTypeCode == ctx.OrderTypeCode[ctx.OrderTypeCode.MembershipGroup] || ctx.od.OrderTypeCode == ctx.OrderTypeCode[ctx.OrderTypeCode.MembershipIndividual])("ngIfElse", _r11);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ctx.od.CustomerType == 2 ? ctx.od.AcepId : ctx.od.AccountNumber);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("'", ctx.pconfig.VENDOR, " Application Fee'");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.pconfig.SHOWAUTORENEWAL || ctx.pconfig.SHOWINSTALLMENTS);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.pconfig.SHOWPAYPAL == true));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.PaymentType.PayPal);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.PaymentType);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.ALLOW_CREDITTERMS != true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.PaymentType.CreditTerms);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.PaymentType);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.od.PaymentInformation.PaymentType != ctx.PaymentType.CreditTerms);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.TERMS_ACCOUNT_APPROVED != true);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.PaymentInformation.PONumber);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.pconfig.TERMS_ACCOUNT_APPROVED != false);
        ɵngcc0.ɵɵadvance(14);
        ɵngcc0.ɵɵtextInterpolate(ctx.ccEmailTooltipText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("validation-error", !!ctx.od.CCEmail && !ctx.validateEmail(ctx.od.CCEmail));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.od.CCEmail);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.pconfig.TERMSANDCONDITIONS_SHOWCHECKBOX && ctx.summaryValid));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isECommerce);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isECommerce);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.pconfig.TERMSANDCONDITIONS_DESCRIPTION, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: function () { return [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc4.RadioControlValueAccessor, ɵngcc4.DefaultValueAccessor, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ShippingaddressComponent, ManageECPComponent, ManageCreditCardsComponent, ɵngcc4.MaxLengthValidator, TermsAddressComponent]; }, pipes: function () { return [ɵngcc3.CurrencyPipe]; }, encapsulation: 2 });
PaymentComponent.ctorParameters = () => [
    { type: PaymentService },
    { type: GlobalDataOpsService },
    { type: GlobalDomOpsService },
    { type: AcepSSOService }
];
PaymentComponent.propDecorators = {
    managecreditcardscomponent: [{ type: ViewChild, args: ["managecreditcards", { static: false },] }],
    manageecp: [{ type: ViewChild, args: ["manageecp", { static: false },] }],
    termsaddresscomponent: [{ type: ViewChild, args: ["nettermsaddress", { static: false },] }],
    shippingaddresscomponent: [{ type: ViewChild, args: ["shippingaddress", { static: false },] }],
    terms: [{ type: ViewChild, args: ['terms',] }],
    od: [{ type: Input }],
    pconfig: [{ type: Input }],
    updatePaymentSummary: [{ type: Output }],
    OrderProcessingCompleted: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaymentComponent, [{
        type: Component,
        args: [{
                selector: "payment",
                template: "<!--{{od | json}}-->\r\n<!--Payment control <br />-->\r\n<!--{{od.PaymentInformation | json}}<hr/>-->\r\n<!--{{pconfig | json}}-->\r\n<div class=\"f100 clear\">\r\n    <div class=\"r33 rightCol\">\r\n        <!-- cart summary -->\r\n        <div class=\"cartSummary_wrap\" id=\"summary-box\">\r\n            <div class=\"cartSummary_ban\">\r\n                Summary\r\n            </div>\r\n            <!-- summary box -->\r\n            <div class=\"cartSummary_box\">\r\n                <!-- row -->\r\n                <!--<div class=\"f100 clear\">\r\n                    <div class=\"l67\">\r\n                        <p>Price</p>\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        <p class=\"bold\">{{od.TotalAmount | currency:'USD':'symbol-narrow':'1.2-2' }}</p>\r\n                    </div>\r\n                </div>-->\r\n                <!-- /row -->\r\n                <div class=\"f100 clear\" *ngFor=\"let li of od.orderLineItems\">\r\n                    <div class=\"l67\">\r\n                        <p>{{li.ProductName}}{{li.Quantity > 1 ? ' (' + li.Quantity + ')': ''}}\r\n                            <span class=\"autorenewalflag\" *ngIf=\"li.ProductAutoRenew\"><br>(Auto Renew - ON)</span>\r\n                        </p>\r\n\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        <p class=\"bold\">{{(li.UnitPrice * li.Quantity) | currency:'USD':'symbol-narrow':'1.2-2' }}</p>\r\n                    </div>\r\n                </div>\r\n                <!-- /row -->\r\n                <div class=\"f100 clear\" *ngIf=\"od.OrderTypeCode == OrderTypeCode[OrderTypeCode.MembershipGroup]\">\r\n                    <div class=\"l67\">\r\n                        <p>Group Portal</p>\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        <p class=\"bold\">{{pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS |\r\n                            currency:'USD':'symbol-narrow':'1.2-2'}}</p>\r\n                    </div>\r\n                </div>\r\n                <!-- row -->\r\n                <div class=\"f100 clear\" [hidden]=\"pconfig.PAYMENTSUMMARY.TOTALDISCOUNT == 0\">\r\n                    <div class=\"l67\">\r\n                        <p>Discount</p>\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        <p class=\"bold\">-{{pconfig.PAYMENTSUMMARY.TOTALDISCOUNT |\r\n                            currency:'USD':'symbol-narrow':'1.2-2'}}</p>\r\n                    </div>\r\n                </div>\r\n                <!-- /row -->\r\n\r\n                <!-- row -->\r\n                <div class=\"f100 tax clear\">\r\n                    <div class=\"l67\">\r\n                        <p>Tax</p>\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        <p class=\"bold\">{{ summaryValid ? ( pconfig.PAYMENTSUMMARY.TOTALTAXES |\r\n                            currency:'USD':'symbol-narrow':'1.2-2' ) : '-'}}</p>\r\n                    </div>\r\n                </div>\r\n                <!-- /row  -->\r\n\r\n                <!-- row -->\r\n                <div class=\"f100 tax clear\" [hidden]=\"!od.AllowShipping\">\r\n                    <div class=\"l67\">\r\n                        <p>Shipping</p>\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        <p class=\"bold\">{{summaryValid ? ( pconfig.PAYMENTSUMMARY.TOTALSHIPPING > 0 ? (\r\n                            pconfig.PAYMENTSUMMARY.TOTALSHIPPING | currency:'USD':'symbol-narrow':'1.2-2' ) : 'FREE' ) :\r\n                            '-'}}</p>\r\n                    </div>\r\n                </div>\r\n                <!-- /row -->\r\n\r\n                <div class=\"{{od.PaymentInformation.InstallmentType=='1' ? 'cartTotal_ban clear' : 'clear'}}\">\r\n                    <div class=\"l67\">\r\n                        Order Total\r\n                    </div>\r\n                    <div class=\"r33\">\r\n                        {{summaryValid ? (pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS |\r\n                        currency:'USD':'symbol-narrow':'1.2-2') : '-'}}\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!-- /summary box -->\r\n            <div id=\"installmentCtr\" [hidden]=\"od.PaymentInformation.InstallmentType=='1'\">\r\n                <div class=\"cartSummary_ban\">\r\n                    Installment\r\n                </div>\r\n                <div class=\"cartSummary_box\">\r\n                    <div class=\"f100 clear\">\r\n                        <div class=\"l67\">\r\n                            <p>Installment Type</p>\r\n                        </div>\r\n                        <div class=\"r33\">\r\n                            <p class=\"bold\">{{InstallmentType[od.PaymentInformation.InstallmentType]}}</p>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"f100 clear\">\r\n                        <div class=\"l67\">\r\n                            <p>Number of Installments</p>\r\n                        </div>\r\n                        <div class=\"r33\">\r\n                            <p class=\"bold\">{{numberofinstallments}}</p>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"f100 clear\">\r\n                        <div class=\"l67\">\r\n                            <p>Each Installment Amount</p>\r\n                        </div>\r\n                        <div class=\"r33\">\r\n                            <p class=\"bold\">{{pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS /\r\n                                (numberofinstallments) | currency:'USD':'symbol-narrow':'1.2-2'}}</p>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"cartTotal_ban clear\">\r\n                        <div class=\"l67\">\r\n                            Paying Now\r\n                        </div>\r\n                        <div class=\"r33\">\r\n                            {{pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / (numberofinstallments) |\r\n                            currency:'USD':'symbol-narrow':'1.2-2'}}\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"f100 clear\">\r\n                        <div class=\"l67\">\r\n                            <p>Amount to be paid later</p>\r\n                        </div>\r\n                        <div class=\"r33\">\r\n                            <p class=\"bold\">{{( pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS -\r\n                                (pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / (numberofinstallments) ) )|\r\n                                currency:'USD':'symbol-narrow':'1.2-2'}}</p>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!-- installment box -->\r\n            <!--<div class=\"std_box installmentBox\">\r\n                <h3>Installments (Semi-Annual) <span class=\"bold\">$000.00</span></h3>\r\n                <p>You will be only charged for the installments up to date.</p>\r\n            </div>-->\r\n            <!-- installment box -->\r\n        </div>\r\n        <!-- /cart summary -->\r\n\r\n\r\n    </div>\r\n    <div class=\"l67 leftCol\">\r\n        <div id=\"paymentcontrolcontainer\">\r\n\r\n            <!--TRIAL MEMBERSHIP-->\r\n            <div class=\"f100 clear\" [hidden]=\"pconfig.SHOWTRIALMEMBERSHIP != true\">\r\n                <h3>Trial Membership</h3>\r\n                <div class=\"optionbtn promoCodebtn trialMembCtr\">\r\n                    <span class=\"trialMbrWrapper\">{{pconfig.TRIALMEMBERSHIPLABEL}}\r\n                        <br>\r\n                        <span class=\"wrapperAmount\">FREE</span>\r\n                    </span>\r\n                </div>\r\n            </div>\r\n\r\n\r\n            <!--INSTALLMENTS-->\r\n            <div class=\"f100 clear\" [hidden]=\"pconfig.SHOWINSTALLMENTS != true\"\r\n                [attr.disabled]=\"od.PaymentInformation.PaymentType == PaymentType.Check\">\r\n                <h3>{{pconfig.INSTALLMENTSLABEL}}{{pconfig.SHOWTRIALMEMBERSHIP ? ' (after trial period)' : ''}}</h3>\r\n                <div class=\"validationwrap\">\r\n                    <p class=\"validationhead\">Please select one installment type from the following:</p>\r\n                    <div class=\"radioBlock cartInstallments clear\">\r\n                        <input type=\"radio\" name=\"installments\" id=\"Monthly\" required=\"required\"\r\n                            value=\"{{InstallmentType.Monthly}}\" [(ngModel)]=\"od.PaymentInformation.InstallmentType\"\r\n                            [disabled]=\"pconfig.LOCKINSTALLMENTS\" (ngModelChange)=\"changeInstallment()\" />\r\n                        <label for=\"Monthly\">\r\n                            <span class=\"installmentWrapper\">Monthly\r\n                                <br>\r\n                                <span class=\"installmentAmount\">{{\r\n                                    pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / 12 |\r\n                                    currency:'USD':'symbol-narrow':'1.2-2' }}</span>\r\n                            </span>\r\n                        </label>\r\n                        <input type=\"radio\" name=\"installments\" id=\"Quarterly\" required=\"required\"\r\n                            value=\"{{InstallmentType.Quarterly}}\" [(ngModel)]=\"od.PaymentInformation.InstallmentType\"\r\n                            [disabled]=\"pconfig.LOCKINSTALLMENTS\" (ngModelChange)=\"changeInstallment()\" />\r\n                        <label for=\"Quarterly\">\r\n                            <span class=\"installmentWrapper\">Quarterly\r\n                                <br>\r\n                                <span class=\"installmentAmount\">{{\r\n                                    pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / 4 |\r\n                                    currency:'USD':'symbol-narrow':'1.2-2' }}</span>\r\n                            </span>\r\n                        </label>\r\n                        <input type=\"radio\" name=\"installments\" id=\"SemiAnnual\" required=\"required\"\r\n                            value=\"{{InstallmentType.SemiAnnual}}\" [(ngModel)]=\"od.PaymentInformation.InstallmentType\"\r\n                            [disabled]=\"pconfig.LOCKINSTALLMENTS\" (ngModelChange)=\"changeInstallment()\" />\r\n                        <label for=\"SemiAnnual\">\r\n                            <span class=\"installmentWrapper\">Semi-Annual\r\n                                <br>\r\n                                <span class=\"installmentAmount\">{{\r\n                                    pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS / 2 |\r\n                                    currency:'USD':'symbol-narrow':'1.2-2' }}</span>\r\n                            </span>\r\n                        </label>\r\n                        <input type=\"radio\" name=\"installments\" id=\"NoInstallments\" required=\"required\"\r\n                            value=\"{{InstallmentType.Annual}}\" [(ngModel)]=\"od.PaymentInformation.InstallmentType\"\r\n                            (ngModelChange)=\"changeInstallment()\" />\r\n                        <label for=\"NoInstallments\">\r\n                            <span class=\"installmentWrapper\">Annual\r\n                                <br>\r\n                                <span class=\"installmentAmount\">{{\r\n                                    pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS |\r\n                                    currency:'USD':'symbol-narrow':'1.2-2' }}</span>\r\n                            </span>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!--AMOUNT-->\r\n            <div class=\"f100 clear\" [hidden]=\"od.PaymentInformation.Amount == '' || pconfig.SHOWAMOUNT != true\">\r\n                <div class=\"l50\">\r\n                    <div class=\"fl_wrap\">\r\n                        <p>\r\n                            <label>Amount: {{pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS != '' ?\r\n                                (pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS |\r\n                                currency:'USD':'symbol-narrow':'1.2-2')\r\n                                : ''}}</label>\r\n                        </p>\r\n                    </div>\r\n                </div>\r\n                <div class=\"r50\">\r\n                    <p></p>\r\n                </div>\r\n            </div>\r\n            <!--AUTORENEWAL-->\r\n            <div class=\"f100 clear\" [hidden]=\"pconfig.SHOWAUTORENEWAL != true\">\r\n                <div class=\"autorenewalWrapper\">\r\n                    <h3>{{pconfig.AUTORENEWALLABEL == \"\"? \"Auto Renewal\" : pconfig.AUTORENEWALLABEL}} <i\r\n                            class=\"fa fa-info-circle\">\r\n                            <span class=\"tooltiptext\" [innerHTML]='getAutoRenewalInfoText()'>\r\n                            </span></i></h3>\r\n                    <!--NO installment for cheques-->\r\n                </div>\r\n\r\n                <div class=\"radioBlock cartRenewal clear {{pconfig.LOCKAUTORENEWAL ? 'setOpacity' : ''}}\">\r\n                    <input #autorenewYes type=\"radio\" name=\"AutoRenewal\" id=\"AutoRenewal-Yes\" value=\"true\"\r\n                        [(ngModel)]=\"od.PaymentInformation.AutoRenewal\"\r\n                        [disabled]=\"od.PaymentInformation.PaymentType == PaymentType.Check || pconfig.LOCKAUTORENEWAL || (od.PaymentInformation.InstallmentType != InstallmentType.Annual && isMembershipIndividual)\"\r\n                        (ngModelChange)=\"changeAutoRenewal()\" />\r\n                    <label for=\"AutoRenewal-Yes\">Yes</label>\r\n                    <input type=\"radio\" name=\"AutoRenewal\" id=\"AutoRenewal-No\" value=\"false\"\r\n                        [(ngModel)]=\"od.PaymentInformation.AutoRenewal\"\r\n                        [disabled]=\"pconfig.LOCKAUTORENEWAL || (od.PaymentInformation.InstallmentType != InstallmentType.Annual && isMembershipIndividual)\"\r\n                        (ngModelChange)=\"changeAutoRenewal()\" />\r\n                    <label for=\"AutoRenewal-No\">No</label>\r\n                </div>\r\n            </div>\r\n            <!--AUTORENEWAL CONTENT IF ANY-->\r\n            <div class=\"f100 clear autorenewaldetails\" [hidden]=\"autorenewYes.checked != true\">\r\n                <!--TRANSCLUDED CONTENT-->\r\n                <ng-content select=\".payment-autorenewal-details\"></ng-content>\r\n                {{pconfig.AUTORENEWAL_DESCRIPTION}}\r\n            </div>\r\n\r\n\r\n            <app-shippingaddress #shippingaddress [hidden]=\"!od.AllowShipping\"\r\n                (updateShippingRates)=\"updateShippingRates($event)\"></app-shippingaddress>\r\n\r\n\r\n            <div class=\"f100 clear\" *ngIf=\"!summaryValid\">\r\n                <br><br> Please contact <a target=\"_blank\"\r\n                    href=\"https://webapps.acep.org/membership/account/#/messageus?org=ACEP&url=https:%2F%2Fwww.acep.org%2Fstore%2F\">Member\r\n                    and Customer Care</a> for assistance.\r\n            </div>\r\n\r\n\r\n            <div [hidden]=\"!summaryValid\">\r\n\r\n\r\n                <!--PROMOCODE-->\r\n                <!-- promo code - success -->\r\n                <div class=\"f100 clear\" id=\"promoCode\" [hidden]=\"pconfig.SHOWPROMOCODE != true\">\r\n                    <h3>{{pconfig.PRMOCODELABEL}}</h3>\r\n                    <div class=\"f100 PromotionCode clear\">\r\n                        <div class=\"l67\">\r\n                            <div class=\"validationwrap\">\r\n                                <div class=\"fl_wrap\">\r\n                                    <label class=\"fl_label\">{{pconfig.PRMOCODELABEL}}</label>\r\n                                    <input #promo\r\n                                        class=\"fl_input PromotionCode{{ promo.value == '' ? '' : (promocodevalid ? '-Success':'-Error') }}\"\r\n                                        type=\"text\" id=\"PromoCode\" [(ngModel)]=\"od.PromoCode\"\r\n                                        [disabled]=\"pconfig.LOCKPROMOCODE && promo.value != ''\"\r\n                                        (focusout)=\"promocode$.next($event.target.value)\">\r\n                                    <span class=\"promocodemsg\"\r\n                                        [hidden]=\"pconfig.PAYMENTSUMMARY.PROMOCODEMESSAGE == ''  || promocodevalid\">{{pconfig.PAYMENTSUMMARY.PROMOCODEMESSAGE}}</span>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"r33\">\r\n                            <a class=\"optionbtn promoCodebtn\"\r\n                                *ngIf=\"promo.value == '' ? true : (promocodevalid ? false : true)\"\r\n                                [class.disabled]=\"od.PromoCode == '' ? true : null\" (click)=\"ApplyPromoCode()\">Apply\r\n                                Code</a>\r\n                            <a class=\"optionbtn promoCodebtn rpcPromotionCode{{ promo.value == '' ? '' : (promocodevalid ? '-Success':'-Error') }}\"\r\n                                [hidden]=\"promo.value == '' ? true : (promocodevalid ? false : true)\"\r\n                                (click)=\"RemovePromoCode()\">Remove Code</a>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <!-- /promo code - success -->\r\n                <!-- PAYMENT TYPE -->\r\n                <div class=\"f100 radioWrap clear\" id=\"paymentcontrol\"\r\n                    [hidden]=\"pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS == 0 && od.PaymentInformation.AutoRenewal != 'true'\">\r\n                    <h3>{{pconfig.PAYMENTMETHOD}}</h3>\r\n\r\n\r\n                    <div *ngIf=\"pconfig.ALLOW_ECP\" class=\"f100 clear payment_ach_header\"\r\n                        [innerHTML]=\"pconfig.ACH_DESCRIPTION\"></div>\r\n\r\n                    <div class=\"validationwrap\">\r\n                        <p class=\"validationhead\" [hidden]=\"pconfig.SHOWPAYMENTTYPE != true\">Choose Payment Type</p>\r\n\r\n                        <!-- ECP :Electronic Check Payment -->\r\n                        <div class=\"paymentcontrol-block paymentcontrol-cc paymentcontrol-ecp\"\r\n                            [hidden]=\"pconfig.ALLOW_ECP != true\">\r\n                            <input (change)=\"onPaymentTypeChange()\" type=\"radio\" value=\"{{PaymentType.ECP}}\"\r\n                                id=\"PaymentType-ECP\" name=\"PaymentType\" title=\"ECP\"\r\n                                [(ngModel)]=\"od.PaymentInformation.PaymentType\" required=\"required\" />\r\n                            <label for=\"PaymentType-ECP\">Bank Account</label>\r\n                        </div>\r\n\r\n\r\n                        <div class=\"f100 clear ccdetails paymentcontrol-content\" id=\"ccOptions\"\r\n                            [hidden]=\"od.PaymentInformation.PaymentType != PaymentType.ECP\">\r\n                            <manage-ecp #manageecp [savedpaymenttypes]=\"savedpaymenttypes_ecp\"\r\n                                [paymentSpecifications]=\"paymentEvents.asObservable()\"></manage-ecp>\r\n                        </div>\r\n\r\n                        <!--CREDIT CARD-->\r\n\r\n                        <div class=\"paymentcontrol-block paymentcontrol-cc\"\r\n                            [hidden]=\"pconfig.ALLOW_CREDITCARDS != true\">\r\n                            <input (change)=\"onPaymentTypeChange()\" type=\"radio\" value=\"{{PaymentType.CreditCard}}\"\r\n                                id=\"PaymentType-Card\" name=\"PaymentType\" title=\"Credit Card\"\r\n                                [(ngModel)]=\"od.PaymentInformation.PaymentType\" required=\"required\" />\r\n                            <label for=\"PaymentType-Card\">Credit Card - Pay now using a credit card</label>\r\n                        </div>\r\n\r\n\r\n                        <div class=\"f100 clear ccdetails paymentcontrol-content\" id=\"ccOptions\"\r\n                            [hidden]=\"od.PaymentInformation.PaymentType != PaymentType.CreditCard\">\r\n                            <!--<payment-creditcards #creditcards [od]=\"od\" [pconfig]=\"pconfig\" [savedpaymenttypes]=\"savedpaymenttypes\"></payment-creditcards>-->\r\n                            <manage-creditcards #managecreditcards\r\n                                [paymentSpecifications]=\"paymentEvents.asObservable()\"\r\n                                [savedpaymenttypes]=\"savedpaymenttypes_cc\"></manage-creditcards>\r\n                        </div>\r\n\r\n\r\n\r\n\r\n\r\n                        <!-- check -->\r\n                        <div class=\"paymentcontrol-block paymentcontrol-ch\" [hidden]=\"pconfig.ALLOW_CHECKS != true\">\r\n                            <input (change)=\"onPaymentTypeChange()\" type=\"radio\" value=\"{{PaymentType.Check}}\"\r\n                                id=\"PaymentType-Check\" name=\"PaymentType\" title=\"Check\"\r\n                                [(ngModel)]=\"od.PaymentInformation.PaymentType\" required=\"required\" />\r\n                            <label for=\"PaymentType-Check\">Check</label>\r\n                        </div>\r\n                        <!--CHECK-->\r\n                        <div class=\"checkdetails paymentcontrol-content\"\r\n                            [hidden]=\"od.PaymentInformation.PaymentType != PaymentType.Check\">\r\n                            <!--TRANSCLUDED CONTENT-->\r\n                            <ng-content select=\".payment-check-details\"></ng-content>\r\n                            <div class=\"f100 clear\" [innerHTML]=\"pconfig.CHECK_DESCRIPTION\"></div>\r\n                            <div class=\"alert alert-info\">\r\n                                After submitting your application, send a check or money order to:\r\n                                <br>\r\n                                <div\r\n                                    *ngIf=\"od.OrderTypeCode == OrderTypeCode[OrderTypeCode.MembershipGroup] || od.OrderTypeCode == OrderTypeCode[OrderTypeCode.MembershipIndividual] else check_NotMembership\">\r\n                                    <br> American College of Emergency Physicians\r\n                                    <br> P.O. Box 619911\r\n                                    <br> Dallas TX 75261-9911\r\n                                </div>\r\n                                <ng-template #check_NotMembership>\r\n                                    <br> American College of Emergency Physicians MISC ACEP\r\n                                    <br> P.O. Box 222291\r\n                                    <br> Dallas TX 75222-2291\r\n                                </ng-template>\r\n\r\n                                <br>\r\n                                <br>\r\n                                <i> Please write the ACEP ID\r\n                                    <b class=\"bold\">{{od.CustomerType == 2 ? od.AcepId : od.AccountNumber}}</b> and\r\n                                    <b>'{{pconfig.VENDOR}} Application Fee'</b> on your check.\r\n                                </i>\r\n                                <br>\r\n                                <hr>\r\n                                <b>\r\n                                    <i *ngIf=\"pconfig.SHOWAUTORENEWAL || pconfig.SHOWINSTALLMENTS\">{{checkText}}</i>\r\n                                </b>\r\n                            </div>\r\n                        </div>\r\n\r\n\r\n                        <!-- PAYPAL -->\r\n                        <div class=\"paymentcontrol-block paymentcontrol-pp\" [hidden]=\"!(pconfig.SHOWPAYPAL == true)\">\r\n                            <input (change)=\"onPaymentTypeChange()\" type=\"radio\" value=\"{{PaymentType.PayPal}}\"\r\n                                id=\"PaymentType-PayPal\" name=\"PaymentType\" title=\"PayPal\"\r\n                                [(ngModel)]=\"od.PaymentInformation.PaymentType\" required=\"required\" />\r\n                            <label for=\"PaymentType-PayPal\">PayPal</label>\r\n                        </div>\r\n                        <!--PAYPAL-->\r\n\r\n                        <!-- <div class=\"payPalDetails paymentcontrol-content\" [hidden]=\"od.PaymentInformation.PaymentType != PaymentType.PayPal\" >                       \r\n                        <div class=\"alert alert-info\">\r\n                            Please authorize your PayPal Payment by clicking the button below to proceed further. <br><br>\r\n                        </div> \r\n                        <div #paypal></div>\r\n                    </div> -->\r\n\r\n                        <!-- CREDIT TERMS -->\r\n                        <div class=\"paymentcontrol-block paymentcontrol-terms\"\r\n                            [hidden]=\"pconfig.ALLOW_CREDITTERMS != true\">\r\n                            <input (change)=\"onPaymentTypeChange()\" type=\"radio\" value=\"{{PaymentType.CreditTerms}}\"\r\n                                id=\"PaymentType-CreditTerms\" name=\"PaymentType\" title=\"CreditTerms\"\r\n                                [(ngModel)]=\"od.PaymentInformation.PaymentType\" required=\"required\" />\r\n                            <label for=\"PaymentType-CreditTerms\">Purchase Order - Pay later by check or purchase\r\n                                order</label>\r\n                        </div>\r\n                        <!--CREDIT TERMS-->\r\n\r\n                        <div class=\"termsdetails paymentcontrol-content\"\r\n                            [hidden]=\"od.PaymentInformation.PaymentType != PaymentType.CreditTerms\">\r\n\r\n                            <div class=\"f100 clear\" [hidden]=\"pconfig.TERMS_ACCOUNT_APPROVED != true\">\r\n                                <p>Please enter your Purchase Order Details below:</p>\r\n\r\n                                <div class=\"validationwrap\">\r\n                                    <div class=\"fl_wrap\">\r\n                                        <label class=\"fl_label\">PO Number</label>\r\n                                        <input class=\"fl_input\" type=\"text\" id=\"ponumber\"\r\n                                            [(ngModel)]=\"od.PaymentInformation.PONumber\" maxlength=\"50\"\r\n                                            required=\"required\">\r\n                                        <span class=\"validationhead\">Required</span>\r\n                                    </div>\r\n                                </div>\r\n\r\n                            </div>\r\n\r\n\r\n                            <!-- Show the terms application when hasbilling info is returned as false -->\r\n                            <!-- || pconfig.TERMS_ACCOUNT_HASBILLINGINFO == true -->\r\n                            <div class=\"f100 clear\" [hidden]=\"pconfig.TERMS_ACCOUNT_APPROVED != false\">\r\n                                <!-- We are sorry. This account is not approved for Terms. Please contact our customer service as membership@acep.org. -->\r\n\r\n                                <h4><strong>Application for Credit</strong></h4>\r\n                                <p>\r\n                                    Credit terms have not been approved for this account. Please provide the following\r\n                                    information to apply for credit. After your application has been approved, you will\r\n                                    be notified by email and you will need to return to complete the checkout process.\r\n                                </p>\r\n\r\n                                <app-nettermsaddress #nettermsaddress></app-nettermsaddress>\r\n\r\n                            </div>\r\n\r\n                            <!-- <div class=\"f100 clear\" *ngIf=\"pconfig.TERMS_ACCOUNT_APPROVED == false && pconfig.TERMS_ACCOUNT_HASBILLINGINFO == true\">\r\n                                It appears this hospital is not yet approved for the credit application that you have previously submitted. Once approved, the application for accreditation will\r\n                                be submitted and you will receive an invoice at the email address you had provided.\r\n                        </div> -->\r\n\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n                <div class=\"f100 clear\" id=\"ccemailCtr\">\r\n\r\n                    <div class=\"ccemailWrapper\">\r\n                        <h3>CC Email for Receipt <i class=\"fa fa-info-circle\">\r\n                                <span class=\"tooltiptext\">{{ccEmailTooltipText}}</span></i></h3>\r\n                        <!--NO installment for cheques-->\r\n                    </div>\r\n\r\n\r\n                    <div class=\"validationwrap\" [class.validation-error]=\"!!od.CCEmail && !validateEmail(od.CCEmail)\">\r\n                        <div class=\"fl_wrap\">\r\n                            <label class=\"fl_label\" for=\"ccemail\">Enter email address</label>\r\n                            <input #alternateemail class=\"fl_input\" name=\"ccemail\" type=\"email\" id=\"ccemail\"\r\n                                [(ngModel)]=\"od.CCEmail\" maxlength=\"50\" attr.data-validate=\"true\" autocomplete=\"nope\">\r\n                            <span class=\"validationhead\">Please enter a valid email address</span>\r\n\r\n\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </div>\r\n            <!--TERMS AND CONDITIONS-->\r\n            <div class=\"f100 clear termsCtr\" [hidden]=\"!(pconfig.TERMSANDCONDITIONS_SHOWCHECKBOX && summaryValid)\">\r\n                <h3>Terms & Conditions</h3>\r\n                <div class=\"terms\" #terms></div>\r\n\r\n\r\n                <div class=\"validationwrap\">\r\n                    <div id=\"agreeTC\" class=\"checkboxWrap\">\r\n                        <input type=\"checkbox\" id=\"Terms-Yes\" name=\"Terms-Yes\" required=\"required\" />\r\n                        <label for=\"Terms-Yes\" *ngIf=\"!isECommerce\">I agree to\r\n                            {{pconfig.TERMSANDCONDITIONS_CHECKBOXTEXT}}\r\n                            <a (click)=\"showterms()\">terms & conditions</a>\r\n                        </label>\r\n                        <label for=\"Terms-Yes\" *ngIf=\"isECommerce\">I have read the disclaimer and agree to the terms and\r\n                            conditions</label>\r\n                        <span class=\"validationhead\">Please agree to our Terms &amp; Conditions</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!-- TERMS AND CONDITIONS modal -->\r\n            <div class=\"remodal\" data-remodal-id=\"termsModal\">\r\n                <h1>Terms & Conditions</h1>\r\n                <div class=\"f100 clear\" [innerHTML]=\"pconfig.TERMSANDCONDITIONS_DESCRIPTION\"></div>\r\n                <a data-remodal-action=\"confirm\" class=\"remodal-confirm\">Okay</a>\r\n            </div>\r\n            <!-- CVV modal -->\r\n            <div class=\"remodal\" data-remodal-id=\"creditcardCVV\">\r\n                <h1>Credit Card Verification Codes</h1>\r\n                <div class=\"cvvDT\">\r\n                    <!-- cvv art for desktop here -->\r\n                </div>\r\n                <div class=\"cvvMB\">\r\n                    <!-- cvv art for mobile (480px and below) here -->\r\n                </div>\r\n                <a data-remodal-action=\"confirm\" class=\"remodal-confirm\">Okay</a>\r\n            </div>\r\n            <!-- PAYMENT PREVIEW modal -->\r\n            <!-- <div class=\"remodal\" data-remodal-id=\"paymentpreview\">\r\n                <h1>Payment Details</h1>\r\n                <div>\r\n                    Please review the payment information and click 'Submit'. Please do not refresh or close the browser after clicking the 'Submit'\r\n                    button.\r\n                </div>\r\n                <div class=\"f100 clear\">\r\n                    <div class=\"l50\">\r\n                        <h3>Amount:</h3>\r\n                    </div>\r\n                    <div class=\"r50\">\r\n                        {{ pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS != '' ? (pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS\r\n                        / (numberofinstallments) | currency:'USD':'symbol-narrow':'1.2-2') : '' }}\r\n                    </div>\r\n                </div>\r\n                <div class=\"f100 clear\" [hidden]=\"!(pconfig.SHOWINSTALLMENTS && od.PaymentInformation.InstallmentType != InstallmentType.Annual)\">\r\n                    <div class=\"l50\">\r\n                        <h3>Installment Type: </h3>\r\n                    </div>\r\n                    <div class=\"r50\">\r\n                        {{InstallmentType[od.PaymentInformation.InstallmentType]}}\r\n                    </div>\r\n                </div>\r\n                <div class=\"f100 clear\" [hidden]=\"od.PaymentInformation.PaymentType != PaymentType.CreditCard\">\r\n                     <div class=\"f100 clear\" [hidden]=\"od.PaymentInformation.AutoRenewal == 'false'\">\r\n                        <div class=\"l50\">\r\n                            <h3>Auto Renewal:</h3>\r\n                        </div>\r\n                        <div class=\"r50\">\r\n                            {{od.PaymentInformation.AutoRenewal == 'true'? 'Yes' : 'No'}}\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"f100 clear\">\r\n                        <div class=\"l50\">\r\n                            <h3>Credit Card Number:</h3>\r\n                        </div>\r\n                        <div class=\"r50\">\r\n                            {{ maskedccnum}}\r\n                            <span class=\"sprites image-{{CardType[od.PaymentInformation.CardType]}}\"></span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"f100 clear\" [hidden]=\"od.PaymentInformation.NameOnCard == null\">\r\n                        <div class=\"l50\">\r\n                            <h3>Name on the card:</h3>\r\n                        </div>\r\n                        <div class=\"r50\">\r\n                            {{od.PaymentInformation.NameOnCard}}\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"f100 clear\">\r\n                        <div class=\"l50\">\r\n                            <h3>Expiration Date:</h3>\r\n                        </div>\r\n                        <div class=\"r50\">\r\n\r\n                            {{od.PaymentInformation.CCExpirationDate ? ( od.PaymentInformation.CCExpirationDate | date: 'MM/yyyy' ) : ''}}\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <a data-remodal-action=\"cancel\" class=\"remodal-cancel\">CANCEL</a>\r\n                <a data-remodal-action=\"confirm\" class=\"remodal-confirm\" (click)=\"PlaceOrder()\">SUBMIT</a>\r\n            </div> -->\r\n\r\n            <!--CSS-->\r\n            <!--<link href=\"cart.css\" rel=\"stylesheet\" />-->\r\n            <!--ORDER DETAILS:\r\n               {{od|json}}\r\n               <br />\r\n               PAYMENT  DETAILS:\r\n               {{pd|json}}-->\r\n        </div>\r\n    </div>\r\n</div>"
                //styleUrls: [
                //    'app/shared/directives/payment/cart.css'
                //],
            }]
    }], function () { return [{ type: PaymentService }, { type: ɵngcc2.GlobalDataOpsService }, { type: ɵngcc2.GlobalDomOpsService }, { type: ɵngcc2.AcepSSOService }]; }, { updatePaymentSummary: [{
            type: Output
        }], OrderProcessingCompleted: [{
            type: Output
        }], od: [{
            type: Input
        }], pconfig: [{
            type: Input
        }], managecreditcardscomponent: [{
            type: ViewChild,
            args: ["managecreditcards", { static: false }]
        }], manageecp: [{
            type: ViewChild,
            args: ["manageecp", { static: false }]
        }], termsaddresscomponent: [{
            type: ViewChild,
            args: ["nettermsaddress", { static: false }]
        }], shippingaddresscomponent: [{
            type: ViewChild,
            args: ["shippingaddress", { static: false }]
        }], terms: [{
            type: ViewChild,
            args: ['terms']
        }] }); })();

class ManageCreditCardsComponent {
    // @Output()
    // UpdatePaymentInfoInShoppingCart = new EventEmitter();
    constructor(paymentservice, globaldomops, globaldataops, ssosvc) {
        this.paymentservice = paymentservice;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
        this.PaymentType = PaymentType;
        this.CardType = CardType;
        this.CardHolderType = CardHolderType;
        this.selectedpaytype = new PaymentDetails();
        this.maskedccnum = "";
        this.MM = "";
        this.YYYY = "";
        this.editpay = false;
        this.allowAddMultipleCards = false;
        this.SHOWCARDHOLDERTYPE = false;
        this.SHOWSAVECC = true;
        this.formsubmitted = false;
        this.disableSaveCC = false;
        this._paymentDetailsReset = false;
        this._currentAutoRenewal = false;
        this._isOnShoppingCart = true;
    }
    get savedpaymenttypes() {
        return this._savedpaymenttypes;
    }
    set savedpaymenttypes(val) {
        if (val.filter(function (s) {
            return s.ProfileId === "";
        }).length == 0) {
            val.push(new PaymentDetails());
            this._paymentDetailsReset = true;
        }
        this._savedpaymenttypes = val;
        this.UpdateSelectedPaymentDetails(val[0].ProfileId);
        this.editpay = this.selectedpaytype.ProfileId == "";
        this.updateEditUIBasedOnPage();
        this.globaldomops.initPlugins();
        //pga: Coding-8830 Set the initial value of the AutoRenewal
        if (this._paymentDetailsReset && this.paymentservice && this.paymentservice.orderdetails && this.paymentservice.orderdetails.PaymentInformation) {
            this._currentAutoRenewal = this.paymentservice.orderdetails.PaymentInformation.AutoRenewal;
            this.onAutorRenewalChange();
        }
    }
    get isOnShoppingCart() {
        return this._isOnShoppingCart;
    }
    set isOnShoppingCart(val) {
        this._isOnShoppingCart = val;
        this.SHOWCARDHOLDERTYPE = this._isOnShoppingCart
            ? this.paymentservice.paymentuiconfig.SHOWCARDHOLDERTYPE
            : true;
        this.updateEditUIBasedOnPage();
    }
    ngOnInit() {
        this.yearRange = this.paymentservice.GetExpiryDateYearRange();
        this.allowAddMultipleCards =
            window.location.href.indexOf("paymentoptions") > -1;
        $('.FlowupLabels').FlowupLabels({});
        //pga: Coding-8830 Receive Subscription for auto renewal change and set the initial value
        this.paymentEvents = this.paymentSpecifications.subscribe((data) => {
            this._currentAutoRenewal = data.autoRenewal && data.autoRenewal == 'true' ? true : false;
            this.onAutorRenewalChange();
        });
    }
    //pga: Coding-8830 function to handle the subscription
    onAutorRenewalChange() {
        if (this._currentAutoRenewal) {
            this.selectedpaytype.SaveCC = true;
            this.disableSaveCC = true;
        }
        else {
            this.disableSaveCC = false;
        }
        this._paymentDetailsReset = false;
    }
    //pga: Coding-8830 unsubscribe the subscription
    ngOnDestroy() {
        this.paymentEvents.unsubscribe();
    }
    cancelEditPay() {
        this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = false;
    }
    editPayType(profileid) {
        if (this.selectedpaytype.ProfileId == profileid) {
            //toggle
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = !this
                .editpay;
        }
        else {
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = true;
            this.UpdateSelectedPaymentDetails(profileid);
        }
    }
    savePayType() {
        this.formsubmitted = true;
        //pga: Coding-8830 SaveCC is false but checkbox is disabled, it means it is becasue of reinitializing the Payment Details Object so set the value to true
        if (this.selectedpaytype.SaveCC == 'false' && this.disableSaveCC) {
            this.selectedpaytype.SaveCC = true;
        }
        if (!this.isOnShoppingCart) {
            this.selectedpaytype.SaveCC = true;
            this.selectedpaytype.ContactId = this.ssosvc.contactid;
            //TO DO: Set the Org Here
            if (this.globaldataops.ORG == "ACEP") {
                this.selectedpaytype.OrgCode = OrgCode.ACEP;
            }
            else if (this.globaldataops.ORG == "EMRA") {
                this.selectedpaytype.OrgCode = OrgCode.EMRA;
            }
            else if (this.globaldataops.ORG == "SEMPA") {
                this.selectedpaytype.OrgCode = OrgCode.SEMPA;
            }
        }
        //Call service to Update payment type
        this.paymentservice.UpdatePaymentMethod(this.selectedpaytype).subscribe((response) => {
            if (this.selectedpaytype.ProfileId == "") {
                //ADDS
                let chaseprofileid = (this.selectedpaytype.ProfileId = response.headers.get("chaseprofileid"));
                let paymentmethodid = (this.selectedpaytype.PaymentMethodId = response.headers.get("paymentmethodid"));
                let billingOptionsUpdated = response.headers.get("billingOptionsUpdated");
                if (this.savedpaymenttypes.length == 0) {
                    this.savedpaymenttypes.push(this.selectedpaytype);
                }
                this.globaldomops.notify("Payment Method Created");
            }
            else {
                //UPDATES
                this.globaldomops.notify("Payment Method Updated");
            }
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = false;
            this.updatecardexpdate(this.YYYY, this.MM, this.selectedpaytype.ProfileId);
        }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            this.globaldomops.notify("Payment method failed to update", "", "error");
            // this.globaldomops.hidewait();
        }, () => {
            // this.globaldomops.hidewait();
        });
    }
    updateEditUIBasedOnPage() {
        if (!this.isOnShoppingCart && this.savedpaymenttypes.length == 1) {
            this.editpay = false;
        }
    }
    deletePayTypeConfirm(profileid) {
        this.UpdateSelectedPaymentDetails(profileid);
        let deleteconfirmmodal = $("[data-remodal-id=deletePaymentMethod]").remodal();
        deleteconfirmmodal.open();
    }
    deletePayType() {
        this.formsubmitted = true;
        let pid = this.selectedpaytype.ProfileId;
        //Call service to delete payment type
        this.paymentservice.DeletePaymentMethod(this.selectedpaytype).subscribe(response => {
            this.globaldomops.notify("Payment Method deleted");
            this.savedpaymenttypes = this.savedpaymenttypes.filter(function (s) {
                return s.ProfileId != pid;
            });
        }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            this.globaldomops.notify("Payment method failed to delete", "", "error");
            //  this.globaldomops.hidewait();
        }, () => {
            //  this.globaldomops.hidewait();
        });
    }
    selectPaymentDetails(profileid) {
        this.editpay = profileid == "";
        this.UpdateSelectedPaymentDetails(profileid);
    }
    UpdateSelectedPaymentDetails(profileid) {
        this.formsubmitted = true;
        //RESET Credit Card form if new card
        if (!profileid) {
            this.selectedpaytype = new PaymentDetails();
            this.paymentservice.ResetCreditCardForm();
            //Add some valid test data in dev to save time -- MB 2/4/2025
            if (window.location.href.indexOf('localhost') > -1) {
                this.selectedpaytype.CardType = CardType.Visa;
                this.selectedpaytype.CreditCardNumber = '4111111111111111';
                this.selectedpaytype.NameOnCard = 'TEST ACCOUNT';
                this.selectedpaytype.PostalCode = '112233';
                this.selectedpaytype.CCExpirationDate = "01/01/2030";
                this.selectedpaytype.CVV = "123";
            }
            //pga: Coding-8830 Call the logic to set save checkbox values as Payment Details are reset
            this.onAutorRenewalChange();
        }
        else {
            this.selectedpaytype = this.savedpaymenttypes.filter(function (s) {
                return s.ProfileId === profileid;
            })[0];
        }
        this.maskedccnum = this.paymentservice.MaskCreditCardNumber(this.selectedpaytype.CreditCardNumber);
        if (this.selectedpaytype.CCExpirationDate != "") {
            this.MM = moment(this.selectedpaytype.CCExpirationDate).format("M");
            this.YYYY = moment(this.selectedpaytype.CCExpirationDate).format("YYYY");
        }
        else {
            this.MM = this.YYYY = "";
        }
        this.updatecardexpdate(this.YYYY, this.MM, this.selectedpaytype.ProfileId);
        this.SHOWCARDHOLDERTYPE = this.isOnShoppingCart
            ? this.paymentservice.paymentuiconfig.SHOWCARDHOLDERTYPE
            : true;
        this.SHOWSAVECC = this.paymentservice.paymentuiconfig.SHOWSAVECC;
        //this.UpdatePaymentInfoInShoppingCart.emit(this.selectedpaytype);
        if (this.allowAddMultipleCards) {
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = true;
        }
    }
    updatecardexpdate(year, month, profileid) {
        this.formsubmitted = true;
        if (year != "" && month != "") {
            this.selectedpaytype.CCExpirationDate = month + "/01/" + year;
            //this.UpdatePaymentInfoInShoppingCart.emit(this.selectedpaytype);
        }
    }
    cardnumberchange(newValue) {
        this.selectedpaytype.CardType = this.paymentservice.GetCardTypeFromNumber(newValue);
    }
}
ManageCreditCardsComponent.ɵfac = function ManageCreditCardsComponent_Factory(t) { return new (t || ManageCreditCardsComponent)(ɵngcc0.ɵɵdirectiveInject(PaymentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AcepSSOService)); };
ManageCreditCardsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ManageCreditCardsComponent, selectors: [["manage-creditcards"]], inputs: { savedpaymenttypes: "savedpaymenttypes", isOnShoppingCart: "isOnShoppingCart", paymentSpecifications: "paymentSpecifications" }, decls: 22, vars: 11, consts: [[1, "f100", "rowview", "ccheaderrow", "clear", 3, "hidden"], [1, "col5", "cardinfoCol"], [1, "col5", "expireCol"], [1, "col5", "editCol"], [1, "col5", "deleteCol"], ["class", "f100 clear", 4, "ngFor", "ngForOf"], ["class", "f100 rowview clear", 4, "ngIf"], [1, "f100", "rowview", "addNewCard", "clear", 3, "hidden"], ["type", "button", "value", "+ Add New Card", 3, "click"], ["data-remodal-id", "deletePaymentMethod", 1, "remodal"], ["data-remodal-action", "cancel", 1, "remodal-cancel"], ["data-remodal-action", "confirm", 1, "remodal-confirm", 3, "click"], [1, "f100", "clear"], [1, "f100", "rowview", "clear", 3, "hidden"], [1, "col5", "selectCol", 3, "hidden"], ["type", "radio", "name", "SavedPays", 1, "nolabelauty", 3, "value", "id", "ngModel", "ngModelChange"], [3, "for"], [3, "hidden"], [1, "sprites", "image-NewCard"], [1, "col5", "expireCol", 3, "hidden"], [1, "col5", "editCol", 3, "hidden"], [3, "click"], [1, "col5", "deleteCol", 3, "hidden"], ["id", "ccEditCard", 1, "f100", "editview", 3, "ngClass", "hidden"], [1, "radioBlock", "cardType", "clear", 3, "hidden"], ["type", "radio", "name", "ccType", "id", "PersonalCard", 3, "value", "ngModel", "ngModelChange"], ["for", "PersonalCard", 1, "ccPersonal"], ["type", "radio", "name", "ccType", "id", "CorporateCard", 3, "value", "ngModel", "ngModelChange"], ["for", "CorporateCard", 1, "ccCorporate"], [1, "ccIcons", "clear"], [1, "sprites", "image-Visa"], [1, "sprites", "image-MasterCard"], [1, "sprites", "image-Discover"], [1, "sprites", "image-Amex"], [1, "f100", "clear", 3, "hidden"], [1, "l50"], [1, "validationwrap"], [1, "fl_wrap"], ["for", "ccNumber", 1, "fl_label"], ["name", "ccNumber", "type", "text", "pattern", "creditcard", "id", "ccNumber", "maxlength", "19", "data-validate-length-range", "15", "required", "required", 1, "fl_input", "numeric", 3, "ngModel", "ngModelChange"], [1, "validationhead"], [1, "r50"], ["for", "ccName", 1, "fl_label"], ["type", "text", "name", "ccName", "id", "ccName", "maxlength", "30", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "ccExpireMonth", 1, "fl_label"], ["name", "ccExpireMonth", "required", "required", 1, "fl_input", "required", 3, "ngModel", "ngModelChange", "change"], ["ccExpireMonth", ""], ["value", "1"], ["value", "2"], ["value", "3"], ["value", "4"], ["value", "5"], ["value", "6"], ["value", "7"], ["value", "8"], ["value", "9"], ["value", "10"], ["value", "11"], ["value", "12"], ["for", "ccExpireYear", 1, "fl_label"], ["name", "ccExpireYear", "required", "required", 1, "fl_input", "required", 3, "ngModel", "ngModelChange", "change"], ["ccExpireYear", ""], [3, "value", 4, "ngFor", "ngForOf"], ["for", "savedccZip", 1, "fl_label"], ["type", "text", "id", "savedccZip", "maxlength", "10", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], [1, "r50", 3, "hidden"], [1, "fl_label"], ["type", "text", "id", "ccCVV-CID", "maxlength", "4", "data-validate-length-range", "3", "required", "required", 1, "fl_input", "numeric", 3, "ngModel", "ngModelChange"], ["id", "saveCC", 1, "checkboxWrap", 3, "hidden"], ["type", "checkbox", "id", "SaveCard-Yes", "data-validate", "false", "name", "saveCC", 3, "disabled", "checked", "change"], ["saveCC", ""], ["for", "SaveCard-Yes"], [1, "f100", "cartbtns", "clear", 3, "hidden"], [1, "l33"], ["type", "button", "value", "Cancel", 1, "optionbtn", 3, "click"], [1, "r67", "alignright"], ["type", "button", "value", "Save", 1, "appbtn", 3, "click"], [3, "value"], [1, "f100", "rowview", "clear"]], template: function ManageCreditCardsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, " Credit Card ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, " Expiration Date ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵtext(7, " Edit ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵtext(9, " Delete ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, ManageCreditCardsComponent_div_10_Template, 125, 41, "div", 5);
        ɵngcc0.ɵɵtemplate(11, ManageCreditCardsComponent_div_11_Template, 4, 0, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵelementStart(13, "input", 8);
        ɵngcc0.ɵɵlistener("click", function ManageCreditCardsComponent_Template_input_click_13_listener() { return ctx.editPayType(""); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 9);
        ɵngcc0.ɵɵelementStart(15, "div");
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelement(17, "span");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "a", 10);
        ɵngcc0.ɵɵtext(19, "NO");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "a", 11);
        ɵngcc0.ɵɵlistener("click", function ManageCreditCardsComponent_Template_a_click_20_listener() { return ctx.deletePayType(); });
        ɵngcc0.ɵɵtext(21, "YES");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.isOnShoppingCart ? "shoppingcart-page" : "paymentoptions-page");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.savedpaymenttypes.length == 1 && ctx.selectedpaytype.ProfileId == "" || ctx.isOnShoppingCart);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.savedpaymenttypes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isOnShoppingCart && (ctx.savedpaymenttypes.length == 1 && ctx.selectedpaytype.ProfileId == "") && !ctx.editpay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.isOnShoppingCart || ctx.editpay && ctx.selectedpaytype.ProfileId == "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("Delete card ending with ", ctx.maskedccnum, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("sprites image-", ctx.CardType[ctx.selectedpaytype.CardType], "");
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc4.RadioControlValueAccessor, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.NgClass, ɵngcc4.PatternValidator, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.SelectControlValueAccessor, ɵngcc4.NgSelectOption, ɵngcc4.ɵangular_packages_forms_forms_x], pipes: [ɵngcc3.DatePipe], encapsulation: 2 });
ManageCreditCardsComponent.ctorParameters = () => [
    { type: PaymentService },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
ManageCreditCardsComponent.propDecorators = {
    paymentSpecifications: [{ type: Input }],
    savedpaymenttypes: [{ type: Input, args: ["savedpaymenttypes",] }],
    isOnShoppingCart: [{ type: Input, args: ["isOnShoppingCart",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ManageCreditCardsComponent, [{
        type: Component,
        args: [{
                selector: "manage-creditcards",
                template: "<!--Manage Credit Cards {{selectedpaytype | json}}-->\r\n<!-- {{savedpaymenttypes | json}} -->\r\n\r\n\r\n<div class=\"{{ isOnShoppingCart ? 'shoppingcart-page' : 'paymentoptions-page' }}\">\r\n\r\n  <!-- Header Start -->\r\n  <div class=\"f100 rowview ccheaderrow clear\"\r\n    [hidden]=\"(savedpaymenttypes.length == 1 && selectedpaytype.ProfileId == '') || isOnShoppingCart\">\r\n    <div class=\"col5 cardinfoCol\">\r\n      Credit Card\r\n    </div>\r\n    <div class=\"col5 expireCol\">\r\n      Expiration Date\r\n    </div>\r\n    <div class=\"col5 editCol\">\r\n      Edit\r\n    </div>\r\n    <div class=\"col5 deleteCol\">\r\n      Delete\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Header End -->\r\n\r\n\r\n  <div class=\"f100 clear\" *ngFor=\"let el of savedpaymenttypes; let i = index\">\r\n    <!-- row - -->\r\n    <div class=\"f100 rowview clear\" [hidden]=\"(savedpaymenttypes.length == 1 && selectedpaytype.ProfileId == '')\">\r\n      <div class=\"col5 selectCol\" [hidden]=\"!isOnShoppingCart\">\r\n        <input type=\"radio\" class=\"nolabelauty\" name=\"SavedPays\" value=\"{{el.ProfileId}}\" id=\"Profile-{{i}}\"\r\n          [ngModel]=\"selectedpaytype.ProfileId\" (ngModelChange)=\"selectPaymentDetails(el.ProfileId)\">\r\n        <label for=\"Profile-{{i}}\"></label>\r\n      </div>\r\n      <div class=\"col5 cardinfoCol\">\r\n        <span [hidden]=\"el.ProfileId == ''\">\r\n          <span class=\"sprites image-{{CardType[el.CardType]}}\"></span>x{{el.CreditCardNumber.length > 4 ?\r\n          el.CreditCardNumber.substring(0,4) :\r\n          el.CreditCardNumber}}\r\n        </span>\r\n        <span [hidden]=\"(el.ProfileId != '' || !isOnShoppingCart)\">\r\n          <span class=\"sprites image-NewCard\"></span>New Card </span>\r\n      </div>\r\n      <div class=\"col5 expireCol\" [hidden]=\"el.ProfileId == ''\">\r\n        Exp: {{el.CCExpirationDate ? ( el.CCExpirationDate | date: 'MM/yyyy' ) : ''}}\r\n      </div>\r\n      <div class=\"col5 editCol\" [hidden]=\"el.ProfileId == ''\">\r\n        <a (click)=\"editPayType(el.ProfileId)\">Edit</a>\r\n      </div>\r\n      <div class=\"col5 deleteCol\" [hidden]=\"el.ProfileId == ''\">\r\n        <a (click)=\"deletePayTypeConfirm(el.ProfileId)\">Delete</a>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n    <div id=\"ccEditCard\" class=\"f100 editview\"\r\n      [ngClass]=\"(i + 1) == savedpaymenttypes.length ? 'ccAddNewCard' : 'notnewcard'\"\r\n      [hidden]=\"!((selectedpaytype.ProfileId == el.ProfileId) && editpay) \">\r\n      <!-- card type-->\r\n      <div class=\"radioBlock cardType clear\" [hidden]=\"el.ProfileId != '' || SHOWCARDHOLDERTYPE != true\">\r\n        <input type=\"radio\" name=\"ccType\" id=\"PersonalCard\" value=\"{{CardHolderType.Personal}}\"\r\n          [(ngModel)]=\"selectedpaytype.CardHolderType\" />\r\n        <label class=\"ccPersonal\" for=\"PersonalCard\">Personal Card</label>\r\n        <input type=\"radio\" name=\"ccType\" id=\"CorporateCard\" value=\"{{CardHolderType.Business}}\"\r\n          [(ngModel)]=\"selectedpaytype.CardHolderType\" />\r\n        <label class=\"ccCorporate\" for=\"CorporateCard\">Corporate Card</label>\r\n      </div>\r\n      <!-- /card type-->\r\n      <!-- row -->\r\n\r\n      <div class=\"f100 clear\">\r\n        <!-- credit card icons -->\r\n        <div class=\"ccIcons clear\">\r\n          <div class=\"sprites image-Visa\"></div>\r\n          <div class=\"sprites image-MasterCard\"></div>\r\n          <div class=\"sprites image-Discover\"></div>\r\n          <div class=\"sprites image-Amex\"></div>\r\n        </div>\r\n        <!-- /credit card icons -->\r\n      </div>\r\n      <div class=\"f100 clear\" [hidden]=\"el.ProfileId != ''\">\r\n        <div class=\"l50\">\r\n          <div class=\"validationwrap\">\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"ccNumber\">Card Number</label>\r\n              <input class=\"fl_input numeric\" name=\"ccNumber\" type=\"text\" pattern=\"creditcard\" id=\"ccNumber\"\r\n                [(ngModel)]=\"selectedpaytype.CreditCardNumber\" (ngModelChange)=\"cardnumberchange($event)\" maxlength=\"19\"\r\n                data-validate-length-range=\"15\" required=\"required\" attr.data-validate=\"{{el.ProfileId == ''}}\">\r\n              <span class=\"validationhead\">Required</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"r50\">\r\n\r\n          <div class=\"validationwrap\">\r\n\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"ccName\">Name on Card</label>\r\n              <input class=\"fl_input\" type=\"text\" name=\"ccName\" id=\"ccName\" maxlength=\"30\"\r\n                [(ngModel)]=\"selectedpaytype.NameOnCard\" required=\"required\"\r\n                attr.data-validate=\"{{el.ProfileId == ''}}\">\r\n              <span class=\"validationhead\">Required</span>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- /row -->\r\n      <div class=\"f100 clear\">\r\n        <div class=\"l50\">\r\n          <div class=\"validationwrap \">\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"ccExpireMonth\">Expiration Month</label>\r\n              <select #ccExpireMonth class=\"fl_input required\" name=\"ccExpireMonth\" [(ngModel)]=\"MM\" required=\"required\"\r\n                (change)=\"updatecardexpdate(ccExpireYear.value, ccExpireMonth.value,'')\">\r\n                <option></option>\r\n                <option value=\"1\">01 - Jan</option>\r\n                <option value=\"2\">02 - Feb</option>\r\n                <option value=\"3\">03 - Mar</option>\r\n                <option value=\"4\">04 - Apr</option>\r\n                <option value=\"5\">05 - May</option>\r\n                <option value=\"6\">06 - Jun</option>\r\n                <option value=\"7\">07 - Jul</option>\r\n                <option value=\"8\">08 - Aug</option>\r\n                <option value=\"9\">09 - Sep</option>\r\n                <option value=\"10\">10 - Oct</option>\r\n                <option value=\"11\">11 - Nov</option>\r\n                <option value=\"12\">12 - Dec</option>\r\n              </select>\r\n              <span class=\"validationhead\">Required</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"r50\">\r\n          <div class=\"validationwrap\">\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"ccExpireYear\">Expiration Year</label>\r\n              <select #ccExpireYear class=\"fl_input required\" name=\"ccExpireYear\" [(ngModel)]=\"YYYY\"\r\n                (change)=\"updatecardexpdate(ccExpireYear.value, ccExpireMonth.value,'')\" required=\"required\">\r\n                <option></option>\r\n                <option *ngFor=\"let year of yearRange\" [value]=\"year\">{{year}}</option>\r\n              </select>\r\n              <span class=\"validationhead\">Required</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"f100 clear\">\r\n        <div class=\"l50\">\r\n          <div class=\"validationwrap\">\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"savedccZip\">Billing Zip Code</label>\r\n              <input class=\"fl_input\" type=\"text\" id=\"savedccZip\" [(ngModel)]=\"selectedpaytype.PostalCode\"\r\n                maxlength=\"10\" required=\"required\">\r\n              <span class=\"validationhead\">Required</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"r50\" [hidden]=\"!(el.ProfileId == '')\">\r\n          <div class=\"validationwrap\">\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\">CVV/CID</label>\r\n              <input class=\"fl_input numeric\" type=\"text\" id=\"ccCVV-CID\" [(ngModel)]=\"selectedpaytype.CVV\" maxlength=\"4\"\r\n                data-validate-length-range=\"3\" required=\"required\">\r\n              <span class=\"validationhead\">Required</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!-- <div id=\"updateBO\" class=\"checkboxWrap\" [hidden]=\"isOnShoppingCart\">\r\n                <input #updateBO type=\"checkbox\" id=\"updateBO-Yes\" (change)=\"selectedpaytype.UpdateBillingOptions=updateBO.checked\" [checked]=\"selectedpaytype.UpdateBillingOptions == true\"\r\n                    data-validate=\"false\" name=\"updateBO\" />\r\n                <label for=\"updateBO-Yes\">Update All Billing Options</label>\r\n            </div> -->\r\n\r\n\r\n      <div id=\"saveCC\" class=\"checkboxWrap\"\r\n        [hidden]=\"!(el.ProfileId == '' && SHOWSAVECC == true && !allowAddMultipleCards && isOnShoppingCart)\">\r\n        <input [disabled]=\"disableSaveCC\" #saveCC type=\"checkbox\" id=\"SaveCard-Yes\" (change)=\"selectedpaytype.SaveCC=saveCC.checked\"\r\n          [checked]=\"selectedpaytype.SaveCC == true\" data-validate=\"false\" name=\"saveCC\" />\r\n        <label for=\"SaveCard-Yes\">Save this card for future use</label>\r\n      </div>\r\n      <div class=\"f100 cartbtns clear\" [hidden]=\"!(el.ProfileId != '' || allowAddMultipleCards)\">\r\n        <div class=\"l33\">\r\n          <input type=\"button\" class=\"optionbtn\" value=\"Cancel\" (click)=\"cancelEditPay()\" />\r\n        </div>\r\n        <div class=\"r67 alignright\">\r\n          <input type=\"button\" class=\"appbtn\" value=\"Save\" (click)=\"savePayType()\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- !(!isOnShoppingCart && el.ProfileId == '' &&  !editpay) -->\r\n\r\n  <div class=\"f100 rowview clear\"\r\n    *ngIf=\"(!isOnShoppingCart && (savedpaymenttypes.length == 1 && selectedpaytype.ProfileId == '') && !editpay)\">\r\n    No Payment Methods Found\r\n    <br />\r\n    <br />\r\n  </div>\r\n\r\n  <div class=\"f100 rowview addNewCard clear\"\r\n    [hidden]=\"isOnShoppingCart || (editpay && selectedpaytype.ProfileId == '')\">\r\n    <input type=\"button\" value=\"+ Add New Card\" (click)=\"editPayType('')\">\r\n  </div>\r\n\r\n\r\n\r\n\r\n\r\n  <!--Delete Payment method modal-->\r\n  <div class=\"remodal\" data-remodal-id=\"deletePaymentMethod\">\r\n    <div>Delete card ending with {{ maskedccnum }}\r\n      <span class=\"sprites image-{{CardType[selectedpaytype.CardType]}}\"></span>\r\n    </div>\r\n    <a data-remodal-action=\"cancel\" class=\"remodal-cancel\">NO</a>\r\n    <a data-remodal-action=\"confirm\" class=\"remodal-confirm\" (click)=\"deletePayType()\">YES</a>\r\n  </div>\r\n\r\n</div>"
            }]
    }], function () { return [{ type: PaymentService }, { type: ɵngcc2.GlobalDomOpsService }, { type: ɵngcc2.GlobalDataOpsService }, { type: ɵngcc2.AcepSSOService }]; }, { savedpaymenttypes: [{
            type: Input,
            args: ["savedpaymenttypes"]
        }], isOnShoppingCart: [{
            type: Input,
            args: ["isOnShoppingCart"]
        }], paymentSpecifications: [{
            type: Input
        }] }); })();

class ManageBillingOptionsComponent {
    constructor(paymentservice, globaldomops, globaldataops, ssosvc) {
        this.paymentservice = paymentservice;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
        this.PaymentType = PaymentType;
        this.CardType = CardType;
        this.CardHolderType = CardHolderType;
        this.updateinprogress = false;
        //selectedbillingoption: BillingOption = new BillingOption();
        this.savedbillingoptions = [];
        this.savedpaymenttypes = [];
        this.billingoptiontype = ''; //Membership/Subscription
        this.IsCurrentMode = true; // the other one is past subscriptions..false
    }
    ngOnInit() {
        let thiscomponent = this;
        setTimeout(function () {
            // http://www.marghoobsuleman.com/jquery-image-dropdown
            $('.paymentoptions').msDropDown();
            $(".paymentoptions").change(function () {
                //alert($(this).val())
                if (!this.updateinprogress) {
                    this.updateinprogress = true;
                    let boid = $(this).attr('data-boid');
                    let pid = $(this).val();
                    let bo = thiscomponent.savedbillingoptions.filter(b => b.BillingOptionId == boid)[0];
                    thiscomponent.updateBillingOption(bo, pid);
                }
            });
        }, 500);
    }
    updateBillingOption(billingoption, paymentmethodid) {
        billingoption.PaymentMethodId = paymentmethodid;
        this.paymentservice.UpdateBillingOption(billingoption).subscribe((response) => {
            this.globaldomops.notify("Billing Option Updated");
            this.updateinprogress = false;
        }, error => {
            this.globaldomops.notify('Billing Option failed to update', '', 'error');
            this.updateinprogress = false;
            // this.globaldomops.hidewait();
        }, () => {
            // this.globaldomops.hidewait();
        });
    }
}
ManageBillingOptionsComponent.ɵfac = function ManageBillingOptionsComponent_Factory(t) { return new (t || ManageBillingOptionsComponent)(ɵngcc0.ɵɵdirectiveInject(PaymentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AcepSSOService)); };
ManageBillingOptionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ManageBillingOptionsComponent, selectors: [["manage-billingoptions"]], inputs: { savedbillingoptions: "savedbillingoptions", savedpaymenttypes: "savedpaymenttypes", billingoptiontype: "billingoptiontype", IsCurrentMode: "IsCurrentMode" }, decls: 14, vars: 7, consts: [[1, "billingoptions"], [1, "f100", "clear", 3, "hidden"], [1, "f100", "rowview", "ccheaderrow", "clear"], [1, "bo-col", "bo-col-name"], [1, "bo-col"], ["class", "bo-col", 4, "ngIf"], ["class", "bo-col bo-col-paymentoptions", 4, "ngIf"], ["class", "f100 clear", 4, "ngFor", "ngForOf"], [1, "bo-col", "bo-col-paymentoptions"], [1, "f100", "clear"], [1, "f100", "rowview", "clear"], [1, "paymentoptions", 3, "name", "ngModel", "ngModelChange"], ["t", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function ManageBillingOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtext(6, " Name ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵtext(8, " Start Date ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 4);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, ManageBillingOptionsComponent_div_11_Template, 2, 0, "div", 5);
        ɵngcc0.ɵɵtemplate(12, ManageBillingOptionsComponent_div_12_Template, 2, 0, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, ManageBillingOptionsComponent_div_13_Template, 10, 5, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.savedbillingoptions.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" No ", ctx.billingoptiontype, "s Found ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.savedbillingoptions.length == 0);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.IsCurrentMode ? "Renewal Date" : "End Date", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.IsCurrentMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.IsCurrentMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.savedbillingoptions);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgForOf, ɵngcc4.SelectControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc4.NgSelectOption, ɵngcc4.ɵangular_packages_forms_forms_x], encapsulation: 2 });
ManageBillingOptionsComponent.ctorParameters = () => [
    { type: PaymentService },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
ManageBillingOptionsComponent.propDecorators = {
    savedbillingoptions: [{ type: Input }],
    savedpaymenttypes: [{ type: Input }],
    billingoptiontype: [{ type: Input }],
    IsCurrentMode: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ManageBillingOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'manage-billingoptions',
                template: "<!--Manage Credit Cards {{selectedpaytype | json}}-->\r\n<!-- {{savedbillingoptions | json}} <br/> -->\r\n\r\n\r\n<div class=\"billingoptions\">\r\n\r\n    <div class=\"f100 clear\" [hidden]=\"savedbillingoptions.length > 0\">\r\n\r\n        No {{billingoptiontype}}s Found\r\n\r\n    </div>\r\n\r\n    <div class=\"f100 clear\" [hidden]=\"savedbillingoptions.length == 0\">\r\n\r\n        <!-- Header Start -->\r\n        <div class=\"f100 rowview ccheaderrow clear\">\r\n            <div class=\"bo-col bo-col-name\">\r\n                Name\r\n            </div>\r\n            <div class=\"bo-col\">\r\n                Start Date\r\n            </div>\r\n            \r\n            <div class=\"bo-col\">\r\n               {{ IsCurrentMode ? 'Renewal Date' : 'End Date' }} \r\n            </div>\r\n\r\n            <div class=\"bo-col\" *ngIf=\"IsCurrentMode\">\r\n                Auto Renewal\r\n            </div>\r\n            <!-- <div class=\"bo-col\" *ngIf=\"IsCurrentMode\">\r\n                Installments\r\n            </div> -->\r\n            <div class=\"bo-col bo-col-paymentoptions\" *ngIf=\"IsCurrentMode\">\r\n                Payment Method\r\n            </div>\r\n        </div>\r\n\r\n        <!-- Header End -->\r\n\r\n        <div class=\"f100 clear\" *ngFor=\"let el of savedbillingoptions; let i = index\">\r\n\r\n            <div class=\"f100 rowview clear\">\r\n                <div class=\"bo-col bo-col-name\">\r\n                    {{el.ProductName}}\r\n                </div>\r\n                <div class=\"bo-col\">\r\n                    {{el.StartDate}}\r\n                </div>\r\n                \r\n                <div class=\"bo-col\" >\r\n                    {{el.ExpireDate}}\r\n                </div>\r\n                <div class=\"bo-col\" *ngIf=\"IsCurrentMode\">\r\n                    {{el.IsOnAutoRenewal ? 'Yes' : 'No'}}\r\n                </div>\r\n                <!-- <div class=\"bo-col\">\r\n                    {{el.OnInstallments ? 'Yes' : 'No'}}\r\n                </div> -->\r\n                <div class=\"bo-col bo-col-paymentoptions\" *ngIf=\"IsCurrentMode && el.BillingOptionId\">\r\n                    <!-- {{el.PaymentType}} -->\r\n                    <!-- (change)=\"updateBillingOption(el,t.value)\" -->\r\n                    <select attr.data-boid={{el.BillingOptionId}} class=\"paymentoptions\" name=\"paymentMethodId_{{el.BillingOptionId}}\" #t  \r\n                        [(ngModel)]=\"el.PaymentMethodId\">\r\n                            <option *ngFor=\"let pt of savedpaymenttypes\" [value]=\"pt.PaymentMethodId\"  attr.data-image=\"assets/resources/images/logos/{{CardType[pt.CardType] + ''}}.png\" >{{CardType[pt.CardType] + ''}}-x{{pt.CreditCardNumber}}</option>\r\n                            </select>\r\n\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n\r\n\r\n\r\n\r\n\r\n    </div>\r\n\r\n\r\n</div>"
            }]
    }], function () { return [{ type: PaymentService }, { type: ɵngcc2.GlobalDomOpsService }, { type: ɵngcc2.GlobalDataOpsService }, { type: ɵngcc2.AcepSSOService }]; }, { savedbillingoptions: [{
            type: Input
        }], savedpaymenttypes: [{
            type: Input
        }], billingoptiontype: [{
            type: Input
        }], IsCurrentMode: [{
            type: Input
        }] }); })();

class TermsAddressComponent {
    constructor(paymentsvc) {
        this.paymentsvc = paymentsvc;
        this.ui_stateprovinces = this.paymentsvc.uidata.StateProvinces;
        this.ui_countries = this.paymentsvc.uidata.Countries;
        this.address = new NetTermsAddress();
        this.validate = true;
        this.displayAttentionLine = true;
    }
    ngOnInit() {
    }
    initdata() {
        this.ui_countries = this.paymentsvc.uidata.Countries.filter(a => a.acep_iso2code == 'US' || a.acep_iso2code == 'CA');
        ;
        this.refreshStateProvinces();
        this.address.accountnumber = this.paymentsvc.orderdetails.AccountNumber;
        this.address.addresstype = "Billing";
        // this.address = {
        //   accountnumber: this.paymentsvc.orderdetails.AccountNumber,
        //   isprimary : false,
        //   accountname : '', 
        //   addressid : '',
        //   address1: 'adress1',
        //   address2: 'address2',
        //   address3: 'address3',
        //   addresstype: 'Billing',
        //   city: 'cityname',
        //   contactemail: 'mb@acep.org',
        //   contactname: 'mohan',
        //   contactphone: '8787878',
        //   country: 'US',
        //   state: 'TX',
        //   zip: '12345'
        // }
    }
    onCountrySelect(countrycode) {
        this.refreshStateProvinces();
    }
    refreshStateProvinces() {
        this.ui_stateprovinces = this.paymentsvc.uidata.StateProvinces.filter(s => s.countrycode === this.address.country);
    }
}
TermsAddressComponent.ɵfac = function TermsAddressComponent_Factory(t) { return new (t || TermsAddressComponent)(ɵngcc0.ɵɵdirectiveInject(PaymentService)); };
TermsAddressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TermsAddressComponent, selectors: [["app-nettermsaddress"]], inputs: { address: "address", validate: "validate", displayAttentionLine: "displayAttentionLine" }, decls: 82, vars: 17, consts: [["id", "termsform"], [1, "f100", "clear"], [1, "validationwrap"], [1, "fl_wrap"], ["for", "Country", 1, "fl_label"], ["name", "Country", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange", "change"], ["value", ""], [3, "value", 4, "ngFor", "ngForOf"], [1, "validationhead"], ["for", "Address1", 1, "fl_label"], ["type", "text", "id", "Address2", "name", "Address2", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "Address2", 1, "fl_label"], ["type", "text", "id", "Address3", "name", "Address3", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "City", 1, "fl_label"], ["type", "text", "id", "City", "name", "City", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], [1, "fl_wrap", 3, "hidden"], ["for", "StateProvince", 1, "fl_label"], ["name", "StateProvince", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "Zip", 1, "fl_label"], ["type", "text", "id", "Zip", "name", "Zip", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "ContactName", 1, "fl_label"], ["type", "text", "id", "ContactName", "name", "ContactName", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "ContactPhone", 1, "fl_label"], ["type", "text", "id", "ContactPhone", "name", "ContactPhone", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "ContactEmail", 1, "fl_label"], ["type", "text", "id", "ContactEmail", "name", "ContactEmail", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], [1, "resourcesCtr", "downloads"], ["target", "_blank", "title", "W9", "href", "https://s3.amazonaws.com/acep-assets/global/W-9.pdf"], [3, "value"]], template: function TermsAddressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "label", 4);
        ɵngcc0.ɵɵtext(5, "Country");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "select", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_select_ngModelChange_6_listener($event) { return ctx.address.country = $event; })("change", function TermsAddressComponent_Template_select_change_6_listener($event) { return ctx.onCountrySelect($event.target.value); });
        ɵngcc0.ɵɵelement(7, "option", 6);
        ɵngcc0.ɵɵtemplate(8, TermsAddressComponent_option_8_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 8);
        ɵngcc0.ɵɵtext(10, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 1);
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵelementStart(14, "label", 9);
        ɵngcc0.ɵɵtext(15, "Address 1");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "input", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_16_listener($event) { return ctx.address.address2 = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "span", 8);
        ɵngcc0.ɵɵtext(18, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 1);
        ɵngcc0.ɵɵelementStart(20, "div", 2);
        ɵngcc0.ɵɵelementStart(21, "div", 3);
        ɵngcc0.ɵɵelementStart(22, "label", 11);
        ɵngcc0.ɵɵtext(23, "Address 2");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "input", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_24_listener($event) { return ctx.address.address3 = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "span", 8);
        ɵngcc0.ɵɵtext(26, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div", 1);
        ɵngcc0.ɵɵelementStart(28, "div", 2);
        ɵngcc0.ɵɵelementStart(29, "div", 3);
        ɵngcc0.ɵɵelementStart(30, "label", 13);
        ɵngcc0.ɵɵtext(31, "City");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_32_listener($event) { return ctx.address.city = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "span", 8);
        ɵngcc0.ɵɵtext(34, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 1);
        ɵngcc0.ɵɵelementStart(36, "div", 2);
        ɵngcc0.ɵɵelementStart(37, "div", 15);
        ɵngcc0.ɵɵelementStart(38, "label", 16);
        ɵngcc0.ɵɵtext(39, "State/Province");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "select", 17);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_select_ngModelChange_40_listener($event) { return ctx.address.state = $event; });
        ɵngcc0.ɵɵelement(41, "option", 6);
        ɵngcc0.ɵɵtemplate(42, TermsAddressComponent_option_42_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "span", 8);
        ɵngcc0.ɵɵtext(44, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "div", 1);
        ɵngcc0.ɵɵelementStart(46, "div", 2);
        ɵngcc0.ɵɵelementStart(47, "div", 3);
        ɵngcc0.ɵɵelementStart(48, "label", 18);
        ɵngcc0.ɵɵtext(49, "Zip/Postal Code");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "input", 19);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_50_listener($event) { return ctx.address.zip = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "span", 8);
        ɵngcc0.ɵɵtext(52, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "div", 1);
        ɵngcc0.ɵɵelementStart(54, "div", 2);
        ɵngcc0.ɵɵelementStart(55, "div", 3);
        ɵngcc0.ɵɵelementStart(56, "label", 20);
        ɵngcc0.ɵɵtext(57, "Payables Contact");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(58, "input", 21);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_58_listener($event) { return ctx.address.contactname = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(59, "span", 8);
        ɵngcc0.ɵɵtext(60, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(61, "div", 1);
        ɵngcc0.ɵɵelementStart(62, "div", 2);
        ɵngcc0.ɵɵelementStart(63, "div", 3);
        ɵngcc0.ɵɵelementStart(64, "label", 22);
        ɵngcc0.ɵɵtext(65, "Payables Phone");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(66, "input", 23);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_66_listener($event) { return ctx.address.contactphone = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(67, "span", 8);
        ɵngcc0.ɵɵtext(68, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(69, "div", 1);
        ɵngcc0.ɵɵelementStart(70, "div", 2);
        ɵngcc0.ɵɵelementStart(71, "div", 3);
        ɵngcc0.ɵɵelementStart(72, "label", 24);
        ɵngcc0.ɵɵtext(73, "Payables Email");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(74, "input", 25);
        ɵngcc0.ɵɵlistener("ngModelChange", function TermsAddressComponent_Template_input_ngModelChange_74_listener($event) { return ctx.address.contactemail = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(75, "span", 8);
        ɵngcc0.ɵɵtext(76, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(77, "div", 1);
        ɵngcc0.ɵɵelementStart(78, "div", 26);
        ɵngcc0.ɵɵelementStart(79, "p");
        ɵngcc0.ɵɵelementStart(80, "a", 27);
        ɵngcc0.ɵɵtext(81, "ACEP Form W-9");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.country);
        ɵngcc0.ɵɵattribute("data-validate", ctx.validate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.ui_countries);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.address2);
        ɵngcc0.ɵɵattribute("data-validate", ctx.validate);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.address3);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.city);
        ɵngcc0.ɵɵattribute("data-validate", ctx.validate);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", ctx.ui_stateprovinces && ctx.ui_stateprovinces.length == 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.state);
        ɵngcc0.ɵɵattribute("data-validate", ctx.validate && ctx.ui_stateprovinces.length > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.ui_stateprovinces);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.zip);
        ɵngcc0.ɵɵattribute("data-validate", ctx.validate);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.contactname);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.contactphone);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address.contactemail);
    } }, directives: [ɵngcc4.SelectControlValueAccessor, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc4.NgSelectOption, ɵngcc4.ɵangular_packages_forms_forms_x, ɵngcc3.NgForOf, ɵngcc4.DefaultValueAccessor], encapsulation: 2 });
TermsAddressComponent.ctorParameters = () => [
    { type: PaymentService }
];
TermsAddressComponent.propDecorators = {
    address: [{ type: Input }],
    validate: [{ type: Input }],
    displayAttentionLine: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TermsAddressComponent, [{
        type: Component,
        args: [{
                moduleId: module.id,
                selector: 'app-nettermsaddress',
                template: "<!--{{address | json}}-->\r\n<!-- row -->\r\n<div id=\"termsform\">\r\n  <!-- <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"Address1\">Department Name</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"Address1\" name=\"Address1\" [(ngModel)]=\"address.address1\" required=\"required\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div> -->\r\n\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"Country\">Country</label>\r\n        <select class=\"fl_input\" name=\"Country\" [(ngModel)]=\"address.country\" (change)=\"onCountrySelect($event.target.value)\" required=\"required\"\r\n          attr.data-validate=\"{{validate}}\">\r\n          <option value=\"\"></option>\r\n          <option *ngFor=\"let obj of ui_countries\" [value]=\"obj.acep_iso2code\">{{obj.acep_name}}</option>\r\n        </select>\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"Address1\">Address 1</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"Address2\" name=\"Address2\" [(ngModel)]=\"address.address2\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"Address2\">Address 2</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"Address3\" name=\"Address3\" [(ngModel)]=\"address.address3\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n\r\n\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"City\">City</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"City\" name=\"City\" [(ngModel)]=\"address.city\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\" [hidden]=\"(ui_stateprovinces && ui_stateprovinces.length == 0)\">\r\n        <label class=\"fl_label\" for=\"StateProvince\">State/Province</label>\r\n        <select class=\"fl_input\" name=\"StateProvince\" [(ngModel)]=\"address.state\" required=\"required\" attr.data-validate=\"{{validate && ui_stateprovinces.length > 0}}\">\r\n          <option value=\"\"></option>\r\n          <option *ngFor=\"let obj of ui_stateprovinces\" [value]=\"obj.acep_isocode\">{{obj.acep_name}}</option>\r\n        </select>\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- row -->\r\n  <div class=\"f100 clear\">\r\n\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"Zip\">Zip/Postal Code</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"Zip\" name=\"Zip\" [(ngModel)]=\"address.zip\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <!-- /row -->\r\n\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"ContactName\">Payables Contact</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"ContactName\" name=\"ContactName\" [(ngModel)]=\"address.contactname\" required=\"required\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"ContactPhone\">Payables Phone</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"ContactPhone\" name=\"ContactPhone\" [(ngModel)]=\"address.contactphone\" required=\"required\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n\r\n  <div class=\"f100 clear\">\r\n    <div class=\"validationwrap\">\r\n      <div class=\"fl_wrap\">\r\n        <label class=\"fl_label\" for=\"ContactEmail\">Payables Email</label>\r\n        <input class=\"fl_input\" type=\"text\" id=\"ContactEmail\" name=\"ContactEmail\" [(ngModel)]=\"address.contactemail\" required=\"required\">\r\n        <span class=\"validationhead\">Required</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"f100 clear\">\r\n  <div class=\"resourcesCtr downloads\">\r\n    <p>\r\n      <a target=\"_blank\" title=\"W9\" href='https://s3.amazonaws.com/acep-assets/global/W-9.pdf'>ACEP Form W-9</a>\r\n    </p>\r\n  </div>\r\n  </div>\r\n\r\n</div>"
            }]
    }], function () { return [{ type: PaymentService }]; }, { address: [{
            type: Input
        }], validate: [{
            type: Input
        }], displayAttentionLine: [{
            type: Input
        }] }); })();

class ShippingaddressComponent {
    constructor(paymentsvc) {
        this.paymentsvc = paymentsvc;
        this.ui_stateprovinces = this.paymentsvc.uidata.StateProvinces;
        this.ui_countries = this.paymentsvc.uidata.Countries;
        this.addresses = [];
        this.validate = true;
        //UPDATE PAYMENT SUMMARY//
        this.updateShippingRates = new EventEmitter();
        this.address = new ShippingAddress();
        this.blankAddress = new ShippingAddress();
    }
    ngOnInit() {
        // this.getMockData();
        this.initdata();
    }
    initdata() {
        var _a;
        this.ui_countries = this.paymentsvc.uidata.Countries;
        this.address = ((_a = this.addresses) === null || _a === void 0 ? void 0 : _a.length) > 0 ? this.addresses[0] : new ShippingAddress();
        this.refreshStateProvinces();
    }
    getMockData() {
        //mock
        this.addresses = [{
                attention: 'Romeo Bonthu',
                street1: '123 Exchange Street',
                street2: 'Suite A123',
                city: 'Fort Knox',
                stateOrProvince: 'TX',
                country: 'US',
                zip: '53453',
                email: 'romeo@gmail.com',
                phone: '333-444-3333'
            },
            {
                attention: 'Rocky Bonthu',
                street1: '000 Exchange Street',
                street2: 'Suite A555',
                city: 'Boo Knox',
                stateOrProvince: 'WY',
                country: 'US',
                zip: '6666',
                email: 'rocky@gmail.com',
                phone: '999-444-3333'
            }];
    }
    onCountrySelect(countrycode) {
        this.refreshStateProvinces();
        this.updateShippingAddress();
    }
    onStateSelect(statecode) {
        this.updateShippingAddress(statecode);
    }
    refreshStateProvinces() {
        this.ui_stateprovinces = this.paymentsvc.uidata.StateProvinces.filter(s => s.countrycode === this.address.country);
    }
    formatAddress(a) {
        var _a, _b, _c, _d, _e, _f, _g;
        let arr = [(_a = a.attention) !== null && _a !== void 0 ? _a : '', (_b = a.street1) !== null && _b !== void 0 ? _b : '', (_c = a.street2) !== null && _c !== void 0 ? _c : '', (_d = a.city) !== null && _d !== void 0 ? _d : '', (_e = a.stateOrProvince) !== null && _e !== void 0 ? _e : '', (_f = a.zip) !== null && _f !== void 0 ? _f : '', (_g = a.country) !== null && _g !== void 0 ? _g : ''];
        arr = arr.filter(k => k != '');
        let s = arr.join(', ');
        // let s = `${a.address1 ? a.address1  : ''}${a.address2 ? a.address2 + ', ' : ''}${a.address3 ? a.address3 + ', ' : ''}${a.city ? a.city + ', ' : ''}${a.state ? a.state + ', ' : ''}${a.zip ? a.zip: ''}`;
        return s;
    }
    updateShippingAddress(e) {
        this.updateShippingRates.emit(this.address);
    }
    returnToCart() {
        $(".backbtn").click();
    }
}
ShippingaddressComponent.ɵfac = function ShippingaddressComponent_Factory(t) { return new (t || ShippingaddressComponent)(ɵngcc0.ɵɵdirectiveInject(PaymentService)); };
ShippingaddressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ShippingaddressComponent, selectors: [["app-shippingaddress"]], inputs: { addresses: "addresses", validate: "validate" }, outputs: { updateShippingRates: "updateShippingRates" }, decls: 19, vars: 7, consts: [["id", "shippingform"], ["class", "f100 clear shippingalert", 4, "ngIf"], [1, "f100", "clear"], [1, "validationwrap"], [1, "fl_wrap", 3, "hidden"], ["for", "Addresses", 1, "fl_label"], ["name", "Addresses", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange", "change"], ["addressSelect", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "validationhead"], ["class", "addressForm", 4, "ngIf"], [1, "f100", "clear", "shippingalert"], [1, "fl_wrap"], ["aria-hidden", "true", 1, "caution", "red"], [1, "f100", "shippingBtns", "clear"], ["type", "button", "value", "Return to Shopping Cart", 1, "btn", "btn-block", 3, "click"], [1, "addressForm"], ["for", "Country", 1, "fl_label"], ["name", "Country", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange", "change"], ["value", ""], [3, "value", 4, "ngFor", "ngForOf"], ["for", "attention", 1, "fl_label"], ["type", "text", "id", "attention", "name", "attention", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "Street1", 1, "fl_label"], ["type", "text", "id", "Street1", "name", "Street1", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "Street2", 1, "fl_label"], ["type", "text", "id", "Street2", "name", "Street2", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "City", 1, "fl_label"], ["type", "text", "id", "City", "name", "City", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "StateProvince", 1, "fl_label"], ["name", "StateProvince", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange", "change"], ["for", "Zip", 1, "fl_label"], ["type", "text", "id", "Zip", "name", "Zip", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "ShippingPhone", 1, "fl_label"], ["type", "text", "id", "ShippingPhone", "name", "ShippingPhone", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], ["for", "ShippingEmail", 1, "fl_label"], ["type", "text", "id", "ShippingEmail", "name", "ShippingEmail", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], [3, "value"]], template: function ShippingaddressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h3");
        ɵngcc0.ɵɵtext(2, "Address");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p");
        ɵngcc0.ɵɵtext(4, "This information is required for shipping or sales tax");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ShippingaddressComponent_div_5_Template, 6, 0, "div", 1);
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵelementStart(9, "label", 5);
        ɵngcc0.ɵɵtext(10, "Address");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "select", 6, 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function ShippingaddressComponent_Template_select_ngModelChange_11_listener($event) { return ctx.address = $event; })("change", function ShippingaddressComponent_Template_select_change_11_listener($event) { return ctx.updateShippingAddress($event.target.value); });
        ɵngcc0.ɵɵtemplate(13, ShippingaddressComponent_option_13_Template, 2, 2, "option", 8);
        ɵngcc0.ɵɵelementStart(14, "option", 9);
        ɵngcc0.ɵɵtext(15, "+ Add New Address");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "span", 10);
        ɵngcc0.ɵɵtext(17, "Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, ShippingaddressComponent_div_18_Template, 77, 18, "div", 11);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.address == null ? null : ctx.address.country) != "US");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.addresses && (ctx.addresses == null ? null : ctx.addresses.length) == 0);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.address);
        ɵngcc0.ɵɵattribute("data-validate", ctx.validate && (ctx.addresses == null ? null : ctx.addresses.length) > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.addresses);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngValue", ctx.blankAddress);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.address);
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.SelectControlValueAccessor, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.NgForOf, ɵngcc4.NgSelectOption, ɵngcc4.ɵangular_packages_forms_forms_x, ɵngcc4.DefaultValueAccessor], encapsulation: 2 });
ShippingaddressComponent.ctorParameters = () => [
    { type: PaymentService }
];
ShippingaddressComponent.propDecorators = {
    addresses: [{ type: Input }],
    validate: [{ type: Input }],
    updateShippingRates: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ShippingaddressComponent, [{
        type: Component,
        args: [{
                selector: 'app-shippingaddress',
                template: "<div id=\"shippingform\">\r\n    <h3>Address</h3>\r\n    <p>This information is required for shipping or sales tax</p>\r\n\r\n\r\n    <div class=\"f100 clear shippingalert\" *ngIf=\"address?.country != 'US'\">\r\n        <div class=\"fl_wrap\">\r\n            <span class=\"caution red\" aria-hidden=\"true\"></span>We currently do not ship internationally, non-digital products should be removed.\r\n        </div>\r\n\r\n        <div class=\"f100 shippingBtns clear\">\r\n            <input type=\"button\" class=\"btn btn-block\" value=\"Return to Shopping Cart\" (click)=\"returnToCart()\" />\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <!-- {{address | json}} -->\r\n    <div class=\"f100 clear\">\r\n        <div class=\"validationwrap\">\r\n            <div class=\"fl_wrap\" [hidden]=\"(addresses && addresses?.length == 0)\">\r\n                <label class=\"fl_label\" for=\"Addresses\">Address</label>\r\n                <select #addressSelect class=\"fl_input\" name=\"Addresses\" required=\"required\" attr.data-validate=\"{{validate && addresses?.length > 0}}\" [(ngModel)]=\"address\" (change)=\"updateShippingAddress($event.target.value)\">\r\n\r\n                    <option *ngFor=\"let obj of addresses\" [ngValue]=\"obj\">{{formatAddress(obj)}}</option>\r\n\r\n                    <option [ngValue]=\"blankAddress\">+ Add New Address</option>\r\n                </select>\r\n                <span class=\"validationhead\">Required</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n\r\n\r\n\r\n    <div class=\"addressForm\" *ngIf=\"address\">\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"Country\">Country</label>\r\n                    <select class=\"fl_input\" name=\"Country\" [(ngModel)]=\"address.country\" (change)=\"onCountrySelect($event.target.value)\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n                        <option value=\"\"></option>\r\n                        <option *ngFor=\"let obj of ui_countries\" [value]=\"obj.acep_iso2code\">{{obj.acep_name}}</option>\r\n                    </select>\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"attention\">Name</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"attention\" name=\"attention\" [(ngModel)]=\"address.attention\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"Street1\">Address 1</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"Street1\" name=\"Street1\" [(ngModel)]=\"address.street1\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"Street2\">Address 2</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"Street2\" name=\"Street2\" [(ngModel)]=\"address.street2\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"City\">City</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"City\" name=\"City\" [(ngModel)]=\"address.city\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\" [hidden]=\"(ui_stateprovinces && ui_stateprovinces.length == 0)\">\r\n                    <label class=\"fl_label\" for=\"StateProvince\">State/Province</label>\r\n                    <select class=\"fl_input\" name=\"StateProvince\" [(ngModel)]=\"address.stateOrProvince\" required=\"required\" (change)=\"onStateSelect($event.target.value)\" attr.data-validate=\"{{validate && ui_stateprovinces.length > 0}}\">\r\n                        <option value=\"\"></option>\r\n                        <option *ngFor=\"let obj of ui_stateprovinces\" [value]=\"obj.acep_isocode\">{{obj.acep_name}}</option>\r\n                    </select>\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <!-- row -->\r\n        <div class=\"f100 clear\">\r\n\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"Zip\">Zip/Postal Code</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"Zip\" name=\"Zip\" [(ngModel)]=\"address.zip\" required=\"required\" attr.data-validate=\"{{validate}}\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n        <!-- /row -->\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"ShippingPhone\">Phone</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"ShippingPhone\" name=\"ShippingPhone\" [(ngModel)]=\"address.phone\" required=\"required\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"f100 clear\">\r\n            <div class=\"validationwrap\">\r\n                <div class=\"fl_wrap\">\r\n                    <label class=\"fl_label\" for=\"ShippingEmail\">Email</label>\r\n                    <input class=\"fl_input\" type=\"text\" id=\"ShippingEmail\" name=\"ShippingEmail\" [(ngModel)]=\"address.email\" required=\"required\">\r\n                    <span class=\"validationhead\">Required</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n\r\n        <!-- <div class=\"f100 clear\">\r\n            <div class=\"r67 alignright\">\r\n                <input type=\"submit\" class=\"optionbtn bluebtn\" value=\"Update\" (click)=\"updateShippingAddress($event)\" />\r\n            </div>\r\n        </div> -->\r\n    </div>\r\n\r\n\r\n\r\n</div>"
            }]
    }], function () { return [{ type: PaymentService }]; }, { addresses: [{
            type: Input
        }], validate: [{
            type: Input
        }], updateShippingRates: [{
            type: Output
        }] }); })();

class ManageECPComponent {
    // @Output()
    // UpdatePaymentInfoInShoppingCart = new EventEmitter();
    constructor(paymentservice, globaldomops, globaldataops, ssosvc) {
        this.paymentservice = paymentservice;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
        this.PaymentType = PaymentType;
        this.ECPAccountType = ECPAccountType;
        //CardHolderType: typeof CardHolderType = CardHolderType;
        this.selectedpaytype = new PaymentDetails();
        this.maskedccnum = "";
        this.MM = "";
        this.YYYY = "";
        this.editpay = false;
        this.allowAddMultipleCards = false;
        this.SHOWCARDHOLDERTYPE = false;
        this.SHOWSAVECC = true;
        this.formsubmitted = false;
        this.disableSaveCC = false;
        this._paymentDetailsReset = false;
        this._currentAutoRenewal = false;
        this._isOnShoppingCart = true;
    }
    get savedpaymenttypes() {
        return this._savedpaymenttypes;
    }
    set savedpaymenttypes(val) {
        if (val.filter(function (s) {
            return s.ProfileId === "";
        }).length == 0) {
            val.push(new PaymentDetails());
            this._paymentDetailsReset = true;
        }
        this._savedpaymenttypes = val;
        this.UpdateSelectedPaymentDetails(val[0].ProfileId);
        this.editpay = this.selectedpaytype.ProfileId == "";
        this.updateEditUIBasedOnPage();
        this.globaldomops.initPlugins();
        //pga: Coding-8830 Set the initial value of the AutoRenewal
        if (this._paymentDetailsReset && this.paymentservice && this.paymentservice.orderdetails && this.paymentservice.orderdetails.PaymentInformation) {
            this._currentAutoRenewal = this.paymentservice.orderdetails.PaymentInformation.AutoRenewal;
            this.onAutorRenewalChange();
        }
    }
    get isOnShoppingCart() {
        return this._isOnShoppingCart;
    }
    set isOnShoppingCart(val) {
        this._isOnShoppingCart = val;
        this.SHOWCARDHOLDERTYPE = this._isOnShoppingCart
            ? this.paymentservice.paymentuiconfig.SHOWCARDHOLDERTYPE
            : true;
        this.updateEditUIBasedOnPage();
    }
    ngOnInit() {
        this.yearRange = this.paymentservice.GetExpiryDateYearRange();
        this.allowAddMultipleCards =
            window.location.href.indexOf("paymentoptions") > -1;
        $('.FlowupLabels').FlowupLabels({});
        //pga: Coding-8830 Receive Subscription for auto renewal change and set the initial value
        this.paymentEvents = this.paymentSpecifications.subscribe((data) => {
            this._currentAutoRenewal = data.autoRenewal && data.autoRenewal == 'true' ? true : false;
            this.onAutorRenewalChange();
        });
    }
    //pga: Coding-8830 function to handle the subscription
    onAutorRenewalChange() {
        if (this._currentAutoRenewal) {
            this.selectedpaytype.SaveCC = true;
            this.disableSaveCC = true;
        }
        else {
            this.disableSaveCC = false;
        }
        this._paymentDetailsReset = false;
    }
    //pga: Coding-8830 unsubscribe the subscription
    ngOnDestroy() {
        this.paymentEvents.unsubscribe();
    }
    cancelEditPay() {
        this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = false;
    }
    editPayType(profileid) {
        if (this.selectedpaytype.ProfileId == profileid) {
            //toggle
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = !this
                .editpay;
        }
        else {
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = true;
            this.UpdateSelectedPaymentDetails(profileid);
        }
    }
    savePayType() {
        this.formsubmitted = true;
        if (!this.isOnShoppingCart) {
            this.selectedpaytype.SaveCC = true;
            this.selectedpaytype.ContactId = this.ssosvc.contactid;
            //TO DO: Set the Org Here
            if (this.globaldataops.ORG == "ACEP") {
                this.selectedpaytype.OrgCode = OrgCode.ACEP;
            }
            else if (this.globaldataops.ORG == "EMRA") {
                this.selectedpaytype.OrgCode = OrgCode.EMRA;
            }
            else if (this.globaldataops.ORG == "SEMPA") {
                this.selectedpaytype.OrgCode = OrgCode.SEMPA;
            }
        }
        //Call service to Update payment type
        this.paymentservice.UpdatePaymentMethod(this.selectedpaytype).subscribe((response) => {
            if (this.selectedpaytype.ProfileId == "") {
                //ADDS
                let chaseprofileid = (this.selectedpaytype.ProfileId = response.headers.get("chaseprofileid"));
                let paymentmethodid = (this.selectedpaytype.PaymentMethodId = response.headers.get("paymentmethodid"));
                let billingOptionsUpdated = response.headers.get("billingOptionsUpdated");
                if (this.savedpaymenttypes.length == 0) {
                    this.savedpaymenttypes.push(this.selectedpaytype);
                }
                this.globaldomops.notify("Payment Method Created");
            }
            else {
                //UPDATES
                this.globaldomops.notify("Payment Method Updated");
            }
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = false;
            // this.updatecardexpdate(
            //   this.YYYY,
            //   this.MM,
            //   this.selectedpaytype.ProfileId
            // );
        }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            this.globaldomops.notify("Payment method failed to update", "", "error");
            // this.globaldomops.hidewait();
        }, () => {
            // this.globaldomops.hidewait();
        });
    }
    updateEditUIBasedOnPage() {
        if (!this.isOnShoppingCart && this.savedpaymenttypes.length == 1) {
            this.editpay = false;
        }
    }
    deletePayTypeConfirm(profileid) {
        this.UpdateSelectedPaymentDetails(profileid);
        let deleteconfirmmodal = $("[data-remodal-id=deletePaymentMethod]").remodal();
        deleteconfirmmodal.open();
    }
    deletePayType() {
        this.formsubmitted = true;
        let pid = this.selectedpaytype.ProfileId;
        //Call service to delete payment type
        this.paymentservice.DeletePaymentMethod(this.selectedpaytype).subscribe(response => {
            this.globaldomops.notify("Payment Method deleted");
            this.savedpaymenttypes = this.savedpaymenttypes.filter(function (s) {
                return s.ProfileId != pid;
            });
        }, error => {
            this.ssosvc.CheckAuthorizationOnResponse(error);
            this.globaldomops.notify("Payment method failed to delete", "", "error");
            //  this.globaldomops.hidewait();
        }, () => {
            //  this.globaldomops.hidewait();
        });
    }
    selectPaymentDetails(profileid) {
        this.editpay = profileid == "";
        this.UpdateSelectedPaymentDetails(profileid);
    }
    UpdateSelectedPaymentDetails(profileid) {
        this.formsubmitted = true;
        //RESET Credit Card form if new card
        if (!profileid) {
            this.selectedpaytype = new PaymentDetails();
            this.selectedpaytype.CardType = CardType.ECP;
            this.paymentservice.ResetCreditCardForm();
            //pga: Coding-8830 Call the logic to set save checkbox values as Payment Details are reset
            this.onAutorRenewalChange();
            //Add some valid test data in dev to save time -- MB 2/4/2025
            if (window.location.href.indexOf('localhost') > -1) {
                this.selectedpaytype.NameOnCard = "TEST ACCOUNT";
                this.selectedpaytype.ECPAccountDDA = '0888271156';
                this.selectedpaytype.ECPAccountRT = '122000247';
            }
        }
        else {
            this.selectedpaytype = this.savedpaymenttypes.filter(function (s) {
                return s.ProfileId === profileid;
            })[0];
        }
        this.maskedccnum = this.paymentservice.MaskCreditCardNumber(this.selectedpaytype.CreditCardNumber);
        // if (this.selectedpaytype.CCExpirationDate != "") {
        //   this.MM = moment(this.selectedpaytype.CCExpirationDate).format("M");
        //   this.YYYY = moment(this.selectedpaytype.CCExpirationDate).format("YYYY");
        // } else {
        //   this.MM = this.YYYY = "";
        // }
        // this.updatecardexpdate(this.YYYY, this.MM, this.selectedpaytype.ProfileId);
        this.SHOWCARDHOLDERTYPE = this.isOnShoppingCart
            ? this.paymentservice.paymentuiconfig.SHOWCARDHOLDERTYPE
            : true;
        this.SHOWSAVECC = this.paymentservice.paymentuiconfig.SHOWSAVECC;
        //this.UpdatePaymentInfoInShoppingCart.emit(this.selectedpaytype);
        if (this.allowAddMultipleCards) {
            this.editpay = this.paymentservice.editSavedPaymentTypeInProgress = true;
        }
    }
}
ManageECPComponent.ɵfac = function ManageECPComponent_Factory(t) { return new (t || ManageECPComponent)(ɵngcc0.ɵɵdirectiveInject(PaymentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AcepSSOService)); };
ManageECPComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ManageECPComponent, selectors: [["manage-ecp"]], inputs: { savedpaymenttypes: "savedpaymenttypes", isOnShoppingCart: "isOnShoppingCart", paymentSpecifications: "paymentSpecifications" }, decls: 22, vars: 8, consts: [[1, "f100", "rowview", "ccheaderrow", "clear", 3, "hidden"], [1, "col5", "cardinfoCol"], [1, "col5", "expireCol"], [1, "col5", "editCol"], [1, "col5", "deleteCol"], ["class", "f100 clear", 4, "ngFor", "ngForOf"], ["class", "f100 rowview clear", 4, "ngIf"], [1, "f100", "rowview", "addNewCard", "clear", 3, "hidden"], ["type", "button", "value", "+ Add New Card", 3, "click"], ["data-remodal-id", "deletePaymentMethod", 1, "remodal"], [1, "sprites", "image-ECP"], ["data-remodal-action", "cancel", 1, "remodal-cancel"], ["data-remodal-action", "confirm", 1, "remodal-confirm", 3, "click"], [1, "f100", "clear"], [1, "f100", "rowview", "clear", 3, "hidden"], [1, "col5", "selectCol", 3, "hidden"], ["type", "radio", "name", "SavedPaysECP", 1, "nolabelauty", 3, "value", "id", "ngModel", "ngModelChange"], [3, "for"], [3, "hidden"], [1, "col5", "expireCol", 3, "hidden"], [1, "col5", "editCol", 3, "hidden"], [1, "col5", "deleteCol", 3, "hidden"], [3, "click"], ["id", "ccEditCard", 1, "f100", "editview", 3, "ngClass", "hidden"], [1, "validationwrap"], [1, "fl_wrap"], ["for", "ccName", 1, "fl_label"], ["type", "text", "name", "ccName", "id", "ccName", "maxlength", "30", "required", "required", 1, "fl_input", 3, "ngModel", "ngModelChange"], [1, "validationhead"], [1, "l50"], ["for", "ccRouting", 1, "fl_label"], ["name", "ccRouting", "type", "text", "id", "ccRouting", "pattern", "^\\d{9}$", "maxlength", "9", "data-validate-length-range", "9", "required", "required", 1, "fl_input", "numeric", 3, "ngModel", "ngModelChange"], [1, "r50"], ["for", "ccAccount", 1, "fl_label"], ["name", "ccAccount", "type", "text", "id", "ccAccount", "pattern", "^[0-9]*$", "maxlength", "17", "data-validate-length-range", "17", "required", "required", 1, "fl_input", "numeric", 3, "ngModel", "ngModelChange"], ["id", "saveCC", 1, "checkboxWrap", 3, "hidden"], ["type", "checkbox", "id", "SaveCardECP-Yes", "data-validate", "false", "name", "saveCC", 3, "disabled", "checked", "change"], ["saveCC", ""], ["for", "SaveCardECP-Yes"], [1, "f100", "cartbtns", "clear", 3, "hidden"], [1, "l33"], ["type", "button", "value", "Cancel", 1, "optionbtn", 3, "click"], [1, "r67", "alignright"], ["type", "button", "value", "Save", 1, "appbtn", 3, "click"], [1, "f100", "rowview", "clear"]], template: function ManageECPComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtext(3, " Routing Number ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5, " Account Number ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵtext(7, " Edit ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵtext(9, " Delete ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, ManageECPComponent_div_10_Template, 51, 24, "div", 5);
        ɵngcc0.ɵɵtemplate(11, ManageECPComponent_div_11_Template, 4, 0, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵelementStart(13, "input", 8);
        ɵngcc0.ɵɵlistener("click", function ManageECPComponent_Template_input_click_13_listener() { return ctx.editPayType(""); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 9);
        ɵngcc0.ɵɵelementStart(15, "div");
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelement(17, "span", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "a", 11);
        ɵngcc0.ɵɵtext(19, "NO");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "a", 12);
        ɵngcc0.ɵɵlistener("click", function ManageECPComponent_Template_a_click_20_listener() { return ctx.deletePayType(); });
        ɵngcc0.ɵɵtext(21, "YES");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("ecpCtr ", ctx.isOnShoppingCart ? "shoppingcart-page" : "paymentoptions-page", "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.savedpaymenttypes.length == 1 && ctx.selectedpaytype.ProfileId == "" || ctx.isOnShoppingCart);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.savedpaymenttypes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isOnShoppingCart && (ctx.savedpaymenttypes.length == 1 && ctx.selectedpaytype.ProfileId == "") && !ctx.editpay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.isOnShoppingCart || ctx.editpay && ctx.selectedpaytype.ProfileId == "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("Delete account ending with ", ctx.maskedccnum, " ");
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc4.RadioControlValueAccessor, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.NgClass, ɵngcc4.MaxLengthValidator, ɵngcc4.RequiredValidator, ɵngcc4.PatternValidator], encapsulation: 2 });
ManageECPComponent.ctorParameters = () => [
    { type: PaymentService },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
ManageECPComponent.propDecorators = {
    paymentSpecifications: [{ type: Input }],
    savedpaymenttypes: [{ type: Input, args: ["savedpaymenttypes",] }],
    isOnShoppingCart: [{ type: Input, args: ["isOnShoppingCart",] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ManageECPComponent, [{
        type: Component,
        args: [{
                selector: "manage-ecp",
                template: "<!-- Manage ECP {{selectedpaytype | json}}\r\n************\r\n{{savedpaymenttypes | json}} -->\r\n\r\n\r\n<div class=\"ecpCtr {{ isOnShoppingCart ? 'shoppingcart-page' : 'paymentoptions-page' }}\">\r\n\r\n  <!-- Header Start -->\r\n  <div class=\"f100 rowview ccheaderrow clear\"\r\n    [hidden]=\"(savedpaymenttypes.length == 1 && selectedpaytype.ProfileId == '') || isOnShoppingCart\">\r\n    <div class=\"col5 cardinfoCol\">\r\n      Routing Number\r\n    </div>\r\n    <div class=\"col5 expireCol\">\r\n      Account Number\r\n    </div>\r\n    <div class=\"col5 editCol\">\r\n      Edit\r\n    </div>\r\n    <div class=\"col5 deleteCol\">\r\n      Delete\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Header End -->\r\n\r\n\r\n  <div class=\"f100 clear\" *ngFor=\"let el of savedpaymenttypes; let i = index\">\r\n\r\n    <!-- EL: {{el | json}} {{savedpaymenttypes.length}} {{isOnShoppingCart}} -->\r\n    <!-- row - -->\r\n    <div class=\"f100 rowview clear\" [hidden]=\"(savedpaymenttypes.length == 1 && selectedpaytype.ProfileId == '')\">\r\n      <div class=\"col5 selectCol\" [hidden]=\"!isOnShoppingCart\">\r\n        <input type=\"radio\" class=\"nolabelauty\" name=\"SavedPaysECP\" value=\"{{el.ProfileId}}\" id=\"ProfileECP-{{i}}\"\r\n          [ngModel]=\"selectedpaytype.ProfileId\" (ngModelChange)=\"selectPaymentDetails(el.ProfileId)\">\r\n        <label for=\"ProfileECP-{{i}}\"></label>\r\n      </div>\r\n      <div class=\"col5 cardinfoCol\">\r\n        <span [hidden]=\"el.ProfileId == ''\">\r\n          Account x{{el.CreditCardNumber.length > 4 ?\r\n          el.CreditCardNumber.substring(0,4) :\r\n          el.CreditCardNumber}}\r\n        </span>\r\n        <span [hidden]=\"(el.ProfileId != '' || !isOnShoppingCart)\">\r\n          New Account</span>\r\n      </div>\r\n      <div class=\"col5 expireCol\" [hidden]=\"el.ProfileId == ''\">\r\n        <!-- Exp: {{el.CCExpirationDate ? ( el.CCExpirationDate | date: 'MM/yyyy' ) : ''}} -->\r\n      </div>\r\n      <div class=\"col5 editCol\" [hidden]=\"el.ProfileId == ''\">\r\n        <!-- <a (click)=\"editPayType(el.ProfileId)\">Edit</a> -->\r\n      </div>\r\n      <div class=\"col5 deleteCol\" [hidden]=\"el.ProfileId == ''\">\r\n        <a (click)=\"deletePayTypeConfirm(el.ProfileId)\">Delete</a>\r\n      </div>\r\n    </div>\r\n\r\n\r\n\r\n\r\n\r\n    <div id=\"ccEditCard\" class=\"f100 editview\"\r\n      [ngClass]=\"(i + 1) == savedpaymenttypes.length ? 'ccAddNewCard' : 'notnewcard'\"\r\n      [hidden]=\"!((selectedpaytype.ProfileId == el.ProfileId) && editpay) \">\r\n      <!-- card type-->\r\n      <!-- <div class=\"radioBlock cardType clear\" [hidden]=\"el.ProfileId != '' || SHOWCARDHOLDERTYPE != true\">\r\n\r\n        <input type=\"radio\" name=\"ccECPAccountType\" id=\"PersonalChecking\" value=\"{{ECPAccountType.ConsumerChecking}}\"\r\n          [(ngModel)]=\"selectedpaytype.ECPAccountType\" />\r\n        <label class=\"ccPersonal\" for=\"PersonalChecking\">Personal Checking</label>\r\n\r\n        <input type=\"radio\" name=\"ccECPAccountType\" id=\"PersonalSaving\" value=\"{{ECPAccountType.ConsumerSavings}}\"\r\n          [(ngModel)]=\"selectedpaytype.ECPAccountType\" />\r\n        <label class=\"ccCorporate\" for=\"PersonalSaving\">Personal Saving</label>\r\n\r\n        <input type=\"radio\" name=\"ccECPAccountType\" id=\"CommercialChecking\"\r\n          value=\"{{ECPAccountType.CommercialChecking}}\" [(ngModel)]=\"selectedpaytype.ECPAccountType\" />\r\n        <label class=\"ccPersonal\" for=\"CommercialChecking\">Commercial Checking</label>\r\n\r\n\r\n      </div> -->\r\n      <!-- /card type-->\r\n      <!-- row -->\r\n\r\n      <div class=\"f100 clear\">\r\n\r\n        <div class=\"validationwrap\">\r\n\r\n          <div class=\"fl_wrap\">\r\n            <label class=\"fl_label\" for=\"ccName\">Name on Account</label>\r\n            <input class=\"fl_input\" type=\"text\" name=\"ccName\" id=\"ccName\" maxlength=\"30\"\r\n              [(ngModel)]=\"selectedpaytype.NameOnCard\" required=\"required\" attr.data-validate=\"{{el.ProfileId == ''}}\">\r\n            <span class=\"validationhead\">Required</span>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"f100 clear\">\r\n        <div class=\"l50\">\r\n          <div class=\"validationwrap\">\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"ccRouting\">Routing Number</label>\r\n              <input class=\"fl_input numeric\" name=\"ccRouting\" type=\"text\" id=\"ccRouting\" pattern=\"^\\d{9}$\"\r\n                [(ngModel)]=\"selectedpaytype.ECPAccountRT\" maxlength=\"9\" data-validate-length-range=\"9\"\r\n                required=\"required\" attr.data-validate=\"{{el.ProfileId == ''}}\">\r\n              <span class=\"validationhead\">Please enter a valid Routing Number</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"r50\">\r\n\r\n          <div class=\"validationwrap\">\r\n\r\n            <div class=\"fl_wrap\">\r\n              <label class=\"fl_label\" for=\"ccAccount\">Account Number</label>\r\n              <input class=\"fl_input numeric\" name=\"ccAccount\" type=\"text\" id=\"ccAccount\" pattern=\"^[0-9]*$\"\r\n                [(ngModel)]=\" selectedpaytype.ECPAccountDDA\" maxlength=\"17\" data-validate-length-range=\"17\"\r\n                required=\"required\" attr.data-validate=\"{{el.ProfileId == ''}}\">\r\n              <span class=\"validationhead\">Please enter a valid Account Number</span>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!-- /row -->\r\n\r\n      <!-- <div id=\"updateBO\" class=\"checkboxWrap\" [hidden]=\"isOnShoppingCart\">\r\n                <input #updateBO type=\"checkbox\" id=\"updateBO-Yes\" (change)=\"selectedpaytype.UpdateBillingOptions=updateBO.checked\" [checked]=\"selectedpaytype.UpdateBillingOptions == true\"\r\n                    data-validate=\"false\" name=\"updateBO\" />\r\n                <label for=\"updateBO-Yes\">Update All Billing Options</label>\r\n            </div> -->\r\n\r\n\r\n      <div id=\"saveCC\" class=\"checkboxWrap\"\r\n        [hidden]=\"!(el.ProfileId == '' && SHOWSAVECC == true && !allowAddMultipleCards && isOnShoppingCart)\">\r\n        <input [disabled]=\"disableSaveCC\" #saveCC type=\"checkbox\" id=\"SaveCardECP-Yes\" (change)=\"selectedpaytype.SaveCC=saveCC.checked\"\r\n          [checked]=\"selectedpaytype.SaveCC == true\" data-validate=\"false\" name=\"saveCC\" />\r\n        <label for=\"SaveCardECP-Yes\">Save this account for future use</label>\r\n      </div>\r\n      <div class=\"f100 cartbtns clear\" [hidden]=\"!(el.ProfileId != '' || allowAddMultipleCards)\">\r\n        <div class=\"l33\">\r\n          <input type=\"button\" class=\"optionbtn\" value=\"Cancel\" (click)=\"cancelEditPay()\" />\r\n        </div>\r\n        <div class=\"r67 alignright\">\r\n          <input type=\"button\" class=\"appbtn\" value=\"Save\" (click)=\"savePayType()\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- !(!isOnShoppingCart && el.ProfileId == '' &&  !editpay) -->\r\n\r\n  <div class=\"f100 rowview clear\"\r\n    *ngIf=\"(!isOnShoppingCart && (savedpaymenttypes.length == 1 && selectedpaytype.ProfileId == '') && !editpay)\">\r\n    No Payment Methods Found\r\n    <br />\r\n    <br />\r\n  </div>\r\n\r\n  <div class=\"f100 rowview addNewCard clear\"\r\n    [hidden]=\"isOnShoppingCart || (editpay && selectedpaytype.ProfileId == '')\">\r\n    <input type=\"button\" value=\"+ Add New Card\" (click)=\"editPayType('')\">\r\n  </div>\r\n\r\n\r\n\r\n\r\n\r\n  <!--Delete Payment method modal-->\r\n  <div class=\"remodal\" data-remodal-id=\"deletePaymentMethod\">\r\n    <div>Delete account ending with {{ maskedccnum }}\r\n      <span class=\"sprites image-ECP\"></span>\r\n    </div>\r\n    <a data-remodal-action=\"cancel\" class=\"remodal-cancel\">NO</a>\r\n    <a data-remodal-action=\"confirm\" class=\"remodal-confirm\" (click)=\"deletePayType()\">YES</a>\r\n  </div>\r\n\r\n</div>"
            }]
    }], function () { return [{ type: PaymentService }, { type: ɵngcc2.GlobalDomOpsService }, { type: ɵngcc2.GlobalDataOpsService }, { type: ɵngcc2.AcepSSOService }]; }, { savedpaymenttypes: [{
            type: Input,
            args: ["savedpaymenttypes"]
        }], isOnShoppingCart: [{
            type: Input,
            args: ["isOnShoppingCart"]
        }], paymentSpecifications: [{
            type: Input
        }] }); })();

;
// import * as svc from '../acepglobal/_services'
// import * as factories from '../acepglobal/_factories'
class PaymentModule {
    static forRoot() {
        return {
            ngModule: PaymentModule,
            providers: [
                PaymentService
            ]
        };
    }
}
PaymentModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PaymentModule, bootstrap: function () { return [PaymentComponent]; } });
PaymentModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PaymentModule_Factory(t) { return new (t || PaymentModule)(); }, imports: [[BrowserModule, FormsModule, AcepGlobalModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PaymentModule, { declarations: function () { return [PaymentComponent, ManageCreditCardsComponent, ManageECPComponent, ManageBillingOptionsComponent, TermsAddressComponent, ShippingaddressComponent]; }, imports: function () { return [BrowserModule, FormsModule, AcepGlobalModule]; }, exports: function () { return [PaymentComponent, ManageCreditCardsComponent, ManageECPComponent, ManageBillingOptionsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PaymentModule, [{
        type: NgModule,
        args: [{
                imports: [BrowserModule, FormsModule, AcepGlobalModule],
                declarations: [PaymentComponent, ManageCreditCardsComponent, ManageECPComponent, ManageBillingOptionsComponent, TermsAddressComponent, ShippingaddressComponent],
                bootstrap: [PaymentComponent],
                exports: [PaymentComponent, ManageCreditCardsComponent, ManageECPComponent, ManageBillingOptionsComponent]
            }]
    }], null, null); })();

//Modules

/**
 * Generated bundle index. Do not edit.
 */

export { AccountDetails, BillingOption, CardHolderType, CardType, CustType, ECPAccountType, GPOrgCode, InstallmentType, LineItem, ManageBillingOptionsComponent, ManageCreditCardsComponent, NetTermsAddress, OrderDetails, OrderSource, OrderTypeCode, OrgCode, PaymentComponent, PaymentDetails, PaymentModule, PaymentService, PaymentSummary, PaymentType, PaymentUIConfiguration, ProductSubType, ProductType, ProfileActionType, ShippingAddress, TermsAddressComponent, UIDATA, ManageECPComponent as ɵa, ShippingaddressComponent as ɵb };

//# sourceMappingURL=acepteam-payment.js.map